var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogofamz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1388,
    height: 424,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 12.5 3 L 16 4.5 Q 16.9 7.5 12.5 6 Q 9.5 4.5 12.5 3 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 631.5 6 L 639.5 6 L 640 8 L 634.5 10 L 633.5 8 L 631.5 9 Q 628.5 7.5 631.5 6 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 374.5 8 L 382 8.5 L 381.5 11 Q 380 7.5 378.5 10 Q 373.7 10 374.5 8 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 424 8 L 426 8.5 L 426 10.5 Q 426.8 12.8 424.5 12 L 424 9.5 L 424 8 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 429.5 8 L 430.5 10 Q 427.7 10.7 429.5 8 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 432.5 8 L 433.5 10 Q 430.7 10.7 432.5 8 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480 8 L 491.5 8 L 492 10 L 486 11.5 L 489.5 13 L 491.5 12 L 493.5 13 L 495.5 12 L 496.5 13 L 622.5 13 L 623.5 12 L 633.5 12 L 636 13.5 L 635.5 15 L 637 15.5 L 635 16.5 L 633.5 14 L 632.5 15 L 484 15 L 484.5 13 L 486.5 14 L 485.5 10 L 482.5 9 L 482.5 11 L 480 10 L 480 8 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 493.5 8 L 497 8.5 L 493.5 9 L 493.5 8 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 786.5 8 Q 789.1 7.2 788 10.5 L 789 10.5 L 789.5 9 L 794.5 19 L 796 18.5 L 795 20.5 L 795 22.5 Q 794.5 26.5 797.5 27 L 799 27.5 L 797 29.5 L 798.5 35 Q 800.8 34.3 800 36.5 L 799 38.5 L 800 41 L 803 42.5 L 802.5 44 Q 805.1 44.8 804 41.5 L 805 41.5 L 804 45.5 L 808 48 Q 809.1 50.7 806.5 50 L 804 49 L 806.5 57 L 808.5 53 L 810 53 L 810 58 L 807 58.5 L 808 61.5 L 806 60.5 L 801 45.5 L 801.5 44 Q 798.9 44.8 800 41.5 L 795 29.5 L 795.5 28 Q 792.9 28.8 794 25.5 L 793 23.5 L 794 20.5 L 793 20.5 L 792.5 22 L 790 15 L 785.5 14 L 784.5 15 L 727.5 15 L 726 14.5 L 723.5 21 L 722.5 16 L 720.5 19 L 720 17.5 L 721 15 L 723 14.5 L 722.5 13 L 725.5 14 L 728 12.5 L 727.5 11 L 729.5 12 L 732.5 11 L 737.5 13 L 782.5 13 L 784.5 10 Q 785.8 12.3 787 9.5 L 786.5 8 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 896 8 L 898.5 9 L 899.5 8 L 906 8 Q 907.1 10.7 904.5 10 L 901.5 12 L 901.5 10 L 898.5 12 L 898.5 10 Q 894.8 11 896 8 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 909.5 8 L 913 8.5 L 909.5 9 L 909.5 8 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 964.5 8 L 966 8.5 L 964 9.5 L 968 11.5 L 967 14.5 L 968 15.5 L 966.5 18 L 968.5 17 L 968 18.5 L 967 21.5 L 967 23.5 L 969 26.5 L 971 26.5 Q 967.5 28 970 29.5 Q 969.3 31.8 971.5 31 L 973 30.5 L 972.5 32 L 974 32.5 L 972 33 L 972 36.5 L 978.5 49 L 980 48.5 L 981 53.5 L 979 54 L 962 16.5 L 964.5 18 L 966 16.5 L 964 15.5 L 966 15 L 967 11.5 Q 965 13.2 963 9.5 L 964.5 8 Z M 966 18 L 965 21 L 966 21 L 966 18 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1163.5 8 L 1164 10 L 1166.5 11 L 1168 10.5 Q 1165.8 11.8 1168.5 13 L 1326.5 13 L 1329 12 Q 1327.9 9.3 1330.5 10 L 1333 11 L 1333.5 9 Q 1336.8 10.8 1333 12.5 L 1332.5 15 L 1330.5 15 L 1166.5 15 L 1165.5 14 L 1164 15.5 L 1163.5 56 L 1162 52.5 L 1163 50.5 L 1162 48.5 L 1163 47.5 L 1163 15.5 L 1160 14.5 L 1162 11.5 Q 1159.2 9.8 1163.5 8 Z M 1163 10 L 1163 13 L 1161 14 L 1164 14 L 1164 10 L 1163 10 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1114.5 9 L 1117 9.5 L 1114.5 10 L 1114.5 9 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 427.5 11 L 428.5 13 L 430 12.5 Q 430.8 14.8 428.5 14 L 427.5 11 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 438.5 11 L 439.5 13 L 437.5 13 L 436 12.5 L 438.5 11 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 960.5 11 L 964 12.5 L 962 13.5 L 962.5 12 Q 959.5 12.5 960.5 11 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 12.5 12 L 16.5 13 L 375.5 13 L 376.5 12 L 380.5 14 Q 385.3 12.7 384 16 L 381 17.5 L 381.5 21 L 383 20.5 L 384 23.5 L 382.5 23 L 381 23.5 L 381 367.5 L 383 367.5 L 382.5 372 L 381.5 369 L 381 375.5 L 383 381.5 L 382 381.5 L 381.5 380 L 379.5 385 L 11.5 385 L 8 383.5 L 9 381.5 L 8 376.5 L 10 369.5 L 8 366.5 L 8 33.5 L 9 32.5 L 9 24.5 L 8 20.5 L 9 16.5 L 8 13 L 12.5 12 Z M 11 15 L 11 384 L 380 384 L 380 15 L 11 15 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 910.5 12 L 912.5 13 L 961 13 L 960.5 15 L 903.5 15 L 901.5 15 L 899 14.5 L 902.5 13 Q 908.8 14.8 910.5 12 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1115.5 12 L 1120 13 L 1121 15.5 L 1121 227.5 L 1119.5 230 L 1117.5 230 L 1115.5 229 L 1115 230.5 L 1115.5 232 L 1114 229 L 1103.5 229 L 1102.5 230 L 1073.5 230 L 1070.5 229 Q 1063.5 230.5 1064 227.5 L 1062 224.5 L 1063 223.5 L 1063 111.5 L 1062 109.5 L 1063 107.5 L 1063 105.5 Q 1064.9 100.1 1061.5 101 L 1059 107 L 1061 107.5 L 1060 110.5 Q 1062.3 111.8 1059.5 113 Q 1056.5 113.9 1058 109.5 L 1057 109.5 L 1055.5 113 L 1054 112.5 L 1064.5 89 L 1065 227 L 1117.5 227 L 1118.5 228 L 1120 226.5 L 1120 15 L 1056.5 15 L 1054 16.5 L 1054 18.5 L 1053.5 20 L 1052 16 L 1057.5 13 L 1114.5 13 L 1115.5 12 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 424.5 13 L 427 14.5 L 425 15.5 L 425.5 14 L 424.5 13 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 434.5 13 L 436 15.5 L 435 16.5 L 435 383.5 L 436.5 386 Q 438.3 382.3 440 385.5 L 437 386.5 L 440 387.5 Q 438.7 390.3 437.5 388 Q 435.3 388.8 436 386.5 L 434 386.5 L 435 384.5 L 434 383.5 L 434 16.5 L 434 14.5 L 434.5 13 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 481.5 13 L 482.5 15 L 481 15.5 L 482 16.5 L 482 227 L 537 227 L 537 137 L 627 137 L 627 95.5 L 627.5 92 L 625 91.5 L 627.5 91 L 630.5 95 L 632 94.5 L 630 96.5 L 630 126.5 L 628 137.5 L 628.5 139 L 626.5 138 L 623.5 140 L 622.5 139 L 544.5 139 L 543.5 138 L 542.5 141 Q 540.8 137.3 539 140.5 L 542 142.5 L 540 143.5 L 539.5 142 Q 536.8 143.3 539 144.5 L 539 224.5 L 538 226.5 L 538.5 228 L 537 228.5 L 539.5 230 L 542 229 L 542.5 224 L 544 229 Q 541.3 227.9 542 230.5 L 538.5 235 L 536 233.5 Q 535.1 230.5 539.5 232 L 539.5 231 Q 536.3 227.2 527.5 229 L 526.5 230 L 497.5 230 L 492.5 229 L 490.5 230 L 488.5 230 L 486.5 231 L 481 227.5 L 480 224.5 L 481 223.5 L 481 16.5 L 481 14.5 L 481.5 13 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 437.5 14 L 440 14.5 Q 437.9 17.8 437.5 14 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 896 14 L 898 14.5 L 897 15.5 L 897 224.5 L 896 225.5 L 897.5 227 L 950 227 L 950 96.5 L 951 95.5 L 950 90.5 L 951 90.5 L 962 115.5 Q 959.5 117 963 118.5 L 969 133.5 L 967 134.5 L 966.5 133 L 964 134.5 L 966 131.5 L 966 129.5 L 964.5 127 Q 962.3 127.8 963 125.5 L 962 123.5 L 963 120 Q 960.3 121.1 961 118.5 L 958.5 112 Q 957.3 114.3 956 111.5 L 957 106.5 Q 954 105.3 955 101 L 952 102.5 L 953.5 105 L 951.5 104 L 951 223.5 L 952 228 L 950 228.5 Q 953.8 230.3 950.5 232 L 949.5 229 L 945.5 230 L 943.5 229 L 942.5 230 L 913.5 230 L 912.5 229 L 902.5 229 L 898 230 L 895 224.5 L 896 223.5 L 896 14 Z M 952 96 L 951 100 L 954 100 L 952 96 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1334.5 14 L 1335.5 16 L 1334.5 14 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 429.5 15 L 431 16.5 L 431 383.5 L 429 384.5 L 429 382.5 L 429 17.5 L 430 16.5 L 429.5 15 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1045.5 16 Q 1047.8 15.3 1047 17.5 L 1044 19 L 1045.5 16 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1332.5 16 L 1333 55.5 L 1332 55.5 L 1332.5 16 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0.5 17 L 1 30.5 L 0 30.5 L 0.5 17 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 799.5 17 L 799 18.5 L 800 21.5 L 799 21.5 L 798 18.5 L 799.5 17 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 720.5 21 L 723 22.5 L 719 35 L 716 33.5 L 719 32 Q 718.2 26.2 722 23.5 L 720.5 21 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1042 21 L 1044 21 L 1044 25.5 Q 1047 24.5 1046 29.5 L 1044 28.5 L 1044 26 L 1042 25.5 L 1042 21 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1051 21 L 1053 21.5 L 1032 69 L 1030 68.5 L 1031 65 L 1033 64.5 Q 1031.8 61.8 1030.5 64 L 1029 64 L 1029 60 L 1032 61.5 L 1032.5 63 L 1034 59.5 L 1032 55.5 L 1034 56.5 Q 1031.8 57.8 1034.5 59 L 1038 53.5 L 1037.5 52 L 1039 51.5 L 1039 49.5 L 1040 45 L 1042 44.5 L 1040 44 L 1041.5 41 L 1043 41.5 L 1044 39.5 L 1043.5 38 Q 1046.1 38.8 1045 35.5 L 1043 35.5 L 1045.5 32 Q 1048.1 32.8 1047 29.5 L 1050 25.5 L 1049.5 24 Q 1052.5 24.8 1051 21 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 974.5 26 Q 976.8 26.8 976 30.5 L 974 29.5 L 975 27.5 L 974.5 26 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1040.5 28 L 1042 34.5 L 1040 35.5 L 1040 33.5 L 1040.5 28 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 712 32 L 715 33.5 Q 714.4 38.1 717 39.5 L 715.5 43 L 714.5 40 L 711.5 45 Q 709.3 44.3 710 40.5 L 712 39.5 L 712.5 41 L 714 39.5 L 713.5 37 Q 711.3 37.8 712 35.5 L 714 35.5 Q 714.7 32.9 712 34 L 712 32 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 975.5 36 L 974.5 38 L 975.5 36 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 38 L 321.5 38 L 322 40.5 L 323 40.5 L 324.5 38 Q 328.7 36.7 327 41.5 L 325 42.5 L 326 39 L 324 39.5 L 324.5 41 L 321.5 43 L 320 43.5 L 321 39 L 249.5 39 Q 247.8 41.7 241.5 40 L 239 42.5 L 240 44.5 L 239.5 47 L 236 46 L 238 41.5 Q 235.8 40.3 238.5 39 Q 243.2 40.2 244.5 38 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 704.5 40 L 705 43.5 L 704 43.5 L 704.5 40 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 807.5 40 L 807 41.5 L 806.5 44 L 806 41.5 L 807.5 40 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 41 L 236 41.5 Q 236.8 43.8 234.5 43 L 233.5 41 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 42 L 231 42.5 L 228 44 L 229 48 L 223.5 46 L 218 49.5 L 218.5 51 Q 220 48.5 221.5 52 L 224 50.5 L 223 53.5 L 224 56 L 219.5 54 L 218 54.5 L 219 52.5 L 215.5 51 L 212 53.5 Q 212.8 56.1 209.5 55 L 204 63 L 200 65.5 L 197 69.5 L 197.5 71 L 196 71.5 L 198.5 73 L 200 72.5 Q 200.8 76.3 198.5 77 L 195.5 72 L 195 74.5 L 197 77.5 L 194 78 L 193.5 80 L 191 79.5 L 191 78 Q 194.8 79.5 194 76.5 L 194.5 75 L 193 74.5 Q 199.2 62.2 209.5 54 L 229.5 42 Z M 226 45 L 227 47 L 228 47 L 226 45 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256 44 L 318.5 44 L 319 46 L 256.5 46 L 256 44 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 323.5 44 L 322 46.5 L 321.5 82 L 321 46.5 L 323.5 44 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 713 44 Q 715.7 42.9 715 45.5 L 700.5 83 L 699.5 81 L 698 81.5 L 698.5 79 L 701 78.5 L 700 76.5 Q 702.3 75.3 699.5 74 L 698 73.5 L 699.5 73 L 703 73.5 L 705 66.5 L 704.5 65 L 706 65.5 L 704 62.5 L 707 63.5 L 708 60.5 L 707.5 59 Q 709.8 59.8 709 57.5 Q 711.8 54.5 711 49 Q 708.3 47.9 709 50.5 L 708.5 53 L 707 53.5 Q 709.3 54.8 706.5 56 L 705 53 L 707 52.5 L 705 48.5 L 706 46 Q 709 44.8 708 48.5 L 709.5 48 L 711.5 49 Q 714 47.8 713 44 Z M 707 48 Q 705 51 708 50 L 707 48 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 46 L 234 47.5 L 231.5 48 L 230.5 46 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 814 46 Q 817 45 816 48 Q 813 49 814 46 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 637.5 47 L 638 52 L 636 52.5 L 638 56 L 640 56.5 L 638.5 59 L 640 59.5 L 638.5 60 L 636 59 L 635 52.5 L 637.5 47 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 986 48 Q 989 46.8 988 50.5 Q 990.7 51.3 990 55.5 L 988 54.5 L 988 51.5 L 986 48 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1032.5 48 L 1034.5 49 Q 1035.8 46.8 1037 49.5 L 1035 49.5 Q 1035.8 52.1 1032.5 51 L 1032.5 48 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1336.5 48 L 1338 50.5 L 1338 52.5 L 1339 56.5 L 1337 57.5 L 1336.5 56 L 1334.5 59 L 1335 57.5 L 1336.5 48 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341 48 Q 1345.1 46.7 1344 50 L 1341.5 51 L 1341 48 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 981.5 49 L 983 51.5 L 982 51.5 L 981.5 49 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1155.5 49 Q 1158.3 50.3 1156 51.5 Q 1156.8 54.1 1153.5 53 L 1152.5 51 L 1155.5 49 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 983.5 53 Q 981.7 55.2 986 57.5 L 983.5 63 L 980 55 L 983.5 53 Z M 983 55 L 982 59 L 983 59 L 983 55 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1026.5 54 L 1027 56.5 L 1026 56.5 L 1026.5 54 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1340.5 54 L 1341 57.5 L 1340 57.5 L 1340.5 54 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 56 L 214.5 56 Q 216.8 55.3 216 57.5 L 212 59 L 212.5 56 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1154 56 Q 1157 54.8 1156 58.5 L 1154 57.5 L 1154 56 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 537.5 57 L 539.5 57 Q 544.1 55.6 542 61.5 Q 544.3 62.8 541.5 64 L 540 64 Q 541.5 60.3 538.5 61 L 539 62.5 L 539 88.5 L 541.5 89 L 541.5 90 L 539 90.5 L 541.5 92 L 543.5 89 L 544 92 L 622.5 92 L 626 94.5 L 538.5 95 L 537 93.5 L 537.5 57 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 57 L 634 57.5 L 627.5 59 L 626 58.5 Q 627 62.3 624 61 L 623.5 58 L 545.5 58 L 545.5 57 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1160.5 57 L 1161 59.5 L 1160.5 61 L 1158.5 58 L 1160.5 57 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1167.5 57 L 1255 57.5 L 1253 58 Q 1254.3 61 1250.5 60 L 1248.5 58 L 1167.5 58 L 1167.5 57 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1260.5 57 L 1263 57.5 L 1247.5 77 Q 1245.3 76.3 1246 78.5 L 1241 86 L 1239 85.5 L 1239 83.5 Q 1239.8 81.3 1237.5 82 L 1236 82.5 Q 1234.8 78.8 1238.5 80 Q 1239.6 82.8 1243 82 L 1242 78.5 L 1243 78.5 L 1243.5 80 L 1244 77.5 Q 1241.3 75.8 1245.5 74 Q 1247 76.5 1248.5 73 L 1250 72.5 L 1249.5 71 L 1253 68.5 L 1254 64 L 1258 61.5 L 1256 58.5 L 1257.5 59 L 1260.5 57 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1331.5 57 Q 1333.8 56.3 1333 58.5 L 1328 65 L 1325 64.5 L 1331.5 57 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207 60 Q 211.1 58.7 210 62 L 207 62.5 L 208 65.5 L 207 65.5 Q 208.1 62.2 205.5 63 L 205.5 62 Q 208.1 62.7 207 60 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1335.5 60 L 1336 62.5 Q 1336.8 65.1 1333.5 64 L 1333.5 63 L 1335 62.5 Q 1332.8 61.3 1335.5 60 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1163.5 61 L 1165.5 62 L 1167.5 61 L 1167.5 62 L 1165.5 63 L 1163.5 61 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 62 L 623 62.5 L 545.5 63 L 545.5 62 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 626.5 62 L 630 62.5 L 626.5 63 L 626.5 62 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1024.5 62 L 1025 65.5 L 1024 65.5 L 1024.5 62 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1154.5 62 L 1155 64 L 1153 63.5 L 1154.5 62 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1160.5 62 Q 1162.8 61.3 1162 63.5 L 1160.5 62 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1169.5 62 L 1247 62.5 L 1169.5 63 L 1169.5 62 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 633.5 63 L 636 63.5 L 633.5 64 L 633.5 63 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 808.5 63 L 809 65.5 L 808 65.5 L 808.5 63 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 812.5 64 Q 815.1 63.2 814 66.5 L 812 67.5 L 813 65.5 L 812.5 64 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 984 64 Q 987 62.8 986 66.5 L 986.5 68 Q 984.3 68.8 985 66.5 L 984 64 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 990.5 64 Q 993.1 63.2 992 66.5 L 989.5 68 L 989.5 67 Q 991.8 67.8 991 65.5 L 990.5 64 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1246 64 L 1250 64 L 1250 65.5 L 1252 65.5 L 1251.5 68 Q 1250.3 65 1246 66 L 1246 64 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1026.5 65 L 1027 67 L 1029 67.5 L 1028 72.5 L 1030 72.5 L 1026.5 78 L 1027 76.5 L 1028 73.5 L 1025.5 73 L 1024 73.5 Q 1027.5 72 1025 70.5 L 1025.5 69 L 1027 69.5 L 1026.5 65 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1324.5 66 Q 1327.8 64.9 1327 67.5 L 1325 67.5 L 1326 69.5 L 1324.5 69 L 1323 69.5 L 1324 73.5 L 1322 74.5 L 1321.5 71 L 1318 75.5 L 1320 78.5 L 1318.5 78 L 1316.5 77 L 1310.5 86 L 1309 85.5 L 1308.5 87 L 1308 85.5 L 1324.5 66 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 67 L 206 70 Q 203.3 68.9 204 71.5 L 203 71.5 L 205.5 67 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 809.5 67 Q 812.5 66.1 811 70.5 L 814 75.5 L 813.5 77 L 816 78.5 L 814.5 82 L 809.5 67 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 986.5 69 L 989 73.5 L 987 72.5 L 986.5 69 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 692 70 Q 695.8 69.3 697 72.5 L 696.5 75 Q 695.3 72.8 694 75.5 L 692.5 79 L 691 76.5 L 692 70 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1242.5 72 L 1243.5 74 L 1242.5 72 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 756 73 Q 759 71.8 758 75.5 Q 754.9 77.3 756.5 79 Q 753.5 78.1 755 82.5 L 753 83.5 L 756 73 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 989 75 Q 991.7 73.9 991 76.5 L 993 80.5 L 997 89.5 L 995 90 L 989 75 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1240.5 75 L 1241.5 77 L 1240.5 75 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 758.5 77 L 762 85.5 L 759 86.5 L 758.5 88 L 757 84.5 Q 760.8 82.8 757.5 81 L 756 80.5 L 757.5 80 L 759 80.5 L 758.5 77 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1025 79 L 1027 79.5 L 1024 87 L 1022 86.5 L 1025 79 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 694.5 80 Q 697.8 81.2 697 85 L 699.5 84 L 700 85.5 L 694.5 98 L 693 97.5 L 695 95.5 L 698 86.5 L 696 86 Q 697.3 81.9 694 83 L 694.5 80 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 997.5 80 L 999.5 83 Q 997.3 83.8 998 81.5 L 996 81.5 L 997.5 80 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1018.5 80 L 1022 80.5 Q 1018.5 82 1021 83.5 Q 1021.8 85.8 1019.5 85 L 1018.5 82 L 1017 81.5 L 1018.5 80 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 82 L 192 86.5 L 191 86.5 Q 191.7 83.9 189 85 L 188.5 87 L 188 84.5 L 189.5 82 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1008.5 82 L 1009.5 84 Q 1006.7 84.7 1008.5 82 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 815.5 83 L 820 93.5 L 818 92.5 L 815.5 83 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1232 83 Q 1236.5 81.5 1235 86 L 1232.5 87 L 1232 83 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 84 L 250 84.5 L 245.5 86 L 243.5 85 L 241.5 86 L 240.5 84 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 998.5 84 L 1000 86.5 L 999 86.5 L 998.5 84 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 752 85 L 754 85.5 L 753.5 88 Q 750.9 87.2 752 90.5 L 750 97 L 753.5 96 L 752.5 98 L 748 99.5 L 752 102.5 L 751.5 105 L 750 102 L 747 102 L 747 107 L 745.5 107 L 746 105.5 L 752 85 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1005.5 86 L 1006 88.5 L 1005 88.5 L 1005.5 86 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1237.5 86 Q 1240.3 87.3 1238 88.5 L 1235.5 92 Q 1233.3 91.3 1234 93.5 L 1230.5 98 Q 1227.9 98.7 1229 96 L 1232 94.5 L 1232 92 L 1234 92 Q 1232.9 89.3 1235.5 90 L 1235.5 88 Q 1238 88.7 1237.5 86 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233 88 Q 236 87 235 90 Q 232 91 233 88 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 88 L 235 93.5 L 232.5 99 L 232 92 L 236 92 Q 234.3 87.9 238.5 89 L 239.5 88 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 625.5 88 L 629 88.5 Q 627.8 91.3 626.5 89 L 625.5 88 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 822.5 88 Q 825 89 824 93.5 L 824 95.5 L 822 100.5 L 823 103.5 L 822 103.5 L 819 95.5 L 822 93.5 L 823 89.5 L 822.5 88 Z M 821 95 L 821 97 L 823 96 L 821 95 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 828 88 L 830 88.5 L 830 95 Q 827 96.3 828 92.5 L 828 90.5 L 828 88 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1016.5 88 L 1018 92.5 L 1017 94.5 L 1019 95.5 L 1020 91.5 Q 1017.2 89.8 1021.5 88 L 1023 88.5 L 1014 109 L 1012 109.5 L 1013 111.5 L 1008.5 119 L 1009 117.5 L 1008.5 116 L 1007 116.5 L 1002 104 Q 1005.7 105.3 1004 99.5 L 1005.5 97 L 1006 98.5 Q 1003.5 100 1007 101.5 L 1006 103.5 L 1006 105.5 L 1007.5 109 L 1009 108.5 L 1010 112 Q 1007.3 113.1 1008 110.5 L 1006 109.5 L 1007 114 Q 1009.7 112.9 1009 115.5 L 1010 115.5 L 1012 111.5 L 1011 109.5 L 1011.5 107 Q 1014.1 107.7 1013 105 L 1009.5 107 L 1011.5 104 Q 1015.9 105.5 1015 102.5 L 1017 97.5 L 1015.5 94 L 1014 94 L 1014 90 Q 1016.8 91 1016.5 88 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1306.5 88 L 1306 89.5 L 1304 93.5 L 1306 93.5 L 1305.5 96 L 1303 94.5 Q 1303.7 97.1 1301 96 L 1301 98.5 L 1295 103.5 L 1296 107 L 1301 104.5 L 1299 103.5 L 1300.5 103 Q 1301.7 105.3 1303 102.5 L 1302 99.5 Q 1303.3 96.8 1304.5 99 Q 1307.5 98.2 1306 102 L 1302 104 L 1302 107.5 L 1298.5 109 L 1294 108 L 1293.5 106 L 1290 112 L 1287 113.5 L 1286 115.5 L 1286.5 117 Q 1284.8 114.3 1283 118.5 Q 1283.8 120.8 1281.5 120 L 1277 126.5 L 1279 129.5 L 1278 129.5 L 1276.5 127 Q 1273.9 128.4 1274.5 133 L 1274 131 L 1271 132.5 L 1268 137.5 L 1270.5 139 L 1272 138.5 L 1271.5 143 L 1269 141.5 L 1270 143.5 L 1268.5 143 L 1263 144.5 L 1263.5 146 L 1261.5 146 L 1260 146 Q 1261.5 149.8 1258.5 149 L 1250.5 160 L 1248 161.5 L 1246.5 165 L 1242 168.5 L 1242 171 L 1240 171 Q 1241.1 173.7 1238.5 173 L 1239.5 175 Q 1241.8 175.8 1241 173.5 L 1243.5 172 L 1245 173.5 L 1243.5 176 L 1246.5 174 L 1245 176.5 Q 1245.7 179.5 1242 178 L 1241.5 175 L 1239.5 176 Q 1237.7 173.2 1236 177.5 L 1235 181 L 1232 182.5 Q 1232.8 184.8 1230.5 184 L 1230.5 185 L 1337 185.5 L 1228 186 L 1233.5 178 Q 1236.1 178.8 1235 175.5 L 1264.5 140 L 1264 141.5 Q 1263.3 144.1 1266 143 L 1267 140.5 L 1266 137.5 L 1306.5 88 Z M 1268 138 L 1267 140 L 1269 141 L 1268 138 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1310.5 88 L 1309.5 90 L 1310.5 88 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 754 89 Q 758.1 87.3 757 91.5 L 754 93 L 754 89 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 763.5 90 L 765 93.5 Q 762.5 95 766 96.5 L 770 107.5 L 768 108 L 767 103 Q 763.3 104.3 765 98.5 L 763 94.5 L 763.5 90 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 996.5 91 L 998.5 92 L 1000 91.5 Q 996.5 93 999 94.5 Q 998 98.3 1001 97 L 1001 100.5 L 1000 100.5 L 996.5 91 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1007 91 Q 1010.7 89.7 1009 95.5 L 1010.5 98 L 1008.5 97 L 1007 97.5 L 1007 91 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1309.5 91 L 1312 92.5 L 1310.5 96 L 1309 95.5 L 1311 95 Q 1312.5 91.3 1309.5 92 L 1309.5 91 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 760.5 92 Q 763.5 93.5 760.5 95 L 760.5 92 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1001.5 92 L 1003 96 L 1000 94.5 L 1001.5 92 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 93 L 190 96 L 187 96.5 L 189 97 L 187.5 101 L 186 96.5 L 188.5 93 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 688.5 97 Q 690.3 100.1 692 98.5 L 690.5 100 L 688.5 97 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1226.5 98 L 1229 99.5 L 1224.5 105 L 1225 103.5 L 1224 100.5 L 1226.5 98 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 693 99 L 695 99.5 L 693.5 102 L 693 99 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 100 L 190 102.5 L 188.5 105 L 188 103.5 L 189.5 100 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 760.5 100 L 761 101.5 Q 756.8 104.3 756.5 111 L 756 104.5 L 760 102 L 760.5 100 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1220 100 Q 1223 99 1222 102 Q 1219.3 100.9 1220 103.5 L 1219 103.5 L 1220 100 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 692.5 104 L 692 105.5 Q 691 114 686.5 119 L 686 116.5 L 688 114.5 L 689 109.5 L 688.5 108 Q 689.8 110.3 691 107.5 L 692.5 104 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 825.5 104 L 826 108.5 L 829 120 Q 831.7 121.1 831 118.5 L 832 118.5 L 831 120.5 L 832 122.5 L 832 124.5 L 833 130.5 L 832 130.5 L 831 124.5 L 829 122.5 Q 831.5 121 828 119.5 L 823 105.5 L 825.5 104 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1216.5 105 L 1219.5 107 L 1219.5 105 L 1222.5 107 L 1224 106.5 L 1221 108 L 1220 111.5 L 1183 158 Q 1180.3 156.9 1181 159.5 L 1171.5 171 L 1174 167.5 L 1173.5 165 Q 1170.9 165.8 1172 162.5 L 1173 160.5 L 1171.5 161 L 1170 160.5 L 1172.5 156 L 1174 160 L 1176 160.5 L 1175 163 L 1173 163.5 L 1175.5 165 L 1177 161 Q 1180 162.3 1179 158.5 L 1180 156 L 1184 154.5 L 1185.5 152 Q 1188.1 152.7 1187 150 L 1184.5 151 L 1185 149.5 Q 1183.9 145.3 1188 147 L 1188.5 149 L 1190 146.5 L 1189 144 Q 1192.8 144.8 1194 141.5 L 1193 139.5 L 1194.5 140 L 1196 139.5 L 1193.5 136 L 1195 136.5 Q 1194.2 133.9 1197.5 135 Q 1199.3 137.8 1201 133.5 Q 1199.9 130.2 1202.5 131 L 1203.5 128 Q 1205.3 130.8 1207 126.5 L 1206 123 L 1210 122.5 L 1207 122 L 1208 117 Q 1210.7 118.1 1210 115.5 L 1214 112.5 L 1213 114.5 L 1214.5 117 L 1216 113.5 L 1215.5 112 L 1217.5 112 Q 1220.1 112.7 1219 110 Q 1216.3 111.1 1217 108.5 L 1216.5 105 Z M 1211 118 L 1211 120 L 1213 119 L 1211 118 Z M 1210 119 L 1208 121 L 1211 121 L 1210 119 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 106 Q 231.3 110.3 234 111.5 Q 232.8 114.3 231.5 112 L 229 110.5 Q 228.5 106.5 231.5 106 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 827.5 106 L 831 108.5 L 830.5 110 L 829.5 108 L 827.5 111 L 828 109.5 L 827.5 106 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 954.5 106 L 955 107.5 L 953 110.5 L 954 113 L 952 112.5 L 952 110.5 Q 950.5 106.1 953.5 107 L 954.5 106 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 107 L 190 108.5 L 192 115 Q 189 116.3 190 112.5 L 189 108.5 L 190.5 107 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 748.5 107 L 749.5 109 L 750.5 107 L 751 108.5 Q 747.5 110 750 111.5 L 749.5 114 L 748 111 Q 744.6 110.3 743.5 113 L 743 111.5 L 744 108 L 748 109 L 748.5 107 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1308.5 108 L 1309 110 Q 1306.3 108.9 1307 111.5 L 1306 111.5 L 1308.5 108 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 762 109 L 765 110.5 Q 765.7 113.5 762 112 L 762 109 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 769.5 109 L 775 124 L 773 123.5 L 773 121.5 L 772.5 119 L 771 119.5 L 770 116.5 L 771 113.5 L 769.5 109 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1292.5 110 L 1294 110.5 L 1293 112.5 L 1295 112.5 L 1290.5 117 L 1288 116.5 L 1292 114 L 1291 111.5 L 1292.5 110 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 829.5 111 L 832 114.5 L 831.5 117 Q 828.8 115.8 831 114.5 L 829.5 111 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 674.5 112 L 675 116.5 L 674 116.5 L 674.5 112 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 680 112 Q 683.8 110.5 683 113.5 L 684 114.5 L 681 117.5 L 682 119.5 L 680 120 L 681 114.5 L 680 112 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 114 L 235 119.5 L 232 124 L 230 123.5 L 231 120 L 233 119.5 L 231.5 114 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 114 L 239 120 Q 241.7 118.9 241 121.5 L 247 126.5 L 243 128 L 244 125.5 L 240 122.5 L 238.5 120 Q 235.9 120.8 237 117.5 L 235.5 115 L 237.5 114 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 742.5 114 L 743 117.5 L 741 118.5 L 742.5 114 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1054.5 114 Q 1058.2 116.2 1053 118.5 L 1054 122.5 L 1053 122.5 L 1052.5 121 L 1051 124.5 L 1051.5 126 L 1050 126.5 L 1050.5 128 Q 1048.3 127.3 1049 129.5 L 1046.5 133 L 1046 131.5 L 1054.5 114 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1204.5 115 L 1203.5 117 L 1204.5 115 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 116 Q 193.8 119.8 194 126.5 L 196 128.5 Q 195.4 133.9 197 136 L 200 136.5 L 199 140 L 203 142.5 Q 200.5 144 204 145.5 L 203.5 148 L 193 129.5 Q 193.7 122.3 190 119.5 L 190.5 116 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 746.5 117 L 748 119.5 L 746.5 122 L 746.5 117 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1202.5 118 L 1202 119.5 Q 1203 123.3 1200 122 Q 1198.5 118.3 1201.5 119 L 1202.5 118 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1287.5 118 L 1290 118.5 L 1286.5 120 L 1287.5 118 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1295.5 119 L 1296 122 Q 1293 120.8 1294 124.5 L 1291.5 126 Q 1288.5 124.5 1291.5 123 L 1294 121.5 L 1295.5 119 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 120 L 197 122.5 L 196 122.5 L 196.5 120 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 685 120 L 687 120.5 L 683.5 129 L 682 124.5 L 684 124.5 L 685 120 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 740 120 L 742 120.5 L 739.5 125 L 739 123.5 L 740 120 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 768 122 L 770 122.5 L 768 123.5 L 768 122 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 123 Q 239 124.2 238 128 Q 233.9 129.2 236.5 123 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1283.5 123 L 1286 123.5 Q 1283.9 126.8 1283.5 123 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 741.5 124 L 744 124.5 Q 744.8 126.8 742.5 126 L 742.5 127 L 744 127.5 L 741 128.5 L 743 129.5 L 741 130.5 L 743 131.5 Q 741.8 134.3 740.5 132 L 738 132.5 L 740 133 L 741 135.5 L 738 135.5 L 737.5 133 L 735 138.5 L 736 140.5 Q 733.8 141.8 736.5 143 L 768.5 143 Q 767.9 140.3 771 141 L 772.5 144 L 777 143 L 776 140.5 L 777.5 141 L 780 139.5 L 776 137.5 L 778.5 137 Q 780.8 136.3 780 138.5 L 781 141.5 L 780.5 143 Q 783.1 142.3 782 145 L 732.5 145 L 732 143 L 734 142.5 L 733 140.5 L 738.5 126 L 739.5 129 L 740.5 126 L 742 125.5 L 741.5 124 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 125 Q 232.5 124.2 231 128 Q 227.2 129.5 228 126.5 L 229.5 125 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 768.5 125 Q 771.5 124.2 770 128 L 768 127.5 L 768.5 125 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 774.5 125 Q 777.1 124.2 776 127.5 L 779 135.5 L 776 135.5 L 777 133.5 L 776 128 L 773.5 127 L 772 127.5 L 774.5 125 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 961.5 126 L 961 127.5 L 960.5 129 L 960 127.5 L 961.5 126 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1055.5 126 L 1056 128 L 1054 127.5 L 1055.5 126 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 127 L 250.5 128 L 301 128.5 L 299 129.5 L 303.5 131 L 303.5 129 L 305.5 129 L 309 130.5 L 303 134.5 L 302.5 136 L 302 134 L 299 133.5 L 304 132.5 L 298.5 131 L 296.5 132 L 296.5 131 Q 299.1 131.7 298 129 L 250.5 129 L 249.5 127 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 681.5 127 Q 679.9 128.8 683 130.5 L 682 131.5 L 681.5 135 L 680 130.5 L 681.5 127 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 128 L 162 128.5 Q 160.8 131.3 159.5 129 L 104.5 129 L 102 130.5 L 102.5 132 L 98.5 134 L 94 134 Q 95.1 136.7 92.5 136 L 96 131.5 Q 95.3 129.3 97.5 130 L 103.5 128 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 128 Q 170 127 171 130.5 L 178 144.5 L 176 145 Q 177.5 141.2 174.5 142 Q 170.3 140.3 173 138.5 L 171 132 L 169 132.5 L 169.5 136 L 168 133 Q 165 134.3 166 130.5 L 164.5 128 Z M 168 130 L 168 132 L 170 131 L 168 130 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 632 128 Q 635 127 634 130 Q 631 131 632 128 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 677.5 128 L 678 131 Q 675.3 132.1 676 129.5 L 677.5 128 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 834.5 128 Q 837.8 126.9 837 129.5 L 835 133 L 833 132.5 L 835 129.5 L 834.5 128 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1184 128 L 1186 128.5 L 1184 129.5 L 1184 128 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1050 130 Q 1053.7 128.8 1052 134 Q 1049 132.8 1050 136.5 L 1047 138.5 L 1050 133.5 L 1050 130 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 131 L 94 131.5 L 86 135.5 L 90 137.5 L 86.5 138 L 83.5 136 L 74 141 L 74.5 143 L 76.5 143 Q 79.8 144.1 79 141.5 L 78.5 140 L 80 144 L 73.5 144 L 72.5 143 L 70 144 L 66.5 149 Q 62.5 148.5 62 151.5 Q 62.8 153.8 60.5 153 L 69.5 143 L 73 142 Q 71.9 139.3 74.5 140 L 91.5 131 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 131 L 319 133.5 L 316.5 134 L 312.5 132 L 312.5 131 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1187.5 131 Q 1191.3 129.8 1190 133.5 L 1186 135 Q 1187.3 139.1 1184 138 L 1184 135.5 L 1187.5 131 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1278.5 131 Q 1280.8 130.3 1280 132.5 L 1278 132.5 L 1279 134.5 L 1277 133.5 L 1278.5 131 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 639.5 132 L 640 135 Q 637.3 136.1 638 133.5 L 639.5 132 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 772.5 132 L 774 135.5 L 772 134.5 L 772.5 132 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 842.5 132 L 843 135.5 L 842 135.5 L 842.5 132 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 133 L 298 135.5 L 296 134.5 L 297.5 133 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 305.5 134 L 309 134.5 L 305.5 135 L 305.5 134 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 134 L 333 140 Q 331.9 142.7 334.5 142 L 338 144 L 339.5 150 L 340.5 147 Q 350.2 155.3 356 167.5 L 352 166.5 L 351 160 L 348 160 L 348 156 Q 345.3 157.1 346 154.5 L 345 152 L 342.5 151 L 338 152 L 337 145.5 L 334.5 143 L 330.5 144 L 329.5 142 Q 332.1 142.7 331 140 L 328.5 139 L 326 140.5 L 326.5 142 Q 320.4 140.8 321 143.5 L 320 143.5 L 322.5 140 Q 327.3 141.3 326 138 Q 321.1 137.2 320.5 134 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 834.5 134 L 836.5 137 L 839.5 135 L 840 136.5 L 840 138.5 L 838 141.5 L 840 142.5 L 839 146.5 L 841 152 Q 843.7 150.9 843 153.5 L 844 155.5 L 843 157.5 L 845 157.5 L 844.5 160 Q 842.3 160.8 843 158.5 L 836 141.5 L 834.5 134 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1053.5 134 L 1054 137.5 L 1052 136.5 L 1053.5 134 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 313.5 135 L 319 136 Q 320.3 139.3 315.5 138 L 310.5 139 L 310.5 138 L 314 136.5 L 313.5 135 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 969.5 135 L 977 152.5 L 976 152.5 L 974.5 150 Q 972.3 150.8 973 148.5 L 971 142.5 L 971 140.5 Q 971.8 138.3 969.5 139 L 969 136.5 L 969.5 135 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 136 Q 112.8 135.3 112 137.5 L 109.5 139 L 108.5 137 L 110.5 136 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 632.5 136 L 634 140 L 630 139.5 L 632 139 L 632.5 136 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 675.5 136 L 679 141.5 L 676 142 Q 677.1 144.7 674.5 144 L 672.5 145 L 672.5 144 Q 675.3 144.6 674 138.5 L 675.5 136 Z M 676 139 Q 674 142 677 141 L 676 139 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 680.5 136 L 681 137.5 L 679.5 140 L 679 137.5 L 680.5 136 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1044.5 136 L 1045 138.5 L 1043 139.5 L 1044.5 136 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 138 Q 165.5 139.5 162.5 141 L 162.5 138 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 138 L 170 139.5 L 169 141.5 L 170.5 141 L 173 142.5 L 169 144 L 168 139.5 L 169.5 138 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1276 139 Q 1279.3 137.9 1278 142 L 1273.5 144 L 1274.5 142 Q 1277.5 142.7 1276 139 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1046.5 140 L 1048 140.5 L 1047.5 143 L 1045 141.5 L 1046.5 140 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 845.5 141 L 847 143.5 L 844 144 L 845.5 141 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1042.5 141 L 1044 143.5 L 1041.5 144 L 1042 142.5 L 1042.5 141 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 627.5 142 L 630 143.5 L 628.5 144 L 626 143.5 L 627.5 142 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 966 142 Q 969 141 968 144 Q 965 145 966 142 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 677.5 143 L 678 145.5 L 675.5 147 L 675.5 146 Q 678.4 146.7 677.5 143 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1046.5 144 L 1047.5 146 Q 1045.3 145.3 1046 147.5 L 1048 147.5 L 1044.5 152 L 1043 151.5 L 1046 149.5 Q 1046.7 146.9 1044 148 L 1044 150 Q 1041.3 148.9 1042 151.5 L 1039 152.5 L 1036 159 L 1040 159.5 L 1039.5 162 L 1037.5 161 L 1035 162 L 1034.5 164 Q 1031.8 162.8 1034 161.5 L 1040 146 L 1043.5 145 L 1040.5 150 L 1046 145.5 L 1046.5 144 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1169.5 144 Q 1172.1 143.3 1171 146 L 1168 145.5 L 1169.5 144 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 964.5 145 L 969 153.5 L 965.5 155 L 964 153.5 L 963 146.5 L 964.5 145 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176 146 Q 179.7 144.5 179 147.5 L 183 154.5 L 181 155 L 179 149 L 176 147.5 L 176 146 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 147 L 76 152 Q 71.9 153.7 73 149.5 L 75.5 147 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1178.5 147 Q 1183 146 1184 148.5 Q 1182.3 146.9 1180.5 150 L 1177 148.5 L 1178.5 147 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1260.5 150 L 1263 150.5 L 1262 153 Q 1258.5 154.1 1260.5 150 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 151 Q 208.6 153.8 212 153 Q 210.5 156.8 213.5 156 L 215 155.5 L 214.5 159 L 209 154.5 L 207.5 151 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214 152 L 216 152.5 L 214 153.5 L 214 152 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 673 152 Q 675.7 150.9 675 153.5 L 672.5 158 L 672 154.5 L 673 152 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 845.5 152 L 848 152.5 Q 845.9 155.8 845.5 152 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 153 L 68 155.5 Q 68.9 158.5 64.5 157 Q 63.3 159.3 62 156.5 L 64 156 L 63.5 153 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 153 L 178 154.5 L 177.5 156 L 176.5 154 L 178.5 153 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 154 Q 61.1 153.3 60 156 L 56.5 158 L 57 156.5 L 58.5 154 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 977.5 154 L 988 178 L 1026.5 178 L 1027 176.5 L 1032.5 165 L 1033 167.5 L 1032 170.5 L 1032.5 173 L 1034 170 Q 1036.7 168.9 1036 171.5 Q 1033.3 172.6 1034 176 Q 1031.3 177.1 1032 174.5 L 1030 174.5 L 1031 172.5 L 1029 173.5 L 1028 177.5 L 1030 178 Q 1031.3 181.3 1026.5 180 L 1026.5 181 L 1030.5 182 L 1032 181.5 L 1031.5 184 L 1028.5 183 L 1027 183.5 L 1027.5 182 L 1025.5 183 L 1024.5 181 L 1023 181.5 L 1024 179 L 991.5 179 L 989.5 180 L 987.5 179 L 986 179.5 L 984 176.5 L 982.5 167 L 981 167.5 Q 982.1 164.2 979.5 165 L 980 163.5 L 980 161 Q 977.3 162.1 978 159.5 L 977 159.5 L 976.5 163 L 976 159.5 L 976.5 157 L 978 157.5 L 977.5 154 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1262 154 Q 1265.3 152.9 1264 157 Q 1260.7 158.1 1262 154 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1258.5 155 L 1260 159 Q 1255.9 160.7 1257 156.5 L 1258.5 155 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 156 L 185 157.5 L 193 169.5 L 191 170 L 190.5 168 L 189 171.5 L 189.5 173 Q 186.5 173.9 188 169.5 L 189 166.5 L 185 163.5 L 186 161.5 L 185 159 L 182 160.5 Q 182.7 163.1 180 162 L 179 158.5 L 180.5 159 L 182 158.5 Q 179.8 157.3 182.5 156 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 156 L 345.5 158 L 344.5 156 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70 158 Q 73 157 72 160 Q 69 161 70 158 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 341.5 158 Q 343.8 157.3 343 159.5 L 341.5 158 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 159 L 54.5 161 L 55.5 159 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 671.5 159 L 672 161.5 L 669.5 167 L 668 161.5 L 671 160.5 L 671.5 159 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 160 L 220 160.5 Q 217.9 163.8 217.5 160 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 844.5 161 L 845.5 163 L 846 161 L 848 161.5 L 847.5 164 L 846 163.5 L 847 169 L 849.5 168 L 851.5 169 L 854 168 L 853.5 170 L 852 169.5 Q 851.3 171.8 853.5 171 L 853 172.5 L 851 177 Q 848 178 849 175 L 852 173.5 L 849.5 170 L 848.5 174 L 844.5 161 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 162 L 57 164 L 55.5 168 L 55 164 L 52.5 165 L 52 163.5 L 53.5 162 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 163 L 231 164.5 L 228 165 L 228.5 163 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 665 163 L 667 163.5 L 665.5 166 L 665 163 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178 164 Q 181.7 162.8 180 168 L 182.5 168 L 182 169.5 L 183 172.5 L 178.5 173 L 178.5 172 Q 181.5 172.9 180 168.5 Q 177.3 167.4 178 164 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1168.5 164 L 1172 166.5 L 1170 166.5 L 1169.5 168 L 1168.5 164 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 165 L 227 166.5 L 225.5 166 L 224.5 165 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 166 L 64 168 L 62 167.5 L 63.5 166 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1036.5 166 L 1037.5 168 L 1036.5 166 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 167 L 51 168.5 L 50 170.5 L 52 171.5 Q 51.3 169.3 53.5 170 L 55.5 169 L 54 171.5 L 55 173.5 L 52.5 172 L 51.5 173 Q 49.3 172.3 50 174.5 L 50.5 176 Q 49.3 173.8 48 176.5 L 47 181.5 L 47 183.5 L 46.5 187 L 46 184 L 44 183.5 L 46 182.5 L 45 179.5 L 50.5 167 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 167 L 231 168.5 L 229.5 169 L 228.5 167 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 667.5 167 L 669 169.5 L 665.5 178 L 662 176 Q 663.1 178.7 660.5 178 L 662 175.5 Q 660.7 170.7 664 172 L 664.5 176 L 666 174.5 L 667.5 167 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 168 L 239.5 169 L 241 168.5 Q 241.8 171.1 238.5 170 L 237.5 168 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 168 L 294 168.5 L 291.5 169 L 291.5 168 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1246.5 168 L 1248 171.5 Q 1248.8 173.8 1246.5 173 L 1244 169.5 L 1246 169.5 L 1246.5 168 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 169 Q 112.3 168.3 114 170.5 L 112.5 171 L 107.5 170 L 107.5 169 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 169 L 355 171.5 L 353 171.5 L 354 173.5 L 352 172.5 L 353.5 169 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1039.5 169 L 1040 172.5 L 1038 171.5 L 1039.5 169 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 170 L 120 170 L 120.5 172 L 174.5 172 L 174.5 173 L 109 172.5 L 119 171.5 L 117.5 170 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 170 Q 295.6 168.9 298 171.5 L 296 172.5 Q 296.5 169.5 289.5 171 L 289.5 170 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 171 L 199 177.5 L 197.5 178 L 193.5 176 L 189 174.5 L 194 174 L 193.5 171 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 357.5 171 L 360 178.5 L 358 178.5 Q 359 182.3 356 181 L 355 173 Q 357.8 174 357.5 171 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 172 L 247 172.5 L 244.5 174 L 241.5 173 L 241.5 172 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255 172 L 288 172.5 L 256.5 173 L 255.5 174 L 255 172 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 290.5 172 Q 295.5 171 294.5 174 L 299.5 174 L 299.5 175 L 293.5 175 L 293 173 L 290.5 173 L 290.5 172 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 301.5 172 Q 304.8 170.9 304 173.5 L 302.5 173 L 301.5 172 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1168 172 L 1171 172.5 L 1159.5 186 L 1160 184.5 L 1162 181.5 L 1161.5 180 L 1163 180.5 L 1164 178.5 L 1163 176.5 L 1164 176.5 L 1164.5 178 L 1165 176 L 1168 174.5 L 1168 172 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 173 L 59 176 L 55 175.5 L 57.5 173 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 854 173 L 856 173.5 L 855 176 Q 859.5 174.3 858 179.5 L 856.5 179 L 853 176.5 L 854 173 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104 174 L 109 174.5 L 104 176 L 104 174 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 176 L 309.5 180 L 312 180 L 313 182.5 L 311 183 Q 312.1 180.3 309.5 181 L 303.5 177 L 303.5 176 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 178 L 99 178.5 L 94 182 L 90 192.5 L 90 206.5 L 92 212.5 L 90 212.5 Q 88.4 220.6 92 223.5 L 89 222.5 L 88.5 224 L 88 222.5 Q 90.8 220.8 89 214.5 L 89 212.5 L 90 207.5 L 89 206.5 L 88 194.5 L 89 188 Q 92.3 189.3 91 184.5 L 96 178 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 976 178 L 980 179.5 Q 981.2 184.1 976 182 L 976 178 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 664.5 179 L 665 180.5 L 659.5 194 L 659 189.5 L 661 186.5 L 657 188.5 L 656 186.5 L 657.5 187 L 660 185.5 Q 659.3 182.5 663 184 L 663 180.5 L 664.5 179 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 852.5 179 L 853.5 182 L 856 180.5 L 853 185 L 855.5 184 L 856 185.5 L 856 187.5 L 854.5 190 L 851 180.5 L 852.5 179 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 180 Q 362.8 181.8 362 186.5 L 360 190.5 L 359.5 194 L 358 188 L 361 186.5 L 360.5 180 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1243.5 180 L 1245 180 L 1245 184 L 1240 183.5 L 1243.5 180 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1339 180 L 1344 180 L 1344 183 L 1339 182 L 1339 180 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 858.5 181 Q 860.8 180.3 860 182.5 L 862 188 Q 859 189.3 860 185.5 L 858.5 181 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 988.5 182 L 987.5 184 L 988.5 182 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1155 182 L 1158 183.5 L 1157.5 186 Q 1155.8 182.9 1154 184.5 L 1155 182 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 184 L 319 188.5 L 318 188.5 L 318.5 184 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 984.5 184 L 987 185.5 L 982.5 189 L 980.5 189 L 977.5 190 L 976.5 188 L 979.5 187 L 980.5 188 L 984.5 184 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 718 185 L 784 185.5 L 719.5 186 L 718 187.5 Q 717.3 189.8 719.5 189 L 720.5 190 L 784.5 190 L 784 188.5 Q 783.2 185.5 787 187 L 784.5 191 L 720.5 191 L 717 192 L 718 194.5 Q 715.7 195.8 718.5 197 L 720 196.5 L 717 198.5 L 718 202 Q 715.3 200.9 716 203.5 L 716.5 205 L 713.5 207 L 711 210.5 L 714 212.5 Q 715.5 216.9 712.5 216 L 710 217 L 710.5 219 L 712 218.5 L 711 221.5 Q 713.3 222.8 710.5 224 L 710.5 222 Q 708.3 222.8 709 220.5 L 709 218.5 L 708.5 217 L 707 217.5 L 712.5 202 L 713 205 L 715 204.5 L 714 201.5 L 713 199.5 L 718 185 Z M 709 214 L 709 217 L 711 216 Q 712 213 709 214 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 789.5 185 Q 796.5 183.5 796 186.5 L 804 207.5 L 801 206.5 L 800.5 208 L 800 204.5 L 800 202.5 L 798.5 199 Q 797.3 201.3 796 198.5 Q 797.1 195.2 794.5 196 L 794 193.5 L 793.5 191 L 792.5 193 L 791 188 L 794 188.5 Q 791.5 190 795 191.5 L 795.5 193 L 796 188.5 L 794.5 186 L 792.5 186 Q 788.5 186.8 789.5 185 Z M 797 196 L 798 199 L 799 197 L 797 196 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 186 Q 317.5 185.1 316 189.5 Q 318.7 191.2 317 197.5 L 316 199.5 L 317 202.5 L 316 202.5 L 315.5 201 L 312 203.5 Q 317.4 200.4 316 190.5 L 314.5 186 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1152 186 L 1155 186.5 L 1153 187 L 1152.5 190 L 1152 186 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1338.5 186 L 1340 188.5 L 1339 191.5 L 1339 224.5 L 1340 226.5 L 1338.5 229 L 1337 228.5 Q 1337.8 230.8 1335.5 230 L 1334.5 233 L 1329 234 Q 1327.9 230.7 1332 232 L 1332 229 L 1326.5 230 L 1169.5 230 L 1168.5 229 L 1157 229 L 1157.5 227 L 1337.5 227 L 1338 226.5 L 1338.5 186 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1342.5 187 Q 1345.5 188.5 1342.5 190 L 1341 189.5 L 1343 188.5 L 1342.5 187 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1158.5 188 L 1159 225.5 L 1157 224.5 L 1157 192.5 L 1155.5 191 L 1154 191.5 Q 1153.2 188.9 1156.5 190 L 1158.5 188 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 656.5 190 Q 659.3 191.3 657 192.5 L 659 196.5 L 654 207.5 L 654 210.5 L 648 227 L 703.5 227 L 704 225.5 L 705 225.5 Q 704.3 227.8 706.5 227 L 705.5 229 L 704 228.5 L 705 230.5 L 700.5 229 L 698.5 230 L 695.5 229 L 687.5 229 L 686.5 230 L 657.5 230 L 655.5 230 L 653.5 229 L 650.5 230 L 647 227.5 L 646 224.5 L 649 219.5 L 648 217.5 Q 651.5 216 649 214.5 L 649.5 212 L 650.5 215 L 652 212.5 L 648 211 L 649 208.5 L 648.5 207 L 650.5 208 L 652 207.5 L 651 209.5 L 653 210 L 652.5 205 L 651 205.5 L 650 201 L 648 200.5 L 649.5 200 L 651 204 L 653.5 205 L 655 201.5 L 653 201.5 L 657 199.5 L 658 195.5 L 656 195.5 L 656 193.5 L 657 191.5 L 656.5 190 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1023.5 190 Q 1027.3 189 1026 192 L 992 191.5 L 1022.5 191 L 1023.5 190 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 855.5 191 L 859.5 193 L 863 192.5 L 862.5 194 L 864 194.5 L 861 196.5 L 862 194 L 858 195.5 L 859 198 Q 856.3 199.1 857 196.5 L 855.5 191 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1342.5 193 L 1343 222.5 L 1342 222.5 L 1342.5 193 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 194 L 48 197.5 L 47 197.5 L 47.5 194 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 195 L 359 203.5 L 357.5 210 Q 354.7 207.3 356 200.5 L 357 200.5 L 357.5 203 L 358.5 195 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 863.5 197 L 864 198.5 L 862 199.5 L 863.5 197 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 858.5 199 L 859 201 L 862 201.5 L 860 202.5 L 862.5 204 L 863.5 201 L 864 203.5 L 861 205.5 L 864 210.5 L 865.5 217 L 867 216.5 L 867 218.5 L 868 220.5 L 866 221.5 L 858.5 199 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 203 L 354 205.5 L 353 205.5 L 353.5 203 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 648.5 203 L 650 205.5 L 648 204.5 L 648.5 203 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 310.5 204 L 311 206 Q 314 205 313 208 L 309 209.5 L 309.5 213 L 308 213.5 L 308.5 215 Q 306.3 210.8 304 215.5 L 303 217.5 Q 305.3 218.8 302.5 220 L 301 219.5 L 303 218.5 L 300.5 218 L 295.5 219 L 295.5 218 Q 304.5 217 308 210.5 L 310.5 204 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314 208 Q 317 206.8 316 210.5 L 314 209.5 L 314 208 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 208 L 354 210.5 L 353 210.5 L 353.5 208 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 866 208 Q 869.3 206.9 868 211 Q 864.7 212.1 866 208 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 873 208 Q 877.1 206.3 876 210.5 L 873 212 L 873 208 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 804.5 210 L 806 214.5 L 805 214.5 Q 805.8 212.3 803.5 213 L 801 214.5 L 802 218.5 L 800 219.5 L 801 217.5 L 800 214.5 L 801.5 211 Q 803 213.5 804.5 210 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 879.5 212 L 880 217.5 L 879 217.5 L 878 213.5 L 879.5 212 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 213 L 354.5 217 L 355.5 215 L 356 216.5 L 355 220 Q 352.3 221.1 353 218.5 L 352 216.5 L 353.5 213 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 870.5 215 Q 873.9 214.1 872 219.5 L 873 223 Q 870.3 224.1 871 221.5 L 870 218.5 L 869.5 217 L 868 217.5 L 870.5 215 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 645.5 216 L 646 218 L 644 217.5 L 645.5 216 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 217 L 310.5 219 L 308 218.5 L 309.5 217 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 806.5 217 L 810 227 L 867.5 227 L 868 225.5 L 867.5 224 Q 870.5 223.1 869 227.5 L 867.5 231 L 866.5 229 L 864.5 230 L 862.5 230 L 817.5 230 L 815.5 228 L 813 228.5 L 812.5 230 L 809 228 L 806.5 224 Q 803.9 224.8 805 221.5 L 807 221.5 L 806.5 217 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 218 L 95 222 L 92 220.5 L 92.5 218 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 218 L 222 218.5 L 220 219.5 L 222 220.5 L 220.5 221 L 218.5 219 L 95.5 219 L 95.5 218 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 219 L 287.5 219 L 294.5 221 Q 295.7 218.8 297 221.5 L 288.5 222 L 286.5 220 L 224.5 220 L 224.5 219 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 220 Q 221 222 217.5 224 L 216.5 221 L 215.5 222 L 112.5 222 L 112.5 221 L 215.5 221 L 216.5 220 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 706.5 220 Q 709.6 221.4 709 226.5 L 708 226.5 L 707.5 223 L 705 224 L 706.5 220 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 221 L 110 221.5 L 104.5 222 L 104.5 221 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 301.5 221 L 304 221.5 L 301.5 222 L 301.5 221 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 224 L 346 229.5 L 345 229.5 L 345.5 224 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348 225 L 351 226.5 L 344 240 L 342 240 Q 343.1 242.7 340.5 242 L 335 246 L 333.5 250 L 319.5 259 L 318 258.5 Q 318.7 261.1 316 260 L 316 256 L 322.5 256 L 323 254.5 L 322 251 L 320 250.5 Q 321.5 247.5 323 250.5 L 324 254 L 328 252.5 L 326 251.5 L 327.5 251 L 329.5 251 L 331 250.5 L 328 249.5 L 332.5 248 L 334 248.5 L 335.5 245 L 340 241.5 Q 339.3 239.3 341.5 240 L 341.5 238 L 345 235.5 Q 344.5 231 348 230.5 L 348 225 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 958 226 Q 961.3 224.9 960 229 L 957.5 230 L 957 228.5 L 958 226 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1056.5 226 L 1058 230 Q 1054.2 231.2 1056.5 226 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1152.5 226 L 1154.5 229 L 1152 228 L 1152.5 226 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1343.5 226 L 1344 227.5 L 1343.5 232 L 1341.5 231 L 1339.5 232 L 1339.5 231 L 1341 230.5 L 1340.5 229 L 1342.5 230 L 1343 227.5 L 1343.5 226 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 802.5 227 L 804 230 L 801.5 231 L 800 228 L 802.5 227 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 640 228 Q 643 227 642 230 Q 639 231 640 228 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 709 228 L 711 228.5 L 707.5 231 L 707.5 230 Q 710.1 230.7 709 228 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1065 230 L 1069 230.5 L 1066 231.5 L 1069 232 Q 1070.3 235 1066.5 234 L 1065 230 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1156.5 230 L 1160 230.5 L 1154.5 232 L 1154.5 231 L 1156.5 230 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 653 231 Q 657.5 229.5 656 234 L 653 232.5 L 653 231 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 947 231 L 949 231.5 L 946.5 236 Q 942.3 237.1 944 233 Q 948.1 234.3 947 231 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1166.5 231 L 1168 235 L 1165 233.5 L 1166.5 231 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 528 232 Q 531 231 530 234 Q 527 235 528 232 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 878 232 Q 881.3 230.9 880 235 Q 876.7 236.1 878 232 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 905.5 232 Q 907.8 231.3 907 233.5 L 904 237.5 L 904 240 Q 901.3 241.1 902 238.5 L 905.5 232 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480 233 Q 482.7 231.9 482 234.5 L 480 235.5 L 480 233 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 896 233 Q 898.7 231.9 898 234.5 L 896 235.5 L 896 233 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 911.5 233 L 912 237.5 L 910 236.5 L 911.5 233 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 958.5 234 Q 961.5 235.5 958.5 237 Q 956.3 237.8 957 235.5 L 958.5 234 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 495.5 236 L 496 239.5 L 495 239.5 L 494 237.5 L 495.5 236 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 487.5 237 Q 490.5 236.2 489 240 Q 485.2 241.5 486 238.5 L 487.5 237 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 800.5 237 L 802 240 Q 798.5 241.1 800.5 237 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 807 237 Q 810.3 235.9 809 240 Q 805.7 241.1 807 237 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 533.5 238 L 534 240 L 532 239.5 L 533.5 238 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 543.5 238 L 544 240 L 542 239.5 L 543.5 238 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 649.5 238 Q 653.3 237 652 240 L 648 239.5 L 649.5 238 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 814 238 Q 817 237 816 240 Q 813 241 814 238 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1070.5 238 Q 1073.1 237.3 1072 240 L 1069 239.5 L 1070.5 238 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1152 238 Q 1155 237 1154 240 Q 1151 241 1152 238 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1336 238 Q 1341.2 236.3 1340 240 Q 1334.8 241.7 1336 238 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 496.5 248 L 499.5 250 L 502.5 248 L 506 250 L 505.5 252 Q 504.2 249.8 503 252.5 L 503.5 254 L 501 252.5 L 504 250.5 L 501.5 249 L 501.5 251 L 500 250.5 L 498.5 254 Q 495.2 255.1 496 252.5 L 497.5 253 Q 499.8 253.8 499 251.5 L 496 250.5 L 496.5 248 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 509.5 248 L 511.5 249 L 515.5 248 L 515.5 249 L 510.5 251 L 510.5 249 L 507.5 250 L 507.5 249 L 509.5 248 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 618.5 248 L 620.5 249 L 622.5 248 L 622.5 249 L 614.5 254 L 614 252 L 610.5 251 L 609 251.5 L 612 249.5 L 611.5 251 L 614.5 250 L 614.5 252 L 618 250.5 L 616 249.5 L 618.5 248 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 626 248 L 630 248.5 L 626.5 250 L 626 248 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 671.5 248 L 673 248.5 L 670.5 250 L 671.5 248 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 675.5 248 L 676.5 250 L 674 249.5 L 675.5 248 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 248 L 790 248.5 L 787.5 249 L 787.5 248 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 889 248 L 891 248.5 L 890 250.5 L 892 250.5 L 891 252.5 L 893 253.5 L 894.5 250 L 894 251.5 L 895 255.5 L 893.5 255 Q 890.2 256.1 891 253.5 L 889 248 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 996.5 248 L 999 248.5 L 996.5 249 L 996.5 248 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1048.5 248 L 1051 249.5 L 1051.5 251 L 1055 250 L 1055.5 248 L 1057 251.5 L 1055.5 251 L 1054 251.5 L 1055 254.5 L 1053.5 256 Q 1051.8 253.3 1050 257.5 L 1049.5 259 L 1049 257.5 Q 1053 255.5 1049 253.5 L 1048 251.5 L 1049 249.5 L 1048.5 248 Z M 1051 251 L 1050 254 Q 1054 255 1053 252 L 1051 251 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1060 248 L 1062 248.5 L 1061 251 L 1059 250.5 L 1060 248 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1073.5 248 L 1079 248.5 L 1073.5 249 L 1073.5 248 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1100.5 248 L 1104 248.5 L 1100.5 249 L 1100.5 248 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1109 248 L 1113 248.5 L 1112 249.5 L 1113.5 252 Q 1111.3 247.8 1109 249.5 L 1109 248 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1119.5 248 L 1119 249.5 L 1120 253.5 Q 1118 257 1116 252.5 L 1117.5 253 L 1119 252.5 L 1118 249.5 L 1119.5 248 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1161.5 248 L 1166 250.5 L 1165.5 252 L 1167 252.5 L 1165 253 L 1164.5 255 L 1163.5 253 L 1162.5 256 Q 1159.3 254.3 1163 252.5 L 1161.5 248 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1168.5 248 L 1172.5 249 L 1174.5 248 L 1174.5 249 L 1169 251.5 L 1168.5 253 L 1168 251.5 L 1169.5 249 L 1168.5 248 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1176.5 248 Q 1179.8 246.9 1179 249.5 L 1177.5 249 L 1176.5 248 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1223.5 248 L 1225 249.5 L 1224.5 252 L 1220 249.5 L 1223.5 248 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1229.5 248 L 1232 248.5 L 1230.5 251 L 1229.5 248 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1276.5 248 L 1279.5 249 L 1282.5 248 L 1285 249.5 Q 1284.3 247.3 1286.5 248 L 1286.5 251 L 1283.5 250 L 1279.5 253 L 1281 250.5 L 1280.5 249 L 1277.5 251 L 1277.5 250 L 1279 249.5 L 1276.5 249 L 1275 250.5 L 1276 253.5 L 1275.5 255 L 1272 253.5 L 1275 251.5 L 1273.5 251 L 1272 251.5 L 1272.5 249 L 1276.5 248 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1063 249 L 1067 249.5 L 1063.5 251 L 1063 249 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1227.5 249 L 1230.5 253 L 1232 253.5 L 1230.5 254 Q 1229 250.5 1227.5 253 L 1226 252.5 L 1228 252 L 1227.5 249 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 566.5 250 Q 569 251.2 568 255 L 565 254.5 L 567 254 L 566.5 252 L 565 252.5 L 566.5 250 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 990.5 250 L 993 250.5 L 992 252.5 Q 994.3 253.8 991.5 255 L 989 254.5 L 991 254 L 990.5 252 L 989 252.5 L 990.5 250 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 995.5 250 L 995 251.5 L 994.5 253 L 994 251.5 L 995.5 250 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1030.5 250 L 1031 251.5 L 1029.5 254 L 1029 252.5 L 1030.5 250 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1340.5 250 L 1342.5 251 L 1344 250.5 Q 1342.8 253.3 1341.5 251 L 1340.5 250 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 670.5 251 Q 676.6 249.8 676 252.5 L 676.5 254 Q 673.9 254.7 675 252 L 670.5 252 L 670.5 251 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 611 253 L 613 253.5 L 611.5 256 L 611 253 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1031.5 253 L 1032 254.5 L 1030 255.5 L 1031.5 253 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341.5 253 L 1343 255.5 L 1340 255.5 L 1341.5 253 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 498.5 255 L 500 255.5 L 498 256 L 497.5 258 L 497 256.5 L 498.5 255 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 609.5 255 L 609 256.5 L 602.5 264 L 601.5 262 L 600 262.5 L 602.5 261 Q 604.2 263.8 606 259.5 L 605 257.5 L 606.5 258 Q 608.8 258.8 608 256.5 L 609.5 255 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1272.5 255 L 1273 257.5 L 1271.5 257 L 1269 256.5 L 1272.5 255 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 491.5 256 L 493.5 258 L 496 256.5 Q 496.8 258.8 494.5 258 L 494.5 260 Q 491.9 259.2 493 262.5 Q 491.5 265.5 490 262.5 L 490 260.5 L 489.5 259 L 488.5 262 L 488 259.5 L 491.5 256 Z M 492 257 L 490 259 L 491 261 L 493 260 L 492 257 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 566.5 256 L 567 281.5 L 568 282.5 L 565 283.5 L 563 286.5 L 562 286.5 L 563 283 L 565 282.5 Q 562.5 281 566 279.5 L 566.5 256 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 603.5 256 L 604 257.5 L 603.5 260 L 602 257.5 L 603.5 256 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 685.5 256 L 685 257.5 L 683.5 260 L 683.5 257 L 685.5 256 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 891.5 256 L 892 279.5 L 893 280.5 Q 890.8 281.8 893.5 283 L 896 283.5 L 892 284 L 890 280.5 L 891 279.5 L 891.5 256 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 990.5 256 L 991 281.5 L 992 282.5 L 989 283.5 L 987 286.5 L 986 286.5 L 987 283 L 989 282.5 Q 986.5 281 990 279.5 L 990.5 256 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1125.5 256 L 1128.5 257 L 1130 256.5 L 1130 258.5 L 1130.5 261 L 1131 259 L 1133 259.5 Q 1129.5 261 1132 262.5 L 1133 265.5 L 1131 264.5 L 1129.5 262 L 1128 262.5 L 1128.5 261 Q 1123.5 261.5 1123 257.5 L 1127 259.5 Q 1128.1 256.2 1125.5 257 L 1125.5 256 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1135.5 256 L 1134.5 258 L 1133 257.5 L 1135.5 256 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1153.5 256 L 1156 256.5 L 1157 258.5 L 1155 259.5 L 1154.5 258 L 1152.5 262 L 1153.5 256 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1237.5 256 L 1237.5 259 Q 1234.5 257.5 1237.5 256 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1265.5 256 L 1268 257 L 1270 260.5 L 1267 261.5 L 1266.5 264 L 1264 263.5 L 1267 259.5 L 1264 260.5 L 1266 257.5 L 1264 257.5 L 1265.5 256 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1040.5 257 L 1043.5 259 L 1045 258.5 Q 1043.8 261.3 1042.5 259 L 1040.5 257 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 313.5 258 L 314 261 L 308.5 263 L 304 260.5 L 306.5 260 L 308.5 260 L 311.5 261 L 313.5 258 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 686.5 258 L 688 261.5 L 687 261.5 L 686.5 258 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1135.5 260 L 1136 261.5 L 1135.5 266 L 1134 264.5 L 1135 261.5 L 1135.5 260 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1157 260 L 1159 260.5 L 1157 261.5 L 1157 260 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1042.5 261 L 1043 265.5 L 1041 266.5 L 1042 264.5 L 1042 262.5 L 1042.5 261 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1155.5 261 L 1154.5 263 L 1155.5 261 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341 262 Q 1344 261 1343 264 Q 1340 265 1341 262 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 488.5 263 L 489 265.5 L 486 269.5 L 486 271.5 L 485.5 273 L 485 269.5 L 488 265.5 Q 485.7 264.3 488.5 263 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 264 L 91.5 265 L 96.5 264 L 96.5 265 L 91 266 L 89.5 272 L 88 268.5 L 89.5 264 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 264 L 189 264.5 L 179.5 265 L 179.5 264 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 264 L 295 264.5 L 221.5 265 L 221.5 264 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 481 264 L 483 264.5 L 482 266.5 L 484 270.5 L 483 270.5 Q 480.2 268.5 481 264 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 485.5 264 L 486 265.5 L 484 266.5 L 485.5 264 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 593.5 264 L 596 264.5 L 594.5 267 L 593.5 265 L 592.5 267 L 592 265.5 L 593.5 264 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 693.5 264 L 694.5 266 L 695.5 264 L 696 265.5 L 695.5 268 L 693 267.5 L 693 265.5 L 693.5 264 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1144 264 L 1147.5 265 L 1149 264.5 L 1147.5 271 L 1146.5 269 L 1144 274.5 L 1146 274.5 L 1146 276.5 L 1146.5 278 L 1147.5 276 L 1148 277.5 Q 1144.5 279 1147 280.5 L 1146.5 282 L 1145.5 280 L 1143.5 281 L 1143.5 280 L 1146 278.5 L 1143.5 275 L 1142.5 277 L 1141.5 275 L 1140 278 L 1137 276.5 L 1140 276 L 1139 272.5 L 1140.5 273 L 1142.5 272 L 1144 272.5 L 1145 268 L 1147 267.5 L 1144 266 L 1144 264 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1150.5 264 L 1151.5 266 L 1153.5 265 L 1153.5 266 L 1151 267.5 L 1151.5 269 L 1149 267.5 L 1150.5 264 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1244.5 264 L 1245 265.5 L 1243 266.5 L 1244.5 264 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1257.5 264 L 1260 264.5 L 1256.5 266 L 1257.5 264 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1035.5 265 L 1037 265.5 L 1035 266 Q 1036.1 268.7 1033.5 268 L 1035.5 265 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1261.5 265 L 1262 267 L 1264 267.5 L 1262.5 268 L 1261.5 265 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 597.5 266 Q 600.8 267.8 597 269.5 L 595 272.5 L 595.5 274 Q 592.3 272.3 596 270.5 L 598 267.5 L 597.5 266 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 691.5 266 L 692 269 L 694 269.5 L 692.5 270 Q 688 268 691.5 266 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1038.5 267 L 1039.5 269 L 1037 268.5 L 1038.5 267 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1247.5 267 L 1248 269.5 L 1247.5 271 L 1246 268.5 L 1247.5 267 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1259.5 267 L 1260 268.5 L 1259 271 Q 1261.7 269.9 1261 272.5 L 1259 273.5 Q 1261.3 272.3 1258.5 271 L 1257 271.5 L 1259.5 267 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 593.5 268 L 594.5 270 L 593.5 268 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1135.5 268 L 1135 269.5 L 1138 274.5 L 1135 272.5 L 1134 269.5 L 1135.5 268 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480.5 269 L 481.5 271 L 480.5 269 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1035.5 269 L 1038 272.5 L 1035 274 L 1032.5 278 L 1033 276.5 L 1032 273.5 L 1033.5 274 L 1035 274 L 1035.5 269 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341 270 Q 1344 269 1343 272 Q 1340 273 1341 270 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480.5 272 L 483 275.5 L 482 277.5 L 482.5 279 L 480 278 L 481 274.5 L 480.5 272 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 482.5 272 Q 484.8 271.3 484 273.5 L 484.5 275 L 482.5 272 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1149.5 272 L 1147.5 275 L 1147 273 L 1149.5 272 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1250.5 272 L 1255 275.5 Q 1254.3 273.3 1256.5 274 L 1255 276.5 Q 1255.8 280.3 1253.5 281 L 1254 279.5 L 1252 274 L 1249 273.5 L 1250.5 272 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 274 L 91 279.5 L 90 280.5 L 89.5 351 L 89.5 274 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 592.5 274 L 593.5 276 L 595 275.5 Q 595.8 277.8 593.5 277 L 592.5 274 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1248.5 275 L 1252 277.5 L 1250.5 283 L 1250 281.5 L 1251 278.5 L 1248.5 275 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1036.5 276 L 1037 278 L 1033.5 280 L 1036.5 276 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1256.5 277 L 1259 278.5 L 1257.5 279 L 1256.5 277 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 592.5 278 L 593 280.5 L 592 280.5 L 592.5 278 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1141.5 278 L 1140 280.5 L 1141 281.5 L 1140.5 285 L 1139.5 282 L 1138 282.5 L 1139 280.5 L 1138.5 279 L 1141.5 278 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341 278 Q 1343.7 276.9 1343 279.5 L 1341 283.5 L 1342.5 285 L 1344 285.5 L 1341 286 L 1340.5 284 L 1340 287 L 1342 287.5 L 1340.5 288 L 1338.5 287 L 1337 287.5 Q 1336.3 285.3 1338.5 286 L 1338.5 285 L 1335.5 286 L 1304.5 286 L 1304.5 285 L 1335.5 285 L 1340 284 L 1341 278 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480.5 279 Q 483.5 280.5 480.5 282 L 480.5 279 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 697.5 280 L 698 282.5 L 697.5 286 L 696 281.5 L 697.5 280 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 699.5 280 L 702 280 L 702 286.5 L 701 286.5 Q 701.6 281 699.5 280 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1257.5 280 L 1258 281.5 L 1254 286.5 L 1254.5 288 L 1252 282 L 1254 282.5 L 1253 284.5 L 1255 283.5 L 1255.5 281 L 1257 281.5 L 1257.5 280 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 525.5 281 L 527 281.5 L 523.5 283 L 523.5 282 L 525.5 281 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 560.5 281 L 563 281.5 L 561 286 L 528.5 286 L 525.5 287 L 525.5 286 L 528 285.5 L 523 284.5 L 527.5 284 L 528.5 285 L 560 285 L 561 282.5 L 560.5 281 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 635 281 L 638 281.5 L 631.5 285 L 632.5 283 Q 636.3 284 635 281 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 984.5 281 L 987 281.5 L 985 286 L 960.5 286 L 959.5 285 L 958 285.5 L 959 283.5 L 958.5 282 L 960 285 L 983.5 285 L 984 283.5 L 984.5 281 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1034.5 281 L 1035 287.5 L 1034 287.5 L 1032 282.5 L 1033 282.5 L 1033.5 285 L 1034.5 281 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1098.5 281 Q 1101.8 279.9 1101 282.5 L 1099.5 282 L 1098.5 281 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1187.5 281 L 1189 281.5 Q 1188.5 284.5 1184.5 284 L 1182 282.5 L 1183.5 282 L 1185.5 283 L 1187.5 281 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1209 281 L 1213 282.5 L 1210 283.5 L 1211 285.5 L 1210.5 288 L 1207.5 286 L 1192 285.5 L 1207.5 285 L 1210 286 L 1209 281 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1299 281 L 1302 281.5 L 1295 285.5 L 1297.5 286 L 1302.5 285 L 1302.5 286 Q 1296.4 285.4 1293.5 288 L 1294 286.5 L 1295 284.5 L 1294.5 283 L 1296.5 283 Q 1300.3 284 1299 281 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 629.5 282 L 629 283.5 L 628.5 285 L 628 283.5 L 629.5 282 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 659.5 282 Q 662.5 282.5 662 286.5 Q 660.5 289.5 659 286.5 L 661 284.5 L 659.5 282 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 923.5 282 L 925.5 285 L 923 283.5 L 923.5 282 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1071.5 282 L 1072.5 284 L 1074 283.5 L 1072.5 285 L 1070 284.5 L 1071.5 282 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1079.5 282 L 1080 284 L 1078 283.5 L 1079.5 282 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1191.5 282 L 1192 283.5 L 1191 286 Q 1185.6 285.1 1183.5 289 L 1183.5 287 Q 1181.3 287.8 1182 285.5 L 1180 285.5 Q 1181.8 282.3 1183.5 286 Q 1189.5 286 1191.5 282 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 481.5 283 L 482 288.5 L 481 288.5 L 481.5 283 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 657.5 283 Q 660.5 284.5 657.5 286 L 640 285.5 L 657 285 L 657.5 283 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1075.5 283 L 1077 286 Q 1073.6 285.3 1072.5 288 L 1070 286.5 L 1071.5 286 Q 1073 288.5 1074.5 285 L 1076 284.5 L 1075.5 283 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1144.5 283 L 1146 285.5 L 1145 285.5 L 1144.5 283 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 592.5 284 L 593 286.5 L 592 286.5 L 592.5 284 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 889.5 284 Q 892.1 283.3 891 286 L 893 286 L 893 287.5 L 889.5 284 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1102.5 284 L 1101.5 288 L 1099 286.5 L 1102.5 284 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 634.5 285 L 639 285.5 L 631.5 287 L 631.5 286 L 634.5 285 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 896.5 285 L 922.5 285 L 924 286.5 L 923.5 288 L 921.5 286 L 896 286 L 895.5 288 L 895 286.5 L 896.5 285 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1079.5 285 L 1096.5 285 L 1098 286.5 L 1097.5 288 L 1097 286 L 1079 286.5 L 1079.5 288 Q 1076.5 286.5 1079.5 285 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1215 285 L 1217 285.5 Q 1214.5 287 1218 288.5 L 1217.5 290 L 1215.5 287 L 1214 287.5 L 1215 285 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1292.5 285 L 1292 286.5 L 1291 289.5 L 1293 292.5 L 1291 293.5 L 1291 291.5 Q 1291.7 288.9 1289 290 L 1289 287.5 L 1290 287.5 L 1290.5 289 L 1292.5 285 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 519 286 L 521 286.5 L 518.5 290 L 514 287.5 L 515.5 287 L 518 287.5 L 518.5 289 L 519 286 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 564.5 286 L 568 286.5 L 565.5 288 L 564.5 286 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 626.5 286 L 629 287.5 L 628.5 290 L 625 287.5 L 626.5 286 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 988.5 286 L 992 286.5 L 989.5 288 L 988.5 286 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1103.5 286 L 1107 288.5 L 1104.5 292 L 1104 290.5 L 1105 287 L 1103.5 286 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1141.5 286 L 1145 287.5 L 1141 288 L 1141.5 286 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1250.5 286 L 1251.5 288 L 1250.5 286 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 663.5 287 L 664.5 289 L 663.5 287 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 958.5 287 L 959 383.5 L 958 383.5 L 958.5 287 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1032.5 287 L 1033 289 Q 1036 287.8 1035 291.5 L 1033 292.5 L 1032.5 287 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1067.5 287 L 1069 289.5 L 1067 288.5 L 1067.5 287 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 701.5 288 L 702 295.5 L 701 295.5 L 701.5 288 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1070.5 288 L 1072 290.5 L 1070 289.5 L 1070.5 288 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1178.5 288 Q 1180.8 287.3 1180 289.5 Q 1182.3 290.7 1181 295.5 L 1180 295.5 Q 1180.8 289.3 1178.5 288 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1295.5 288 L 1296 290.5 L 1294 291.5 L 1295.5 288 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 519.5 291 L 518.5 293 L 519.5 291 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 626.5 291 L 627 294 Q 629.7 295.1 629 292.5 L 631 291.5 Q 632.1 294.8 629.5 294 L 627 295 L 627 344.5 L 626 345.5 L 628 346 L 627.5 348 L 625 344.5 L 626 343.5 L 626.5 291 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1069.5 291 L 1071 295.5 L 1070 296.5 L 1070 343.5 L 1069 344.5 L 1072 346.5 L 1069 347.5 L 1070.5 350 L 1068 347.5 L 1069 346.5 L 1067.5 344 L 1069 343.5 L 1069 296.5 L 1070 294 Q 1066.3 295.5 1067 292.5 L 1069 292.5 L 1069.5 291 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1106.5 291 L 1107 294.5 L 1106 294.5 L 1106.5 291 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1182.5 291 L 1183 293.5 L 1182 293.5 L 1182.5 291 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1216.5 291 L 1217 295.5 L 1216 295.5 L 1216.5 291 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1256.5 292 L 1257 294.5 L 1256 294.5 L 1256.5 292 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480 293 L 482 293.5 L 481 295.5 L 481.5 297 L 480 293 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 515.5 293 L 516.5 295 L 518 294.5 L 517.5 298 L 515 294.5 L 515.5 293 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1295.5 293 L 1296 294.5 L 1295.5 296 L 1298 296.5 L 1295 297 L 1294.5 299 L 1293 295.5 L 1295.5 293 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 519.5 294 L 520 296 L 525.5 298 L 544 298 L 544.5 296 L 548.5 297 L 550.5 297 L 553 297 Q 551.8 300 555.5 299 L 559.5 298 L 559.5 299 Q 555.8 298.3 555 300.5 L 554.5 302 L 544.5 298 L 543.5 299 L 527 299.5 L 546 300.5 L 527.5 301 L 525.5 300 L 524 300.5 L 523.5 298 L 519.5 299 L 519.5 298 L 523 297.5 L 519 295.5 L 519.5 294 Z M 548 298 L 548 299 L 552 299 L 548 298 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1032.5 295 L 1035 295.5 L 1034 296.5 L 1034 346.5 L 1032.5 348 L 1033 346.5 L 1033 296.5 L 1032.5 295 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 628.5 296 L 629.5 345 L 631.5 344 L 631.5 345 Q 628.9 344.2 630 347.5 L 632 347.5 Q 630.5 350.5 629 347.5 L 628 344.5 L 628.5 296 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 699.5 296 L 700 344 Q 704.1 342.3 703 346.5 L 702 346.5 Q 702.8 344.3 700.5 345 L 697 347.5 L 698 345.5 L 697.5 344 L 699.5 345 L 699 343.5 L 699.5 296 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1323 296 L 1325 296 Q 1323.9 298.7 1326.5 298 L 1329 296.5 L 1328 298.5 L 1330.5 297 L 1333 297.5 L 1327.5 301 L 1327.5 299 L 1321.5 301 L 1302.5 301 L 1300.5 300 L 1299 300.5 L 1302 298.5 L 1300 297.5 L 1303.5 297 L 1304.5 298 L 1320 298.5 L 1302 299.5 L 1321.5 300 L 1323 296 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 558.5 300 L 560 300.5 L 556.5 302 L 556.5 301 L 558.5 300 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1330.5 300 L 1333.5 301 L 1335.5 300 L 1335.5 301 L 1333.5 302 L 1330.5 301 L 1330.5 300 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480.5 301 L 481 303 L 484 304.5 L 481 307.5 L 484.5 312 L 482 310.5 L 480 307.5 L 481 305.5 L 480 302.5 L 480.5 301 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 565.5 304 L 564.5 306 L 565.5 304 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 567.5 304 L 570.5 305 L 572 305.5 L 570.5 306 L 569 305.5 L 568.5 307 L 567.5 304 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 573.5 304 L 576 305.5 L 574 306.5 L 574.5 305 L 573.5 304 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1256.5 304 L 1259 307.5 L 1258 310 L 1260.5 311 L 1262 310.5 L 1261 314 L 1264 315.5 L 1263.5 317 L 1259.5 311 Q 1256.8 312.3 1259 313.5 L 1258.5 315 L 1256 310.5 L 1257 308.5 L 1256.5 307 L 1258 307.5 L 1256.5 304 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341.5 304 L 1343.5 305 L 1345.5 304 L 1347.5 304 L 1349 304.5 L 1346.5 306 L 1344.5 305 L 1346.5 309 Q 1342.5 309.5 1342 306.5 L 1341.5 304 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 484.5 306 L 485.5 310 Q 481 308 484.5 306 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1349.5 307 Q 1352.8 305.9 1352 308.5 L 1350.5 308 L 1349.5 307 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 572.5 308 L 574.5 309 L 576 308.5 Q 576.8 310.8 574.5 310 L 575 311.5 L 574.5 313 L 574 311 L 572 310.5 L 572.5 308 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 579.5 312 L 580.5 314 L 578 313.5 L 579.5 312 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1355.5 312 L 1358 312.5 L 1356 316 L 1359 314.5 L 1359.5 313 L 1360 314.5 L 1358 316.5 L 1359.5 319 L 1358 319.5 L 1360 322.5 L 1359 324.5 L 1360 327 L 1358 326.5 L 1358 324.5 L 1359 322.5 L 1357.5 320 L 1356 320.5 L 1358 317.5 L 1355.5 319 L 1353.5 317 L 1352 316.5 L 1355 315.5 Q 1355.8 313.3 1353.5 314 L 1353.5 313 L 1355.5 312 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 583.5 313 L 583.5 318 L 580.5 317 L 579 317.5 Q 579.8 315.3 577.5 316 L 577.5 315 L 582 316 L 583.5 313 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1256.5 315 L 1263 318 L 1262.5 320 L 1260.5 320 L 1259 319.5 L 1260 317 Q 1257.3 315.9 1258 318.5 L 1257 318.5 L 1256.5 315 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 489.5 317 L 493 319 L 492.5 321 L 491 320.5 L 493.5 325 L 500.5 327 L 502 326.5 L 499.5 328 L 497.5 328 L 496 327.5 L 496.5 326 L 492 326 Q 493 323 490 324 L 490 321.5 L 488 321.5 L 488.5 319 L 490.5 320 L 489.5 317 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1265.5 319 L 1267.5 322 L 1269 321.5 L 1268 323.5 L 1269.5 323 L 1271 323.5 L 1269 324.5 L 1271 325.5 L 1267.5 328 L 1266.5 326 Q 1265.3 328.3 1264 325.5 L 1265 323.5 L 1264 321.5 L 1265.5 319 Z M 1268 324 Q 1266 327 1269 326 L 1268 324 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 582.5 320 L 583 322 L 581 321.5 L 582.5 320 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 493.5 322 L 496 323.5 L 494.5 324 L 493.5 322 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 488.5 323 L 489 325 L 491 325 Q 489.9 327.7 492.5 327 L 492.5 328 L 489.5 327 L 488 327.5 L 489 325.5 L 488.5 323 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 583.5 323 L 582.5 325 L 583.5 323 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1272.5 323 L 1273 325.5 L 1272 325.5 L 1272.5 323 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1274.5 326 L 1273.5 328 L 1274.5 326 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1361 328 L 1363 328.5 L 1362 330.5 Q 1365 331.8 1364 336 L 1366 336 L 1366 330.5 L 1367.5 330 L 1367 331.5 L 1368 337.5 L 1367 337.5 L 1366.5 336 L 1366 338.5 L 1367 341.5 L 1366 341.5 L 1363.5 336 L 1361.5 340 L 1361 338.5 L 1363 333.5 Q 1360 332.3 1361 328 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 590.5 329 L 591 330.5 L 590 333.5 L 590.5 335 Q 587.5 334.1 589 338.5 L 590 338.5 L 590.5 336 L 591 348.5 L 590 348.5 L 590 340.5 L 588.5 339 L 587.5 341 L 586 336.5 L 587 336.5 L 587.5 338 L 589 331.5 L 588 331.5 L 587.5 334 L 587 331.5 L 590 330.5 L 590.5 329 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 504.5 330 L 506.5 331 L 508.5 330 L 508.5 331 L 504.5 333 L 504.5 330 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1286.5 331 Q 1289.8 329.9 1289 332.5 L 1290 335 L 1287.5 334 L 1285.5 335 L 1285.5 333 L 1284 332.5 L 1286.5 331 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 508.5 332 L 511 333.5 L 509.5 333 L 508.5 332 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1294.5 332 L 1295 335 L 1291 334.5 L 1294.5 332 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1281.5 333 L 1283.5 336 L 1281.5 333 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1322.5 333 L 1323.5 335 L 1322.5 333 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 507.5 334 L 506.5 336 L 505 335.5 L 507.5 334 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 515.5 334 L 518 334.5 L 515.5 335 L 515.5 334 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 856.5 336 L 857 343.5 L 855 344.5 L 856.5 336 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 890.5 336 L 891 340.5 L 890 340.5 L 890.5 336 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 893.5 336 L 894 338.5 L 893 338.5 L 893.5 336 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1323 336 L 1325 336.5 L 1323.5 339 L 1323 336 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 552.5 339 L 554 342.5 L 553 342.5 L 552.5 339 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1325.5 339 L 1328 339.5 Q 1325.9 342.8 1325.5 339 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1363.5 339 L 1364 342.5 L 1363 342.5 L 1363.5 339 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1321.5 340 L 1325 342.5 L 1323.5 343 L 1321.5 340 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1328.5 341 L 1329 343.5 L 1327.5 346 L 1326.5 342 L 1328.5 341 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 587.5 342 L 589 345.5 L 588 351 L 586 350.5 L 587 346.5 L 586 343.5 L 587.5 342 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1361.5 342 L 1362 346.5 L 1361 346.5 L 1361.5 342 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1365.5 343 L 1366 345.5 L 1364 344.5 L 1365.5 343 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 546.5 344 L 549 345.5 L 548 349 L 544.5 350 L 544.5 347 L 546.5 348 L 545 345.5 L 546.5 344 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 552.5 344 L 549.5 348 L 552.5 344 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 656.5 344 L 659 344.5 L 660 346.5 L 658.5 346 L 656.5 344 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 737.5 344 L 739.5 345 L 742 344 Q 743.5 347.8 740.5 347 L 740.5 348 Q 743.1 347.2 742 350.5 L 743 350.5 L 743.5 349 L 744 350.5 Q 742.5 353.5 741 350.5 L 739.5 348 L 737 346.5 L 737.5 344 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 820 344 L 822 344.5 Q 819.8 345.7 822.5 347 L 824 346.5 L 823.5 349 L 822 348.5 L 824 351.5 L 822.5 351 Q 819.9 351.8 821 348.5 L 819.5 349 L 818 348.5 L 820 347.5 L 817 346.5 L 820 345.5 L 820 344 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 849.5 344 L 851.5 344 L 854 344.5 L 851 345.5 L 851.5 347 Q 850.3 344.8 849 347.5 L 848.5 350 L 848 347.5 L 849.5 344 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1097.5 344 L 1099.5 345 L 1101 344.5 L 1100.5 346 L 1103.5 344 L 1106 344.5 L 1105.5 347 L 1103.5 347 L 1100 348.5 L 1100.5 350 Q 1098.3 350.8 1099 348.5 L 1100 346.5 L 1097.5 345 L 1096 345.5 L 1097.5 344 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1139.5 344 L 1143 349.5 L 1141 349.5 Q 1141.8 352.1 1138.5 351 L 1139.5 349 L 1141 348.5 Q 1137.9 347.4 1139.5 344 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1367.5 345 L 1368 346.5 L 1365.5 352 L 1363 352 L 1363 346.5 L 1364 346.5 Q 1362.3 352.4 1366 351 L 1367.5 345 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 700.5 347 L 701 350 Q 703.7 351.1 703 348.5 L 704 348.5 L 705 350.5 L 703 350.5 L 702.5 352 L 700.5 351 L 698.5 352 L 697 349.5 L 698 349.5 Q 697.3 352.1 700 351 L 699 348.5 L 700.5 347 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 854.5 347 L 855 348.5 L 852 350.5 L 852.5 348 L 854 348.5 L 854.5 347 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1097.5 347 L 1097 348.5 L 1098.5 351 L 1100 351.5 L 1098.5 352 L 1096 348.5 L 1097.5 347 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1326.5 347 L 1328 347.5 L 1324.5 349 L 1324.5 348 L 1326.5 347 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 657.5 348 L 660.5 349 L 662 348.5 L 660.5 351 L 660 349 L 656.5 350 L 657.5 348 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1034.5 349 L 1034 350.5 L 1034.5 352 L 1036 351.5 L 1032.5 354 L 1032 351.5 Q 1031.3 349.3 1033.5 350 L 1034.5 349 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1072 349 Q 1075.3 347.9 1074 352 Q 1070.7 353.1 1072 349 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1361.5 349 L 1362 350.5 L 1360 351.5 L 1361.5 349 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 592.5 350 L 594 350.5 L 592 351.5 L 594 352.5 L 593 353.5 Q 596.1 355.3 594.5 357 Q 597.9 356.1 596 361.5 L 596.5 363 L 595 362.5 Q 595.8 364.8 593.5 364 L 592 361.5 Q 595.8 359.8 592.5 358 L 591.5 360 L 590 353.5 L 591 353.5 Q 589.5 357.9 592.5 357 L 592 353.5 Q 592.8 351.3 590.5 352 L 590.5 351 L 592.5 350 Z M 593 361 L 593 363 L 595 362 L 593 361 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1321.5 350 Q 1323.8 349.3 1323 351.5 L 1320 351.5 L 1321.5 350 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 585.5 352 L 587 355.5 L 586 355.5 L 585.5 352 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 780.5 352 L 781 353.5 L 780 356 L 784 353.5 L 784.5 352 L 785 355 L 781 357.5 L 782.5 358 L 785 357.5 L 785.5 356 L 787 358.5 L 785 358.5 L 784.5 361 L 779 357.5 L 779.5 356 Q 777.3 355.3 778 357.5 L 777 357.5 L 778 354 Q 780.8 355 780.5 352 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89 353 Q 92 352 91 355 Q 88 356 89 353 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1141.5 353 L 1142 355 L 1140 354.5 L 1141.5 353 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 354 L 88 354.5 L 48.5 355 L 48.5 354 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1138.5 354 L 1139 356.5 L 1137.5 360 L 1137 357.5 L 1138.5 354 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 588.5 355 L 590 359.5 L 589 359.5 L 588.5 355 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 705.5 355 L 707 357.5 L 705 357.5 L 707 360.5 Q 705.5 363.5 704 360.5 L 704 358.5 L 705.5 355 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1033.5 355 L 1034.5 357 L 1032.5 358 L 1033 356.5 L 1033.5 355 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480.5 356 Q 483.1 355.2 482 358.5 L 480 359.5 L 481 357.5 L 480.5 356 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 584 357 L 586 357 Q 584.9 359.7 587.5 359 L 587.5 360 L 584 359 L 584 357 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1142 357 Q 1145 356 1144 359 Q 1141 360 1142 357 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 886.5 358 Q 889.5 359.5 886.5 361 Q 883.5 359.5 886.5 358 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 779.5 359 L 780 383.5 L 779 383.5 L 779.5 359 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 582 360 L 584 360.5 L 582 361.5 L 582 360 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1035.5 360 L 1038 366.5 L 1035 365.5 L 1036 367.5 L 1033 367.5 L 1035.5 360 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1357.5 360 L 1360 360.5 L 1359 362.5 L 1359.5 364 L 1357.5 364 L 1356 363.5 L 1358 363 L 1357.5 360 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1033.5 361 L 1034 362.5 L 1032 363.5 L 1033.5 361 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1037.5 361 L 1038.5 363 Q 1035.7 363.7 1037.5 361 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 788.5 362 L 789.5 364 Q 788.3 361.8 787 364.5 L 788.5 367 L 790 366.5 L 788.5 368 L 786.5 366 L 784 367.5 L 784 365.5 Q 783.3 363.3 785.5 364 L 788.5 362 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 883.5 362 Q 887.5 361.5 888 364.5 L 885 365.5 L 886 367.5 L 884 366.5 L 883 364.5 L 886 363.5 Q 882.7 363.6 883.5 362 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 583.5 363 L 583 364.5 L 584 368.5 L 579 372.5 L 581 375.5 L 579.5 375 L 577.5 376 L 575 375 L 574.5 373 L 573 373.5 Q 574.3 370.7 575.5 373 Q 577.8 372.3 577 374.5 L 578 374.5 Q 579.1 371.2 576.5 372 L 577.5 370 L 578.5 372 Q 581.3 370.8 579 369.5 L 580 367.5 L 579.5 366 Q 582.3 367.3 580 368.5 L 580.5 370 L 583 369 L 581 364 L 583.5 363 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 704.5 363 L 707.5 365 L 707.5 363 Q 711.3 362 710 365 L 707 366.5 L 707.5 368 L 706 365 Q 702.8 366 704.5 363 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1134.5 363 L 1136 364.5 L 1135.5 367 L 1133.5 366 L 1132.5 369 Q 1129 367 1133.5 365 L 1135 364.5 L 1134.5 363 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 596.5 364 L 595 366.5 Q 595.7 369.1 593 368 L 592 365.5 L 593.5 366 L 596.5 364 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 691.5 364 L 692.5 366 L 693.5 364 L 695 367.5 L 694 367.5 L 693.5 366 Q 692.3 368.3 691 365.5 L 691.5 364 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1356.5 365 Q 1358.8 364.3 1358 366.5 L 1358.5 368 L 1356.5 365 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 791.5 366 L 793 368.5 L 791 367.5 L 791.5 366 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1041.5 366 L 1044 369.5 L 1040 368.5 L 1041.5 366 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 688 368 Q 691.3 366.9 690 371 Q 686.7 372.1 688 368 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 601.5 369 L 604 370.5 Q 605.1 373.8 602.5 373 L 601 372.5 L 602.5 375 L 605 373.5 L 605.5 372 L 607 375.5 L 606 375.5 L 605.5 374 L 602.5 376 L 600 372.5 Q 603.1 370.7 601.5 369 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 792.5 370 L 795 370.5 Q 794.3 372.8 796.5 372 L 796 373.5 Q 797.1 376.8 794.5 376 L 795 374.5 L 794.5 373 L 793 373.5 L 794 372.5 L 792.5 370 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1041.5 370 L 1044.5 374 L 1047 372.5 L 1046.5 374 L 1049 374.5 L 1046.5 376 L 1045.5 374 L 1044.5 376 L 1042.5 373 L 1040 374.5 L 1041 371.5 L 1041.5 370 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1351.5 370 L 1352 371.5 L 1349.5 373 L 1349.5 372 Q 1352 372.7 1351.5 370 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 712.5 371 L 715 371.5 Q 712.8 372.8 715.5 374 L 717 373.5 L 712 376 L 713 372.5 L 712.5 371 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1135.5 371 L 1135 372.5 L 1134.5 374 L 1134 372.5 L 1135.5 371 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 581.5 372 L 584 372.5 L 581.5 373 L 581.5 372 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 877.5 372 L 880 372.5 Q 880.8 375.1 877.5 374 L 876 374.5 L 877.5 372 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 684.5 373 L 686 373.5 L 685.5 376 L 683 374.5 L 684.5 373 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1129.5 373 L 1129.5 375 L 1131 375.5 L 1129.5 376 L 1127 374.5 L 1129.5 373 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1124 374 L 1126 374.5 L 1124 377.5 L 1127 376.5 L 1124.5 380 L 1120.5 382 L 1120.5 381 L 1122 380.5 L 1119 378.5 L 1120.5 379 L 1122.5 380 L 1123.5 378 L 1122 377.5 L 1124 374 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1346 374 L 1348 374.5 L 1346 375.5 L 1346 374 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1049.5 376 L 1050.5 378 L 1049.5 376 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 721.5 377 L 722 378.5 L 721.5 381 Q 718.8 379.8 721 378.5 L 721.5 377 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1342.5 377 L 1344 377.5 L 1343.5 380 L 1341 378.5 L 1342.5 377 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0.5 378 L 2 382.5 L 0 383.5 L 0.5 378 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 566.5 378 L 568.5 380 L 571 378.5 Q 571.8 380.8 569.5 380 Q 567.8 383.8 566 380.5 L 566.5 378 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 611.5 378 L 612.5 380 L 610 379.5 L 611.5 378 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 803.5 378 L 803.5 380 Q 805.8 379.3 805 381.5 L 809 381.5 Q 808.3 383.8 810.5 383 L 810.5 384 L 807.5 383 L 805.5 383 L 803.5 382 L 802.5 384 L 802 382.5 L 803 380.5 L 800 381.5 L 800.5 379 Q 802 381.5 803.5 378 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1048.5 378 L 1051 379.5 L 1049.5 380 L 1048.5 378 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 573 379 L 576 380.5 L 575.5 382 L 573 381 L 573 379 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 676.5 379 L 676 380.5 L 674.5 384 L 672.5 381 L 674 381.5 Q 673.3 379.3 675.5 380 L 676.5 379 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 866.5 379 L 867 380.5 Q 863.9 382.3 865.5 384 L 862 382.5 L 862.5 381 L 863.5 383 L 866.5 379 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 871.5 379 L 872 384 L 870 383.5 L 871.5 379 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1127.5 379 L 1126 381.5 L 1127 382.5 L 1126.5 384 L 1125.5 382 L 1124.5 384 L 1124 382.5 L 1127.5 379 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 679.5 380 L 678.5 382 L 679.5 380 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1052.5 380 L 1052.5 382 L 1055 381.5 L 1054.5 380 L 1057 380.5 L 1056.5 383 L 1054.5 383 L 1048 381.5 L 1052.5 380 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1058.5 380 L 1062 382.5 L 1059.5 384 L 1059.5 382 Q 1056.7 382.7 1058.5 380 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1338 380 L 1340 380.5 Q 1336.9 382.3 1338.5 384 L 1336.5 381 L 1338 381.5 L 1338 380 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 571.5 381 L 573.5 384 L 570 382.5 L 571.5 381 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 612.5 381 L 611.5 383 L 608.5 384 L 608.5 383 L 612.5 381 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 618.5 381 L 621 382.5 L 619.5 383 L 618.5 381 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 725.5 381 L 723.5 384 L 725.5 381 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1113.5 381 L 1113.5 383 L 1115 383.5 L 1113.5 384 Q 1110.5 382.5 1113.5 381 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1342.5 381 L 1341.5 383 L 1340 382.5 L 1342.5 381 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 557.5 382 L 556.5 384 L 557.5 382 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 559 382 L 562.5 383 L 564.5 382 L 564.5 383 L 562.5 384 L 560.5 383 L 559 383.5 L 559 382 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 614.5 382 L 618 383.5 L 615.5 384 L 614.5 382 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 670.5 382 L 671.5 384 L 670.5 382 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1110.5 382 L 1111 384 L 1109 383.5 L 1110.5 382 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1118.5 382 L 1119.5 384 L 1117 383.5 L 1118.5 382 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1048.5 383 L 1051 383.5 L 1048.5 384 L 1048.5 383 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 425.5 386 Q 427.8 385.3 427 387.5 L 425 390.5 L 425.5 392 Q 422.9 392.8 424 389.5 L 425.5 386 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 431.5 386 L 434 390.5 L 432.5 392 L 431.5 390 L 429 391.5 L 431 388.5 L 431.5 386 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,254,254)",
    stroke: "rgb(252,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 435.5 389 L 438 390.5 Q 438.8 392.8 436.5 392 L 436.5 390 L 435.5 389 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1164.5 15 L 1165 56 L 1263.5 56 L 1264 57.5 L 1262.5 57 L 1165.5 57 L 1164 55.5 L 1164.5 15 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 634.5 16 L 635 55.5 L 633.5 57 L 537.5 57 L 537.5 56 L 634 56 L 634.5 16 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 897.5 16 L 898 226.5 L 897 226.5 L 897.5 16 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 37 L 252 37.5 L 244.5 38 L 244.5 37 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 37 L 328 43.5 L 327 44.5 L 327 82.5 L 327 84.5 L 326.5 86 L 254.5 86 Q 243.2 87.7 238 95.5 L 236 103.5 L 237 110 Q 234.3 111.1 235 108.5 L 234 107.5 L 234 99.5 L 240.5 90 L 251.5 85 L 323.5 85 L 325 83.5 L 325 44.5 Q 328.3 42.8 327.5 37 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 38 L 243 38.5 L 240.5 39 L 240.5 38 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 40 L 234 40.5 L 228.5 43 L 229.5 41 L 232.5 40 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 48 L 215.5 50 L 216.5 48 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 52 L 205.5 58 L 210.5 52 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1331.5 56 L 1330.5 58 L 1331.5 56 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 59 L 199.5 64 L 203.5 59 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1260.5 61 L 1259.5 63 L 1260.5 61 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1327.5 61 L 1326.5 63 L 1327.5 61 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 66 L 196.5 68 L 197.5 66 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1256.5 66 L 1255.5 68 L 1256.5 66 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1323.5 66 L 1322.5 68 L 1323.5 66 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 69 L 194.5 71 L 195.5 69 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 757.5 71 L 756.5 73 L 757.5 71 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1252.5 71 L 1250.5 74 L 1252.5 71 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1318.5 72 L 1317.5 74 L 1318.5 72 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 74 L 192 75.5 L 190.5 78 L 191 76.5 L 192.5 74 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1248.5 76 L 1247.5 78 L 1248.5 76 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1314.5 77 L 1313.5 79 L 1314.5 77 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1244.5 81 L 1242.5 84 L 1244.5 81 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1310.5 82 L 1309.5 84 L 1310.5 82 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 84 L 188 86.5 L 186.5 89 L 186 87.5 L 187.5 84 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 949.5 87 Q 952.3 88.3 950 89.5 L 949.5 227 L 949.5 87 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1239.5 87 L 1238.5 89 L 1239.5 87 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1306.5 87 L 1305.5 89 L 1306.5 87 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 537.5 95 L 627 95.5 L 537.5 96 L 537.5 95 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 96 L 186 111.5 L 194 136.5 Q 201.5 151 213.5 161 Q 225.7 171.3 244.5 175 L 290.5 175 Q 292.3 177.8 298.5 176 Q 305.9 178.1 310 183.5 L 314 190.5 L 314 197.5 L 312 202 Q 308 203.4 310 196.5 L 312 192.5 Q 309.8 184.2 303.5 180 L 295.5 177 L 251.5 177 L 250.5 176 L 242.5 176 Q 219.1 170.4 205 155.5 L 197 145.5 L 185 122.5 Q 182.6 115.4 184 104.5 L 183 103.5 L 184.5 96 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1298.5 97 L 1296.5 100 L 1298.5 97 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1227.5 102 L 1226.5 104 L 1227.5 102 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1293.5 103 L 1292.5 105 L 1293.5 103 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1223.5 107 L 1222.5 109 L 1223.5 107 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1219.5 112 L 1218.5 114 L 1219.5 112 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1284.5 114 L 1283.5 116 L 1284.5 114 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 115 L 241 119.5 L 239 118.5 L 238.5 115 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1215.5 117 L 1214.5 119 L 1215.5 117 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1281.5 118 L 1279.5 121 L 1281.5 118 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 123 L 245.5 125 L 244.5 123 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1210.5 123 L 1209.5 125 L 1210.5 123 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1277.5 123 L 1275.5 126 L 1277.5 123 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 127 L 170 127.5 L 105.5 128 L 105.5 127 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 127 L 297 127.5 L 251.5 128 L 251.5 127 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 128 L 305 128.5 L 302.5 129 L 302.5 128 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1206.5 128 L 1205.5 130 L 1206.5 128 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1272.5 129 L 1271.5 131 L 1272.5 129 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 130 L 93 130.5 L 89.5 132 L 89.5 131 L 91.5 130 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 133 L 327 136.5 L 325.5 136 Q 321.5 135.5 321.5 133 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1202.5 133 L 1201.5 135 L 1202.5 133 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1268.5 134 L 1267.5 136 L 1268.5 134 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 137 L 74.5 140 L 76.5 137 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 138 L 331.5 140 L 330.5 138 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1198.5 138 L 1197.5 140 L 1198.5 138 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1264.5 139 L 1262.5 142 L 1264.5 139 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 140 L 349 154.5 L 336.5 143 L 333.5 140 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 141 L 65.5 147 L 70.5 141 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1194.5 143 L 1193.5 145 L 1194.5 143 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1260.5 144 L 1258.5 147 L 1260.5 144 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1190.5 148 L 1189.5 150 L 1190.5 148 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1255.5 150 L 1254.5 152 L 1255.5 150 Z "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 151 L 57.5 155 L 60.5 151 Z "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1186.5 153 L 1184.5 156 L 1186.5 153 Z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1251.5 155 L 1250.5 157 L 1251.5 155 Z "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 156 L 54.5 159 L 56.5 156 Z "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 156 L 350.5 158 L 349.5 156 Z "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1182.5 158 L 1180.5 161 L 1182.5 158 Z "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 159 L 352.5 161 L 351.5 159 Z "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 162 L 52 163.5 L 50.5 166 L 51 164.5 L 52.5 162 Z "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 162 L 354.5 164 L 353.5 162 Z "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1178.5 163 L 1176.5 166 L 1178.5 163 Z "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 165 L 357 167.5 L 355 166.5 L 355.5 165 Z "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1243.5 165 L 1241.5 168 L 1243.5 165 Z "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 167 L 192.5 169 L 191.5 167 Z "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 171 L 48 172.5 L 46.5 175 L 46 173.5 L 47.5 171 Z "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 171 L 195.5 173 L 194.5 171 Z "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 171 L 361 177.5 L 360 177.5 L 358.5 171 Z "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1238.5 171 L 1237.5 173 L 1238.5 171 Z "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 175 L 189.5 175 L 193 176.5 L 190.5 177 L 189.5 176 L 114.5 176 L 102.5 180 L 97 185.5 Q 93.7 189.2 95 197.5 L 96 199.5 L 96 201.5 L 95.5 214 L 95 211 L 93 210.5 L 93 201.5 L 92 200.5 L 92 191.5 Q 94.1 184.1 99.5 180 L 111.5 175 Z "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 176 L 202 180.5 L 200.5 180 L 194 177.5 L 195.5 177 L 198.5 178 L 198.5 176 Z "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1234.5 176 L 1233.5 178 L 1234.5 176 Z "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 988.5 177 L 1026 177.5 L 988.5 178 L 988.5 177 Z "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1165.5 179 L 1164.5 181 L 1165.5 179 Z "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1230.5 181 L 1229.5 183 L 1230.5 181 Z "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 183 L 44 189.5 L 43 191.5 L 45 195.5 L 45 354.5 L 46.5 356 L 93 356 L 93 278.5 L 92 277.5 L 92 269.5 L 95.5 266 L 100.5 265 L 102.5 266 L 103.5 265 L 175.5 265 L 176.5 266 L 298.5 266 Q 300.3 263.2 306.5 265 L 320.5 260 Q 335.4 252.9 345 240.5 L 356 221.5 L 361 205.5 L 361 198.5 L 363.5 189 L 364 205.5 Q 361.5 207 363 212.5 L 353 232.5 L 338.5 250 Q 329.5 258 317.5 263 L 301.5 267 L 98.5 267 L 94 270.5 Q 93.3 276.2 96 278.5 L 96 357 L 43.5 357 L 42.5 358 L 42 189.5 L 43.5 183 Z "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 183 L 363 185.5 L 362 185.5 L 362.5 183 Z "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 718.5 184 L 795.5 184 L 797 185.5 L 795.5 185 L 718.5 185 L 718.5 184 Z "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1161.5 184 L 1160.5 186 L 1161.5 184 Z "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1337.5 186 L 1338 226.5 L 1337 226.5 L 1337.5 186 Z "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1159.5 187 L 1160 223.5 L 1159 223.5 L 1159.5 187 Z "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 207 L 309 208.5 L 307 209.5 L 308.5 207 Z "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 305.5 212 L 304.5 214 L 305.5 212 Z "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 301.5 215 L 300.5 217 L 299 216.5 L 301.5 215 Z "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 217 L 222 217.5 L 96.5 218 L 96.5 217 Z "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 218 L 293 218.5 L 224.5 219 L 224.5 218 Z "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 517.5 249 L 520 249.5 L 517.5 250 L 517.5 249 Z "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 628.5 249 L 631 249.5 L 628.5 250 L 628.5 249 Z "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 658.5 249 L 662 249.5 L 658.5 250 L 658.5 249 Z "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 704.5 249 L 707 249.5 L 704.5 250 L 704.5 249 Z "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 733.5 249 L 736 249.5 L 733.5 250 L 733.5 249 Z "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 784 249 L 786 249.5 L 785 250.5 L 784.5 347 L 784 249 Z "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 813.5 249 L 816 249.5 L 813.5 250 L 813.5 249 Z "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 895.5 249 L 896 280 L 926.5 280 L 927 282.5 L 926 282.5 L 925.5 281 L 896.5 281 L 895 279.5 L 895.5 249 Z "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 996 249 L 998 249.5 L 997 250.5 L 996.5 384 L 996 249 Z "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1070.5 249 L 1076 249.5 L 1070.5 250 L 1070.5 249 Z "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1100.5 249 L 1104 249.5 L 1100.5 250 L 1100.5 249 Z "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1181.5 249 L 1184 249.5 L 1181.5 250 L 1181.5 249 Z "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1211.5 249 L 1216 249.5 L 1211.5 250 L 1211.5 249 Z "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1292.5 249 L 1295 249.5 L 1292.5 250 L 1292.5 249 Z "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 674.5 253 L 675.5 255 L 674.5 253 Z "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 498.5 257 L 496.5 260 L 498.5 257 Z "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 680.5 257 L 681.5 259 L 680.5 257 Z "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1051.5 257 L 1050.5 259 L 1051.5 257 Z "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1122.5 257 L 1124.5 260 L 1122.5 257 Z "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1162.5 257 L 1161.5 259 L 1162.5 257 Z "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1233.5 257 L 1234.5 259 L 1233.5 257 Z "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1273.5 257 L 1271.5 260 L 1273.5 257 Z "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 608.5 258 L 607.5 260 L 608.5 258 Z "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 492.5 263 L 490.5 266 L 492.5 263 Z "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 603.5 263 L 602.5 265 L 603.5 263 Z "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1128.5 263 L 1130.5 266 L 1128.5 263 Z "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1239.5 263 L 1241.5 266 L 1239.5 263 Z "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1267.5 263 L 1265.5 266 L 1267.5 263 Z "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 687.5 264 L 689.5 267 L 687.5 264 Z "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1044.5 264 L 1043.5 266 L 1044.5 264 Z "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1155.5 264 L 1154.5 266 L 1155.5 264 Z "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 600.5 267 L 599.5 269 L 600.5 267 Z "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1131.5 267 L 1132.5 269 L 1131.5 267 Z "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 692.5 272 L 694 274.5 L 693 274.5 L 692.5 272 Z "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 522.5 280 L 565 280.5 L 522.5 281 L 522.5 280 Z "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 633.5 280 L 658 280.5 L 633.5 281 L 633.5 280 Z "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 958.5 280 L 989 280.5 L 958.5 281 L 958.5 280 Z "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1075.5 280 L 1099 280.5 L 1075.5 281 L 1075.5 280 Z "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1185.5 280 L 1211 280.5 L 1185.5 281 L 1185.5 280 Z "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1297.5 280 L 1340 280.5 L 1297.5 281 L 1297.5 280 Z "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1182.5 281 L 1184 281.5 L 1179.5 285 L 1182.5 281 Z "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 517.5 282 L 515.5 285 L 517.5 282 Z "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 628.5 282 L 626.5 285 L 628.5 282 Z "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 661.5 282 L 664.5 286 L 661.5 282 Z "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1070.5 282 L 1068.5 285 L 1070.5 282 Z "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1103.5 282 L 1105.5 285 L 1103.5 282 Z "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1214.5 282 L 1216.5 285 L 1214.5 282 Z "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1292.5 282 L 1290.5 285 L 1292.5 282 Z "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 696.5 283 L 697 285.5 L 696 285.5 L 696.5 283 Z "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1035.5 283 L 1036 285.5 L 1035 285.5 L 1035.5 283 Z "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1257.5 283 L 1258 286.5 L 1257 286.5 L 1257.5 283 Z "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 482.5 284 L 483 286.5 L 482 286.5 L 482.5 284 Z "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 926.5 284 L 927 287.5 L 926 287.5 L 926.5 284 Z "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1138.5 284 L 1139 287.5 L 1138 287.5 L 1138.5 284 Z "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1146.5 284 L 1147 286.5 L 1146 286.5 L 1146.5 284 Z "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1249.5 284 L 1250 286.5 L 1249 286.5 L 1249.5 284 Z "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 593.5 285 L 594 287.5 L 593 287.5 L 593.5 285 Z "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 513.5 288 L 514 292.5 L 513 292.5 L 513.5 288 Z "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 624.5 288 L 625 344.5 L 624 344.5 L 624.5 288 Z "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 665.5 288 L 666 290.5 L 665 290.5 L 665.5 288 Z "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1066.5 288 L 1067 290.5 L 1066 290.5 L 1066.5 288 Z "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1107.5 288 L 1108 344.5 L 1107 344.5 L 1107.5 288 Z "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1177.5 288 L 1178 290.5 L 1177 290.5 L 1177.5 288 Z "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1218.5 288 L 1219 383.5 L 1218 383.5 L 1218.5 288 Z "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1288.5 288 L 1289 292.5 L 1288 292.5 L 1288.5 288 Z "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 482.5 293 L 483 296.5 L 482 296.5 L 482.5 293 Z "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1257.5 293 L 1258 296.5 L 1257 296.5 L 1257.5 293 Z "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1066.5 295 L 1067 345.5 L 1066 345.5 L 1066.5 295 Z "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 550.5 301 L 553 301.5 L 550.5 302 L 550.5 301 Z "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1325.5 301 L 1328 301.5 L 1325.5 302 L 1325.5 301 Z "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 568.5 308 L 569.5 310 L 568.5 308 Z "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1261.5 308 L 1263 310.5 L 1261 309.5 L 1261.5 308 Z "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1343.5 308 L 1344.5 310 L 1343.5 308 Z "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 577.5 317 L 578.5 319 L 577.5 317 Z "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1352.5 317 L 1353.5 319 L 1352.5 317 Z "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 498.5 323 L 500.5 326 L 498.5 323 Z "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 514.5 331 L 517 331.5 L 514.5 332 L 514.5 331 Z "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1289.5 331 L 1292 331.5 L 1289.5 332 L 1289.5 331 Z "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 543.5 332 L 548 332.5 L 543.5 333 L 543.5 332 Z "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 549.5 333 L 550.5 335 L 549.5 333 Z "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1360.5 335 L 1361 338.5 L 1360 338.5 L 1360.5 335 Z "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 585.5 336 L 586 338.5 L 585 338.5 L 585.5 336 Z "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 554.5 340 L 555 344.5 L 554 344.5 L 554.5 340 Z "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1329.5 340 L 1330 344.5 L 1329 344.5 L 1329.5 340 Z "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 704.5 342 L 705 347.5 L 704 347.5 L 704.5 342 Z "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 593.5 345 L 594 348.5 L 593 348.5 L 593.5 345 Z "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1138.5 345 L 1139 348.5 L 1138 348.5 L 1138.5 345 Z "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 585.5 346 L 586 349.5 L 585 349.5 L 585.5 346 Z "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1360.5 346 L 1361 349.5 L 1360 349.5 L 1360.5 346 Z "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 553.5 347 L 552.5 349 L 553.5 347 Z "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 696.5 347 L 697 350.5 L 696 350.5 L 696.5 347 Z "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1035.5 347 L 1036 349.5 L 1035 349.5 L 1035.5 347 Z "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1328.5 347 L 1327.5 349 L 1328.5 347 Z "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 626.5 348 L 629.5 352 L 626.5 348 Z "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 737.5 348 L 739.5 351 L 737.5 348 Z "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 817.5 348 L 820.5 352 L 817.5 348 Z "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1105.5 348 L 1102.5 352 L 1105.5 348 Z "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 887.5 349 L 888 351.5 L 887 351.5 L 887.5 349 Z "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 550.5 350 L 549.5 352 L 550.5 350 Z "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1325.5 350 L 1324.5 352 L 1325.5 350 Z "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 631.5 352 L 634 352.5 L 631.5 353 L 631.5 352 Z "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 823.5 352 L 828 352.5 L 823.5 353 L 823.5 352 Z "
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1073.5 352 L 1076 352.5 L 1073.5 353 L 1073.5 352 Z "
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 580.5 363 L 579.5 365 L 580.5 363 Z "
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 691.5 363 L 690.5 365 L 691.5 363 Z "
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1040.5 363 L 1041.5 365 L 1040.5 363 Z "
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1355.5 363 L 1354.5 365 L 1355.5 363 Z "
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 790.5 364 L 791.5 366 L 790.5 364 Z "
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 578.5 366 L 577.5 368 L 578.5 366 Z "
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 689.5 366 L 688.5 368 L 689.5 366 Z "
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1042.5 366 L 1043.5 368 L 1042.5 366 Z "
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 601.5 367 L 602.5 369 L 601.5 367 Z "
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 712.5 367 L 713.5 369 L 712.5 367 Z "
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1130.5 367 L 1129.5 369 L 1130.5 367 Z "
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 793.5 368 L 800.5 376 L 793.5 368 Z "
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 877.5 370 L 874.5 374 L 877.5 370 Z "
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 608.5 374 L 609.5 376 L 608.5 374 Z "
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 719.5 374 L 720.5 376 L 719.5 374 Z "
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1123.5 374 L 1122.5 376 L 1123.5 374 Z "
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 680.5 375 L 679.5 377 L 680.5 375 Z "
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1051.5 375 L 1052.5 377 L 1051.5 375 Z "
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1344.5 375 L 1343.5 377 L 1344.5 375 Z "
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 566.5 377 L 565.5 379 L 566.5 377 Z "
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 677.5 377 L 676.5 379 L 677.5 377 Z "
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1054.5 377 L 1055.5 379 L 1054.5 377 Z "
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1117.5 378 L 1116.5 380 L 1117.5 378 Z "
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 549.5 383 L 552 383.5 L 549.5 384 L 549.5 383 Z "
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 627.5 383 L 630 383.5 L 627.5 384 L 627.5 383 Z "
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 660.5 383 L 664 383.5 L 660.5 384 L 660.5 383 Z "
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 738.5 383 L 741 383.5 L 738.5 384 L 738.5 383 Z "
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 818.5 383 L 821 383.5 L 818.5 384 L 818.5 383 Z "
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 851.5 383 L 854 383.5 L 851.5 384 L 851.5 383 Z "
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1068.5 383 L 1071 383.5 L 1068.5 384 L 1068.5 383 Z "
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1102.5 383 L 1105 383.5 L 1102.5 384 L 1102.5 383 Z "
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,218,229)",
    stroke: "rgb(211,218,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1324.5 383 L 1328 383.5 L 1324.5 384 L 1324.5 383 Z "
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 633.5 8 L 632.5 10 L 633.5 8 Z "
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1166.5 8 L 1167 10.5 L 1166 10.5 L 1166.5 8 Z "
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 9.5 9 L 8.5 11 L 9.5 9 Z "
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 14.5 9 L 15.5 11 L 13 10.5 L 14.5 9 Z "
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 437.5 9 L 439.5 12 L 437.5 9 Z "
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 428.5 10 L 430.5 11 L 432 10.5 L 429.5 12 L 428.5 10 Z "
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 965.5 10 L 966.5 12 L 965.5 10 Z "
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 10.5 11 L 9.5 13 L 10.5 11 Z "
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 434.5 11 L 433.5 13 L 434.5 11 Z "
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 636.5 11 L 638 14.5 L 637 14.5 L 636.5 11 Z "
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 724.5 12 L 726.5 15 L 724.5 12 Z "
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 897.5 12 L 899 14.5 L 897 15.5 L 897 13.5 L 897.5 12 Z "
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 10.5 14 L 9.5 16 L 10.5 14 Z "
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480.5 14 L 481.5 16 L 480.5 14 Z "
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 633.5 14 L 636 14.5 Q 633.9 17.8 633.5 14 Z "
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1331.5 14 L 1334 14.5 Q 1331.9 17.8 1331.5 14 Z "
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 962.5 15 L 963.5 17 L 962.5 15 Z "
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1049.5 16 L 1048.5 18 L 1049.5 16 Z "
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 795.5 22 L 798 26.5 L 795 24.5 L 795.5 22 Z "
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1050.5 23 L 1051.5 25 L 1050.5 23 Z "
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 798.5 28 L 799.5 30 L 797 29.5 L 798.5 28 Z "
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 37 L 321 37.5 L 252.5 38 L 252.5 37 Z "
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322.5 37 L 327 37.5 L 322.5 38 L 322.5 37 Z "
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 975.5 38 L 974.5 40 L 975.5 38 Z "
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 39 L 236.5 41 L 234 40.5 L 237.5 39 Z "
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 803.5 40 L 802.5 42 L 803.5 40 Z "
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 41 L 232.5 46 L 230 44.5 L 232 43.5 Q 229.8 42.3 232.5 41 Z "
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 326.5 42 L 325 44.5 L 325 83.5 L 323.5 85 L 251.5 85 Q 242.9 86.9 238 92.5 L 234 99.5 L 234 107.5 L 235 110 Q 238 108.8 237 112.5 L 237.5 114 L 232 109.5 Q 230.8 101.2 233 96.5 L 240.5 88 Q 243.1 88.7 242 86 L 245.5 86 L 250.5 84 L 323 84 L 322 81.5 L 322 46.5 L 324 43 L 326.5 42 Z "
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 47 L 217.5 49 L 218.5 47 Z "
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 708.5 48 L 710 50.5 L 709 50.5 L 708.5 48 Z "
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 981.5 48 L 984 48.5 Q 981.9 51.8 981.5 48 Z "
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 806.5 50 L 805.5 52 L 806.5 50 Z "
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 51 L 210.5 54 L 212.5 51 Z "
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 636.5 52 Q 638.8 51.3 638 53.5 L 636.5 52 Z "
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 54 L 214.5 58 Q 210 56 213.5 54 Z "
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 707.5 55 L 708.5 57 L 707.5 55 Z "
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1332.5 56 L 1333.5 58 L 1332.5 56 Z "
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1260.5 58 L 1263 58.5 Q 1260.9 61.8 1260.5 58 Z "
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1329.5 59 L 1328.5 61 L 1329.5 59 Z "
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1333.5 59 L 1334.5 62 L 1336 61.5 Q 1334.3 64.8 1332.5 61 L 1331 60.5 L 1333.5 59 Z "
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1258.5 63 L 1257.5 65 L 1258.5 63 Z "
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 64 L 198.5 66 L 199.5 64 Z "
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 987.5 64 L 986.5 66 L 987.5 64 Z "
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 811.5 65 Q 813.8 69.3 816 67.5 L 814.5 70 L 811.5 65 Z "
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1249.5 66 Q 1252.5 67.5 1249.5 69 L 1249.5 66 Z "
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 67 L 196.5 69 L 197.5 67 Z "
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 987.5 67 L 986.5 69 L 987.5 67 Z "
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1254.5 68 L 1253.5 70 L 1254.5 68 Z "
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 988.5 69 L 990.5 72 L 988 71 L 988.5 69 Z "
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 70 L 194.5 72 L 195.5 70 Z "
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1320.5 70 L 1319.5 72 L 1320.5 70 Z "
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 814.5 72 Q 812.9 73.8 816 75.5 L 815.5 77 L 815 75 Q 812.3 76.1 813 73.5 L 814.5 72 Z "
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 990.5 73 L 989.5 75 L 988 74.5 L 990.5 73 Z "
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1240.5 73 L 1241.5 75 L 1240.5 73 Z "
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1245.5 73 Q 1248.3 74.3 1246 75.5 L 1247 78.5 L 1245 79.5 L 1246 77.5 L 1244.5 75 Q 1241.8 76.3 1244 77.5 L 1243.5 80 L 1242.5 78 L 1241 78.5 L 1245.5 73 Z "
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 699.5 74 L 700.5 76 L 699.5 74 Z "
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1025.5 74 L 1026.5 76 L 1025.5 74 Z "
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 697.5 75 L 698.5 77 L 697.5 75 Z "
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1316.5 75 L 1315.5 77 L 1316.5 75 Z "
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 77 L 191 78.5 L 189.5 82 L 189 80.5 L 191.5 77 Z "
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194 78 L 197 78.5 L 194 80 L 194 78 Z "
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1316.5 78 L 1319 79.5 L 1317.5 80 L 1316.5 78 Z "
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 998.5 83 L 997.5 85 L 998.5 83 Z "
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1240.5 83 L 1241.5 85 L 1239.5 85 L 1237 86.5 L 1236.5 88 L 1236 86.5 L 1240.5 83 Z "
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 630.5 88 L 629.5 90 L 630.5 88 Z "
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 762.5 88 L 763.5 90 L 762.5 88 Z "
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1234.5 88 L 1235.5 90 L 1234.5 88 Z "
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 89 L 187 91.5 L 186 91.5 L 186.5 89 Z "
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 750.5 90 L 751.5 92 L 750.5 90 Z "
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1310.5 90 Q 1313.3 91.3 1311 92.5 L 1309.5 95 L 1307 93.5 L 1308.5 94 Q 1310.8 94.8 1310 92.5 L 1310.5 90 Z "
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1303.5 91 L 1306 91.5 L 1304.5 93 L 1302 92.5 L 1303.5 91 Z "
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 625.5 92 L 627 94.5 L 625 93.5 L 625.5 92 Z "
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1234.5 92 L 1235 93.5 L 1233 94.5 L 1234.5 92 Z "
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 93 L 187 95.5 L 187 97.5 L 190 112.5 L 190 119.5 Q 193.7 122.3 193 129.5 L 200 144 Q 203 142.8 202 146.5 L 206 149.5 L 210.5 156 L 223.5 166 L 244.5 174 L 292.5 174 Q 294.3 176.8 300.5 175 L 311 181 L 316 190.5 L 316 197.5 L 311.5 204 Q 308.9 204.7 310 202 Q 312.7 203.1 312 200.5 Q 315.4 197.9 314 190.5 L 306.5 180 L 298.5 176 Q 292.3 177.8 290.5 175 L 244.5 175 L 236.5 173 Q 215.9 166.6 204 151.5 L 194 136.5 L 189 123.5 L 186 111.5 L 185.5 93 Z "
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 764.5 94 L 765.5 96 L 764.5 94 Z "
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 823.5 94 L 821.5 97 L 823.5 94 Z "
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1227.5 96 L 1225.5 99 L 1227.5 96 Z "
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1229 98 L 1231 98.5 L 1229 99.5 L 1229 98 Z "
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 692.5 99 L 693 101 L 690.5 102 L 692.5 99 Z "
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 751.5 99 L 750.5 101 L 751.5 99 Z "
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1001.5 100 L 1000.5 102 L 1001.5 100 Z "
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 954.5 101 L 953.5 103 L 954.5 101 Z "
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1300.5 101 L 1303 101.5 Q 1300.9 104.8 1300.5 101 Z "
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 693.5 102 L 692.5 104 L 693.5 102 Z "
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1061 102 L 1063 102.5 L 1061 103.5 L 1061 102 Z "
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1297 102 L 1299 102.5 L 1297 103.5 L 1297 102 Z "
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1225.5 104 L 1224.5 106 L 1225.5 104 Z "
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1006.5 106 L 1007.5 108 L 1006.5 106 Z "
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1291.5 106 L 1289.5 109 L 1291.5 106 Z "
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1293.5 107 L 1292.5 109 L 1293.5 107 Z "
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1221.5 108 L 1222 109.5 L 1220 110.5 L 1221.5 108 Z "
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 953.5 110 L 952.5 112 L 953.5 110 Z "
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1060.5 110 L 1059.5 112 L 1060.5 110 Z "
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1217.5 110 L 1218.5 112 L 1217.5 110 Z "
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1307 110 L 1309 110.5 L 1307 111.5 L 1307 110 Z "
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1286.5 112 L 1285.5 114 L 1286.5 112 Z "
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1054.5 113 L 1053.5 115 L 1054.5 113 Z "
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1217.5 114 L 1216.5 116 L 1217.5 114 Z "
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 961.5 116 L 962.5 118 L 961.5 116 Z "
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1289.5 116 L 1290 118 L 1288 117.5 L 1289.5 116 Z "
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 769.5 117 Q 772.5 118.5 769.5 120 L 769.5 117 Z "
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1008.5 117 Q 1011.5 118.5 1008.5 120 L 1008.5 117 Z "
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 687.5 118 L 686.5 120 L 687.5 118 Z "
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1209.5 119 L 1210.5 121 L 1209.5 119 Z "
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1213.5 119 L 1212.5 121 L 1213.5 119 Z "
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 683.5 120 L 685 122.5 L 684 122.5 L 683.5 121 L 682 121.5 L 683.5 120 Z "
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 121 L 243.5 124 L 241.5 121 Z "
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 739.5 122 L 742 122.5 Q 739.9 125.8 739.5 122 Z "
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1206.5 122 L 1208 122.5 L 1205.5 124 L 1206.5 122 Z "
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1054.5 123 Q 1057.3 124.3 1055 125.5 L 1054.5 127 L 1054 125.5 L 1054.5 123 Z "
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1279.5 124 L 1280 126.5 L 1278.5 128 Q 1275 126 1279.5 124 Z "
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 125 L 249 126.5 L 246.5 128 L 246.5 125 Z "
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1274.5 127 L 1273.5 129 L 1274.5 127 Z "
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 128 Q 172.5 129.5 169.5 131 L 169.5 128 Z "
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 964.5 128 L 965.5 130 L 964.5 128 Z "
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 129 L 98 129.5 L 93.5 131 L 93.5 130 L 96.5 129 Z "
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 129 L 312 130.5 L 309.5 131 L 308.5 129 Z "
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1272.5 131 L 1271.5 133 L 1272.5 131 Z "
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 132 L 86.5 134 L 85 133.5 L 87.5 132 Z "
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 835.5 132 L 834.5 134 L 833 133.5 L 835.5 132 Z "
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 133 L 96 134.5 L 94.5 135 L 92.5 133 Z "
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 133 L 322 134.5 L 320.5 134 L 319.5 133 Z "
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 136 L 78.5 138 L 76.5 139 L 77.5 137 L 79.5 136 Z "
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 630.5 136 L 631.5 138 L 630.5 136 Z "
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 968.5 136 L 971 136.5 Q 968.9 139.8 968.5 136 Z "
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 540.5 139 L 542.5 142 L 539 140.5 L 540.5 139 Z "
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1045.5 139 L 1048 139.5 L 1045.5 140 L 1045.5 139 Z "
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1195.5 139 L 1196.5 141 L 1195.5 139 Z "
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1192.5 140 Q 1195.5 141.5 1192.5 143 L 1192.5 140 Z "
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1268.5 140 L 1269.5 142 L 1268.5 140 Z "
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 141 L 73 141.5 L 70.5 143 L 71.5 141 Z "
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 969.5 141 L 972 141.5 Q 969.9 144.8 969.5 141 Z "
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1041.5 144 L 1040.5 146 L 1041.5 144 Z "
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 145 L 340 147.5 L 339 147.5 L 338.5 145 Z "
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1192.5 145 L 1191.5 147 L 1192.5 145 Z "
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 147 L 63.5 151 L 61 150.5 L 64.5 147 Z "
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 676.5 147 L 677 149 L 675 149.5 L 676 151.5 L 675 151.5 L 674.5 150 L 672 151.5 L 676.5 147 Z "
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 972.5 148 L 972 149.5 L 972.5 151 L 974.5 150 L 974.5 151 L 972.5 152 L 971 149.5 L 972.5 148 Z "
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1257.5 148 L 1259.5 151 Q 1257.8 147.9 1256 149.5 L 1257.5 148 Z "
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 154 L 181 155.5 L 177.5 158 L 176 155.5 L 177 155.5 Q 176.3 158.1 179 157 L 178.5 154 Z "
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 154 L 348.5 156 L 347.5 154 Z "
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1036.5 154 L 1040 156.5 L 1037.5 158 L 1036.5 154 Z "
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1183.5 154 L 1183.5 157 Q 1180.5 155.5 1183.5 154 Z "
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 158 L 54.5 160 L 55.5 158 Z "
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 158 L 62.5 160 L 61.5 158 Z "
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1254.5 158 L 1253.5 160 L 1252 159.5 L 1254.5 158 Z "
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1248.5 159 L 1247.5 161 L 1248.5 159 Z "
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 160 L 185.5 162 L 184 161.5 L 186.5 160 Z "
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1171.5 162 L 1169.5 165 L 1171.5 162 Z "
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1033.5 163 L 1032.5 165 L 1033.5 163 Z "
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1244.5 164 L 1245.5 166 L 1244.5 164 Z "
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 165 L 50.5 167 L 51.5 165 Z "
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 165 L 188.5 167 L 187.5 165 Z "
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 980.5 165 L 981 166.5 L 979 167.5 L 980.5 165 Z "
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 166 L 55 166.5 L 51.5 169 L 53.5 166 Z "
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 166 L 353 167.5 L 352.5 169 L 352 167.5 L 353.5 166 Z "
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 168 L 358 170.5 L 356 169.5 L 356.5 168 Z "
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1243.5 168 L 1242.5 170 L 1243.5 168 Z "
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1170.5 170 L 1173 170.5 L 1171.5 172 L 1169 171.5 L 1170.5 170 Z "
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1239.5 170 L 1240.5 172 L 1239.5 170 Z "
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1244.5 170 L 1243.5 172 L 1244.5 170 Z "
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1247.5 170 L 1245.5 173 L 1247.5 170 Z "
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 172 L 193.5 174 L 192.5 172 Z "
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 174 L 188 174.5 L 111.5 175 Q 101.3 176.8 96 183.5 L 92 191.5 L 92 200.5 L 93 201.5 L 93 211 Q 96 210 95 213 L 91 211.5 L 90 192.5 L 94 182 L 100.5 177 L 109.5 174 Z "
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1168.5 175 L 1167.5 177 L 1168.5 175 Z "
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 176 L 196.5 178 L 195.5 176 Z "
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1160.5 176 Q 1163.5 177.5 1160.5 179 L 1160.5 176 Z "
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1236.5 177 L 1237.5 179 L 1236.5 177 Z "
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1026.5 180 L 1029 180.5 L 1026.5 181 L 1026.5 180 Z "
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 854.5 183 L 853.5 185 L 854.5 183 Z "
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 184 L 48 198.5 L 48 351.5 L 47 353.5 L 48.5 355 L 91 355 L 90 351.5 L 90 280.5 L 91 278.5 L 89 272.5 L 91 266 L 97.5 264 L 178.5 264 L 179.5 265 L 294.5 265 L 296.5 265 Q 299.7 262.7 306.5 264 L 314.5 260 L 317.5 260 L 336 247.5 L 340.5 242 L 342 242 L 342 240 Q 344.7 241.1 344 238.5 L 351 228.5 L 353 220 Q 356 221.3 355 217.5 L 358 209.5 L 359 194.5 L 361 187.5 L 360.5 186 L 363 186.5 L 361 205.5 L 354 226.5 Q 346.3 241.8 333.5 252 L 318.5 261 L 306.5 265 Q 300.3 263.2 298.5 266 L 176.5 266 L 175.5 265 L 103.5 265 L 101.5 266 L 99.5 266 Q 93 265 92 269.5 L 92 277.5 L 93 278.5 L 93 356 L 46.5 356 L 45 354.5 L 45 195.5 L 43 190.5 L 44.5 184 Z "
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1159.5 186 L 1158.5 188 L 1159.5 186 Z "
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1343.5 187 L 1343.5 190 Q 1340.5 188.5 1343.5 187 Z "
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1154.5 188 L 1157 188.5 L 1154.5 189 L 1154.5 188 Z "
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1339.5 189 Q 1341.8 188.3 1341 190.5 L 1339.5 189 Z "
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 799.5 195 L 798.5 197 L 799.5 195 Z "
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 657.5 196 L 658.5 198 L 657.5 196 Z "
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 716.5 196 L 717 197.5 L 716.5 200 Q 713.8 198.8 716 197.5 L 716.5 196 Z "
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 861.5 199 L 860.5 201 L 861.5 199 Z "
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 713.5 200 L 712.5 202 L 713.5 200 Z "
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 714.5 202 L 713.5 204 L 714.5 202 Z "
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 863.5 205 L 864 206.5 L 863.5 209 Q 860.8 207.8 863 206.5 L 863.5 205 Z "
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 652.5 208 L 651.5 210 L 652.5 208 Z "
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 210 L 306.5 212 L 307.5 210 Z "
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 650.5 212 L 653 213.5 L 651.5 213 L 650.5 212 Z "
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 214 L 302.5 216 L 303.5 214 Z "
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 218 L 295 218.5 Q 293.8 221.3 288.5 220 L 288.5 219 L 293.5 218 Z "
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 866.5 222 L 867.5 224 L 866.5 222 Z "
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 538.5 225 L 539.5 227 L 538.5 225 Z "
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1156.5 225 L 1159 226.5 L 1157.5 226 L 1156.5 225 Z "
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 813.5 228 L 816 228.5 L 814.5 231 L 813.5 228 Z "
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 869.5 229 L 868.5 231 L 869.5 229 Z "
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 902.5 229 L 902 230.5 L 901.5 232 L 901 230.5 L 902.5 229 Z "
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 944.5 229 Q 947.5 230.5 944.5 232 L 944.5 229 Z "
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 482.5 230 L 485 231.5 L 483.5 231 L 481.5 232 L 482.5 230 Z "
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 536.5 230 L 537.5 232 L 536.5 230 Z "
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 898.5 230 L 897.5 232 L 898.5 230 Z "
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 662.5 249 L 665 249.5 L 662.5 250 L 662.5 249 Z "
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1108.5 249 L 1109.5 251 L 1108.5 249 Z "
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1168.5 250 L 1167.5 252 L 1168.5 250 Z "
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1115.5 251 L 1117 251.5 L 1114.5 253 L 1115.5 251 Z "
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1167.5 253 L 1169 253.5 L 1166.5 255 L 1167.5 253 Z "
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1278.5 253 L 1280 253.5 L 1277.5 255 L 1278.5 253 Z "
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 497.5 254 L 496.5 256 L 497.5 254 Z "
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 888.5 254 L 889 279.5 L 888 279.5 L 888.5 254 Z "
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1160.5 255 L 1161.5 257 L 1160.5 255 Z "
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1275.5 255 L 1274.5 257 L 1275.5 255 Z "
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 610.5 256 L 609.5 258 L 610.5 256 Z "
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 681.5 257 L 682.5 259 L 681.5 257 Z "
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 496.5 258 L 494.5 261 L 496.5 258 Z "
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1271.5 258 L 1270.5 260 L 1271.5 258 Z "
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 684.5 259 L 685.5 261 L 687 260.5 L 686 261.5 L 687.5 264 L 684 260.5 L 684.5 259 Z "
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1048.5 259 L 1047.5 261 L 1045 262.5 L 1044.5 264 L 1044 262.5 L 1048.5 259 Z "
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1236.5 259 L 1239 259.5 L 1238 260.5 L 1239.5 263 L 1236.5 259 Z "
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 599.5 265 L 602 265.5 Q 599.9 268.8 599.5 265 Z "
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1133.5 265 L 1132.5 267 L 1131 266.5 L 1133.5 265 Z "
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1246.5 266 L 1245.5 268 L 1246.5 266 Z "
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1134.5 267 L 1133.5 269 L 1134.5 267 Z "
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1040.5 269 L 1040 270.5 Q 1040.8 272.8 1038.5 272 L 1040.5 269 Z "
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1151.5 269 L 1151 270.5 L 1150.5 272 L 1150 270.5 L 1151.5 269 Z "
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1262.5 269 L 1262 270.5 L 1261.5 272 L 1261 270.5 L 1262.5 269 Z "
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 693.5 270 L 692.5 272 L 693.5 270 Z "
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1147.5 271 L 1145.5 274 L 1147.5 271 Z "
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1258.5 272 L 1257.5 274 L 1258.5 272 Z "
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 484.5 275 L 483.5 277 L 484.5 275 Z "
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1248.5 278 L 1249.5 280 L 1248.5 278 Z "
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 894.5 280 Q 896.8 279.3 896 281.5 L 894.5 280 Z "
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 631.5 281 L 633 281.5 L 630.5 283 L 631.5 281 Z "
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 888.5 282 L 889 286.5 L 888 286.5 L 888.5 282 Z "
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1102.5 282 L 1101.5 284 L 1102.5 282 Z "
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1293.5 282 L 1294 283.5 L 1292 284.5 L 1293.5 282 Z "
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1212.5 283 L 1211.5 285 L 1212.5 283 Z "
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 518.5 284 L 519.5 286 L 518.5 284 Z "
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 627.5 284 L 626.5 286 L 627.5 284 Z "
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1178.5 286 L 1181 287.5 L 1179.5 287 L 1178.5 286 Z "
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 888.5 288 L 889 343.5 L 888 343.5 L 888.5 288 Z "
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 926.5 288 L 927 383.5 L 926 383.5 L 926.5 288 Z "
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 665.5 291 L 666 343.5 L 665 343.5 L 665.5 291 Z "
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1066.5 291 L 1067 294.5 L 1066 294.5 L 1066.5 291 Z "
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1177.5 291 L 1178 293.5 L 1177 293.5 L 1177.5 291 Z "
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 515.5 296 L 517.5 299 L 515.5 296 Z "
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1177.5 296 L 1178 383.5 L 1177 383.5 L 1177.5 296 Z "
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 566.5 305 L 568 307.5 L 567 307.5 L 566.5 305 Z "
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1348.5 306 L 1348.5 309 Q 1345.5 307.5 1348.5 306 Z "
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 486.5 309 L 486.5 311 L 488 311.5 L 486.5 312 Q 483.5 310.5 486.5 309 Z "
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 571.5 309 L 574.5 313 Q 576.8 312.3 576 314.5 L 578 314.5 L 576.5 316 L 571 310.5 L 571.5 309 Z "
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1346.5 309 L 1348.5 312 L 1350 311.5 Q 1347.8 312.8 1350.5 314 Q 1351.7 311.8 1353 314.5 L 1351.5 316 L 1346 310.5 L 1346.5 309 Z "
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 488.5 313 L 489.5 315 L 488.5 313 Z "
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1263.5 313 L 1264.5 315 L 1263.5 313 Z "
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 491.5 317 L 498 324.5 L 497 324.5 L 491.5 317 Z "
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1266.5 317 L 1271.5 323 L 1269 322.5 Q 1271.3 321.3 1268.5 320 L 1267 320.5 L 1268 319.5 L 1266.5 317 Z "
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1355.5 321 L 1358 322.5 L 1356.5 322 L 1355.5 321 Z "
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 520.5 332 L 543 332.5 L 520.5 333 L 520.5 332 Z "
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1295.5 332 L 1320.5 332 L 1321 333.5 L 1319.5 333 L 1295.5 333 L 1295.5 332 Z "
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1323.5 333 L 1321.5 336 L 1323.5 333 Z "
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1325.5 334 L 1329 338.5 L 1326 336.5 L 1325.5 335 L 1324 335.5 L 1325.5 334 Z "
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1360.5 334 L 1361.5 336 L 1360.5 334 Z "
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 551.5 335 L 554 338.5 L 552 337.5 L 551.5 335 Z "
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 823.5 344 L 822.5 346 L 823.5 344 Z "
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 657.5 346 L 656.5 348 L 657.5 346 Z "
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 662 348 L 664 348.5 L 661 350.5 L 662 348 Z "
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1068.5 348 L 1072 350.5 L 1070.5 351 L 1068.5 348 Z "
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1323.5 348 L 1324.5 350 L 1323.5 348 Z "
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1102.5 350 L 1101.5 352 L 1102.5 350 Z "
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480.5 352 L 482.5 352 L 484 352.5 L 481.5 354 L 480.5 352 Z "
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 488.5 352 L 545 352.5 L 488.5 353 L 488.5 352 Z "
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 637.5 352 L 657 352.5 L 637.5 353 L 637.5 352 Z "
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 744.5 352 L 775 352.5 L 744.5 353 L 744.5 352 Z "
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 828.5 352 L 848 352.5 L 828.5 353 L 828.5 352 Z "
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1076.5 352 L 1099 352.5 L 1076.5 353 L 1076.5 352 Z "
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1257.5 352 L 1259 352.5 L 1256.5 354 L 1257.5 352 Z "
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1263.5 352 L 1320 352.5 L 1263.5 353 L 1263.5 352 Z "
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 359 L 789 361.5 L 787 360.5 L 787.5 359 Z "
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 884.5 360 L 885.5 362 L 884.5 360 Z "
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 693.5 361 L 694.5 363 L 693.5 361 Z "
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 708.5 361 L 707.5 363 L 708.5 361 Z "
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 597.5 363 Q 599.8 362.3 599 364.5 L 597.5 363 Z "
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 789.5 364 L 788.5 366 L 789.5 364 Z "
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 879.5 368 L 878.5 370 L 879.5 368 Z "
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 576.5 369 L 571.5 375 L 576.5 369 Z "
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 687.5 369 L 681.5 376 L 687.5 369 Z "
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1044.5 369 L 1050.5 376 L 1045 372 L 1044.5 369 Z "
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1351.5 369 L 1348 373.5 L 1349.5 376 L 1347 373.5 L 1351.5 369 Z "
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 714.5 370 L 717.5 374 L 714.5 370 Z "
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1128.5 370 L 1132 371.5 Q 1130.3 369.9 1128.5 373 L 1127 371.5 L 1128.5 370 Z "
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 606.5 373 L 607.5 375 L 606.5 373 Z "
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 792.5 373 L 793.5 375 L 792.5 373 Z "
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1130.5 373 L 1131.5 375 L 1130.5 373 Z "
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 568.5 376 L 570 376.5 L 567.5 378 L 568.5 376 Z "
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 610.5 376 L 611.5 378 L 610.5 376 Z "
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1121.5 376 L 1120.5 378 L 1121.5 376 Z "
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 869.5 377 L 868.5 379 L 869.5 377 Z "
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1053.5 377 L 1054.5 379 L 1053.5 377 Z "
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 724.5 378 L 727 379.5 L 725.5 380 L 724.5 378 Z "
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 804.5 378 L 807 379.5 L 805.5 380 L 804.5 378 Z "
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 615.5 379 L 614.5 381 L 615.5 379 Z "
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 679.5 379 L 678.5 381 L 679.5 379 Z "
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 564.5 380 L 565.5 382 L 564.5 380 Z "
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 726.5 381 Q 729.5 382.5 726.5 384 L 726.5 381 Z "
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 430.5 386 L 430.5 389 Q 427.5 387.5 430.5 386 Z "
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 433.5 387 L 434.5 389 L 433.5 387 Z "
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 427.5 388 L 428.5 390 L 427.5 388 Z "
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 439.5 388 L 438.5 390 L 439.5 388 Z "
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380 0 L 385 0 L 385 2 L 380 2 L 380 0 Z "
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 480 0 L 487.5 0 L 492 2.5 L 480 3 L 480 0 Z "
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 635 0 L 640.5 0 L 641 1.5 Q 640.3 3.8 636.5 3 L 635 0 Z "
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 719.5 0 L 727.5 0 L 728 2 L 720.5 2 L 719.5 0 Z "
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 788 0 L 800 0.5 L 785.5 6 L 782.5 3 L 737.5 3 L 736 6 L 728.5 6 L 728 4 Q 733.5 4.8 736.5 2 L 788 2 L 788 0 Z "
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 896 0 L 903.5 0 L 908 2.5 L 898.5 3 L 896 2 L 896 0 Z "
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1160 0 L 1167.5 0 L 1169.5 2 L 1326.5 2 L 1328.5 0 L 1338 0 L 1337.5 2 L 1328.5 2 L 1327.5 3 L 1168.5 3 L 1167.5 2 L 1160 2 L 1160 0 Z "
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 1 Q 374.5 -0.5 376 2.5 L 375.5 4 L 17.5 4 Q 16 6.5 14.5 3 L 10.5 5 L 6.5 5 L 4 7.5 L 5.5 10 L 8.5 11 L 11.5 9 L 16.5 10 L 374 10.5 L 370.5 13 L 17.5 13 Q 16.3 10.8 11.5 12 L 7.5 14 L 6 14.5 L 6 380.5 L 6 382.5 Q 6.7 385.1 4 384 L 4 16.5 L 2 16 L 2 14.5 L 4 11.5 L 0 10 L 0 4 L 2.5 4 L 4.5 2 L 367.5 2 L 368.5 1 Z "
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 496.5 2 L 628.5 2 L 632 3.5 L 623.5 4 L 622.5 3 L 496.5 3 L 496.5 2 Z "
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 912.5 2 L 960 2.5 L 912.5 3 L 912.5 2 Z "
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1056.5 2 L 1104 2.5 L 1056.5 3 L 1056.5 2 Z "
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 432 4 L 437.5 4 Q 438.6 6.7 442 6 Q 441.3 9.4 444 10.5 L 444 15 L 446 15.5 L 446 383.5 L 448 384 L 448 385.5 Q 446.3 389.5 440 388 L 440 384 L 444 383.5 L 444 16 L 440 16 L 440 14.5 L 438.5 12 L 440 12.5 L 438.5 10 L 436.5 10 Q 432.5 10.5 432 7.5 L 432 4 Z "
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 961.5 4 Q 970.5 2.5 972 8.5 L 972 14.5 Q 975 15.5 974 20.5 L 972 25.5 L 972 29.5 L 971.5 31 L 970 27.5 L 970 25.5 Q 973 23.5 972 17.5 L 968 16 Q 969.3 11.4 966.5 10 L 962.5 8 L 896 7.5 L 912.5 6 L 913.5 7 L 958.5 7 L 961.5 4 Z "
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1152 4 Q 1158 2 1156 8 Q 1150 10 1152 4 Z "
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1340 4 Q 1346 2 1344 8 L 1340 5.5 L 1340 4 Z "
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 631.5 5 L 630.5 7 L 631.5 5 Z "
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 720.5 5 Q 725 4 726 6.5 L 720.5 9 L 719 6.5 L 720.5 5 Z "
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 374.5 6 L 383.5 6 L 385 7.5 L 382.5 9 L 381.5 8 L 373 7.5 L 374.5 6 Z "
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 493.5 6 L 497.5 7 L 623 7.5 L 480.5 8 L 480.5 7 L 492.5 7 L 493.5 6 Z "
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 795.5 6 L 801 6 L 801 8.5 Q 799.4 11.5 794 10 L 795.5 6 Z "
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1166.5 6 L 1169.5 7 L 1326.5 7 L 1328.5 6 L 1331 7 L 1331 9 Q 1333.7 7.9 1333 10.5 L 1331.5 10 L 1328.5 11 L 1327.5 8 L 1168 8.5 L 1168.5 10 Q 1166.3 10.8 1167 8.5 L 1166 8.5 Q 1166.8 10.8 1164.5 10 L 1160 13.5 L 1162 17.5 L 1162 47 L 1160 46.5 L 1160 17.5 L 1156 16 L 1156 47.5 L 1157.5 48 L 1159 47.5 L 1158.5 52 L 1154 46.5 L 1154 16.5 L 1158.5 10 L 1161.5 11 L 1161 9.5 Q 1160.3 7.3 1162.5 8 L 1162.5 10 Q 1164.8 10.8 1164 8.5 L 1166.5 6 Z "
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 737.5 7 L 784.5 7 L 787 9.5 L 784.5 10 L 782.5 8 L 737.5 8 L 737.5 7 Z "
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1056.5 7 L 1120 7.5 L 1056.5 8 L 1056.5 7 Z "
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 790.5 8 L 792 12 Q 788.2 13.2 790.5 8 Z "
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1334.5 9 L 1341 13.5 L 1342 15.5 L 1342 46.5 L 1343 47.5 L 1340.5 49 L 1339.5 48 L 1337 49.5 L 1336 47.5 L 1337.5 47 L 1339 47.5 L 1339 17.5 L 1337.5 17 L 1334 11.5 L 1334.5 9 Z "
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 481.5 10 L 483.5 10 L 486 12.5 L 482.5 13 L 480.5 13 Q 477.9 13.7 479 11 L 481.5 10 Z "
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 624 10 L 630 10 L 630 12 L 624 12 L 624 10 Z "
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 730.5 10 Q 737.4 8 736 12 L 730.5 11 L 728.5 12 L 728.5 11 L 730.5 10 Z "
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 897.5 10 L 898 12 L 902 12.5 L 898.5 13 L 896.5 13 Q 893.9 13.7 895 11 L 897.5 10 Z "
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1113.5 10 L 1114 12 Q 1111.3 13.9 1104.5 13 L 1104.5 12 Q 1111.8 13.7 1113.5 10 Z "
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1116 10 L 1120 11.5 L 1117.5 12 Q 1114.9 12.7 1116 10 Z "
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 11 L 382.5 12 Q 383.8 9.8 385 12.5 Q 385.9 15.5 381.5 14 L 380.5 11 Z "
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 721.5 11 Q 725.3 10.3 726 12.5 L 724 12.5 L 723.5 14 L 722 13.5 L 720.5 17 L 719 12 L 721.5 11 Z "
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 634.5 12 L 636.5 13 L 641 12 Q 642.5 16.5 638 15 L 637.5 13 L 635.5 13 L 634.5 12 Z "
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 793 13 L 801 14 L 799.5 17 L 797.5 18 Q 796.4 15.3 793 16 L 793 13 Z "
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1039 15 Q 1043.9 13.4 1042 19 Q 1037.1 20.6 1039 15 Z "
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1045.5 15 L 1049.5 17 L 1050.5 15 L 1051.5 17 Q 1049.3 16.3 1050 18.5 L 1048 19.5 L 1047 16 L 1045.5 15 Z "
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 16 L 385 17.5 L 383.5 19 L 381 18.5 L 382.5 16 Z "
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 418 16 L 420 16.5 L 420 384 L 418 383.5 L 418 16 Z "
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 422 16 L 424 16.5 L 424 384 L 422 383.5 L 422 16 Z "
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 428.5 16 L 429 383.5 L 428 383.5 L 428.5 16 Z "
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8.5 17 L 9 19.5 L 8 19.5 L 8.5 17 Z "
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 436 17 L 438 17.5 L 438 384 L 436 383.5 L 436 17 Z "
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 383.5 21 L 385 25 L 382.5 26 L 381 23 Q 383.8 24 383.5 21 Z "
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 719 22 Q 721.7 20.9 721 23.5 L 719 24.5 L 719 22 Z "
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 796.5 22 L 797 25 L 801 27.5 L 800.5 33 L 798 32 L 799 27.5 Q 794.7 26.3 796.5 22 Z "
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 968.5 22 L 969 23.5 L 967 24.5 L 968.5 22 Z "
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1046.5 23 Q 1049.5 23.5 1049 27.5 L 1048 27.5 L 1048 26 L 1044 26 L 1045.5 30 L 1047 29.5 Q 1048.1 32.8 1045.5 32 L 1044 29 L 1039 28 Q 1037.5 24.3 1040.5 25 L 1042 24.5 Q 1041.3 26.8 1043.5 26 L 1046 25 L 1046.5 23 Z "
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8.5 24 L 9 32.5 L 7 31.5 L 8.5 24 Z "
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 975.5 26 Q 978.1 25.2 977 28.5 L 976 28.5 L 975.5 27 L 974.5 29 L 974 27.5 L 975.5 26 Z "
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 30 L 385 31.5 L 382 32.5 L 383 33.5 L 383 366.5 L 381 367.5 L 381.5 30 Z "
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 706 31 Q 710.5 29.3 709 34.5 L 706 36 L 706 31 Z "
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 714 31 Q 717 30 716 33 Q 713 34 714 31 Z "
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 806 32 L 812 32 L 812 36 L 806 34 L 806 32 Z "
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1039.5 32 L 1042.5 37 L 1044.5 36 L 1044.5 37 Q 1041.9 36.2 1043 39.5 L 1042 39.5 L 1039 35.5 L 1039.5 32 Z "
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 715.5 34 Q 718.1 33.2 717 36.5 L 716 36.5 L 715.5 34 Z "
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 973.5 35 L 974 38.5 L 973 38.5 L 973.5 35 Z "
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 814 36 L 816 36 L 816 42 L 814 42 L 814 36 Z "
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 704.5 37 L 707 42 L 709.5 41 L 712 46.5 L 708 48 Q 709.8 43.5 704.5 45 Q 701.8 43.8 703 38.5 L 704.5 37 Z M 705 40 L 704 44 L 705 44 L 705 40 Z "
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 712 37 L 714 37.5 Q 711.5 39 715 40.5 Q 715.8 42.8 713.5 42 L 712 38.5 L 712 37 Z "
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 39 L 321 39.5 L 320 42 L 257.5 42 L 257 40 L 318.5 40 L 319.5 39 Z "
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 801 39 L 806.5 39 Q 805.9 41.8 809 41 L 809 47.5 L 812 48 L 812 51.5 L 810 52.5 L 810 50 L 808 50 L 808 47 Q 805 48.3 806 44.5 L 805 42.5 L 806 42.5 L 806.5 44 L 807 41 Q 803.3 39.5 804 42.5 L 803 42.5 Q 803.7 39.9 801 41 L 801 39 Z "
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 42 L 252 43.5 L 251.5 46 L 240 46 L 240.5 43 L 244.5 44 L 249.5 42 Z "
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 43 L 232.5 44 L 236.5 43 L 234.5 46 L 232.5 45 L 228.5 46 L 230.5 43 Z "
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 44 L 321 48.5 L 320 48.5 L 319.5 44 Z "
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 981.5 47 Q 983.5 51 985.5 47 L 987 47.5 L 986 50 Q 983.3 48.9 984 51.5 L 983 51.5 L 981.5 48 L 980 48.5 L 981.5 47 Z "
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 990 47 L 993 48.5 L 991.5 51 L 990 47 Z "
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1023 47 L 1026 47 L 1026 51 L 1030 53 L 1032.5 47 L 1034 47.5 L 1032 48.5 L 1032 50.5 L 1033 54.5 Q 1028.6 57.1 1028.5 64 L 1026 57.5 L 1027 54.5 L 1026 51 L 1023 49.5 L 1023 47 Z "
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1036 47 L 1039 47.5 L 1038.5 50 L 1036 48.5 L 1036 47 Z "
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 48 Q 223.1 47.3 222 50 L 218 49.5 L 220.5 48 Z "
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 706.5 48 L 707.5 50 Q 704.7 50.7 706.5 48 Z "
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 814 48 Q 818 46.6 816 53.5 L 815 57.5 L 816 59.5 L 812 62.5 L 811.5 65 L 809 64.5 L 810 59.5 L 813.5 54 Q 816.5 54.9 815 50.5 L 814 48 Z "
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 710.5 50 L 711 52 L 708 51.5 L 710.5 50 Z "
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1035.5 50 L 1036 53 Q 1033.3 54.1 1034 51.5 L 1035.5 50 Z "
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1333.5 50 L 1336 51 L 1336 55 L 1334.5 55 L 1333 55.5 L 1333.5 50 Z "
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1151.5 51 L 1153.5 54 Q 1149.1 55.1 1151.5 51 Z "
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 52 Q 219.8 50.5 218 55 L 213.5 56 L 213 53.5 L 214.5 52 Z "
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 708.5 53 L 709 55.5 L 705 57.5 L 707 58 L 706.5 62 L 704 57.5 L 704 55.5 L 704.5 54 L 708 56 L 708.5 53 Z "
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1158.5 53 L 1160 56 L 1157 56.5 L 1161 61.5 L 1157.5 62 Q 1153.2 60.3 1156 58.5 Q 1155.3 53.8 1158.5 53 Z "
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 54 L 223.5 56 L 225 55.5 L 225 60 Q 221.3 58.5 222 61.5 L 219.5 65 L 216 63.5 L 222 60 L 220.5 56 Q 217.7 56.7 219.5 54 Z "
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1339.5 54 L 1340.5 58 L 1341 54 Q 1346.6 52.1 1345 57 L 1340.5 59 L 1338 58 L 1339 64 L 1334.5 65 L 1334.5 64 Q 1337.5 64.9 1336 60.5 L 1339 56.5 Q 1336.8 55.2 1339.5 54 Z "
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 985.5 55 L 986 57 Q 988.7 58.1 988 55.5 L 989.5 56 L 992 57.5 L 991 60 L 987.5 62 L 986 61.5 L 985.5 64 L 985 61.5 L 986 57.5 L 985.5 55 Z "
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1151 56 Q 1155.1 54.7 1154 58 Q 1149.9 59.3 1151 56 Z "
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1162.5 56 L 1163.5 58 Q 1160.7 58.7 1162.5 56 Z "
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208 57 Q 213.6 55.1 212 60 Q 206.4 61.9 208 57 Z "
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 57 L 218 60 L 214 59.5 L 216.5 57 Z "
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 634 57 Q 637 56 636 59 L 631.5 60 L 631.5 59 Q 635.3 60 634 57 Z "
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1254.5 58 L 1256 60.5 L 1253 65 L 1250.5 66 Q 1250.8 61.8 1248 60.5 Q 1253 61 1254.5 58 Z "
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1333.5 58 L 1334 60.5 L 1332.5 62 L 1330 62.5 Q 1332.3 63.7 1329.5 65 L 1327.5 66 L 1329 63.5 L 1330.5 61 L 1333 60.5 Q 1330.8 59.3 1333.5 58 Z "
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 59 L 207 62 L 202.5 64 L 202.5 63 Q 204.8 63.8 204 61.5 L 206.5 59 Z "
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 638.5 60 L 641 61.5 L 636 64 Q 634.5 60.3 637.5 61 L 638.5 60 Z "
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 624.5 61 L 628 61.5 L 624.5 62 L 624.5 61 Z "
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 632.5 61 L 634 62.5 L 633.5 65 Q 630 65.8 632.5 61 Z "
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1343.5 61 L 1345 65 Q 1340.9 66.7 1342 62.5 L 1343.5 61 Z "
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 62 Q 215.9 60.5 215 63.5 L 211.5 65 Q 208.5 63.5 211.5 62 Z "
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 690 63 L 693 64.5 Q 693.6 69.9 692 72 L 689 70.5 L 690 63 Z "
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 696 63 L 701 63 L 701 65.5 Q 699.8 68.8 696 68 L 696 63 Z "
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1160.5 63 L 1163 63.5 L 1160 65 L 1160.5 63 Z "
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1164.5 63 L 1167 63.5 L 1164.5 64 L 1164.5 63 Z "
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1232.5 63 Q 1237 62 1238 64.5 L 1232.5 67 L 1231 64.5 L 1232.5 63 Z "
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1246.5 63 L 1246 64.5 Q 1245.3 66.8 1247.5 66 L 1247.5 67 Q 1243.8 68.3 1245 64.5 L 1246.5 63 Z "
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 543.5 64 L 544 78.5 L 545 80.5 L 542 82 L 543 78.5 L 543.5 64 Z "
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1025.5 64 L 1026 66.5 L 1025.5 69 Q 1023.3 69.8 1024 67.5 L 1023 65.5 L 1025 65.5 L 1025.5 64 Z "
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 65 L 202 68 Q 204.7 66.9 204 69.5 L 203 75 L 200 73.5 L 199 70.5 Q 201.8 69.3 201.5 65 Z "
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 815.5 65 L 816 66.5 Q 813.5 68 817 69.5 L 816.5 74 L 814 73.5 L 814 71.5 L 815 68.5 L 815 66.5 L 815.5 65 Z "
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 704.5 66 L 705 67.5 L 703 73 L 700.5 74 L 701 72.5 Q 701.3 67.8 704.5 66 Z "
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1240.5 66 L 1244 67.5 L 1238.5 75 L 1236.5 76 L 1236 74 Q 1232.2 75 1231 72.5 L 1232.5 69 L 1236.5 72 L 1240.5 66 Z "
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1252.5 66 L 1253 68.5 L 1252 68.5 L 1252.5 66 Z "
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 988.5 67 L 991 70.5 L 990.5 72 L 992 72.5 L 989 73 L 990 70.5 L 987 68.5 L 988.5 67 Z "
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1030.5 67 L 1030 68.5 L 1028.5 71 L 1028 68 L 1030.5 67 Z "
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1325.5 67 L 1327.5 67 Q 1330.1 66.2 1329 69.5 L 1327 69.5 Q 1328 73.3 1325 72 Q 1326.1 69.3 1323.5 70 L 1323.5 69 Q 1326 69.7 1325.5 67 Z "
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 71 L 209 74.5 L 206 76 Q 207 79.8 204.5 81 L 204 75.5 L 207.5 71 Z "
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1246 71 L 1249 72.5 L 1246 74 L 1246 71 Z "
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1319.5 73 L 1323 77.5 L 1322 80 L 1319 79.5 L 1320 76.5 L 1319.5 73 Z "
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 695.5 74 L 694.5 76 L 695.5 74 Z "
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 697.5 74 L 700 75.5 Q 701.3 80.3 698 79 L 699 76.5 L 697.5 74 Z "
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1024.5 74 L 1025.5 76 L 1024 76.5 L 1025 79.5 L 1024.5 81 L 1023 75.5 L 1024.5 74 Z "
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1326 74 Q 1330.9 72.2 1329 78.5 Q 1327.5 81.5 1326 78.5 L 1326 74 Z "
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196 75 Q 198.7 73.9 198 76.5 L 200 79.5 Q 199 82 194.5 81 L 194.5 80 Q 198.3 81.3 197 77.5 L 196 75 Z "
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 690.5 77 Q 692.3 80.1 694 78.5 Q 695.3 84.6 692.5 84 Q 688.5 82.5 690.5 77 Z "
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1234 77 L 1237 78.5 Q 1237.9 81.9 1232.5 80 L 1232.5 79 Q 1235.1 79.7 1234 77 Z "
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1241.5 77 L 1241 80.5 L 1240.5 82 L 1240 78.5 L 1241.5 77 Z "
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1317.5 78 L 1316.5 80 L 1317.5 78 Z "
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 79 L 246 81.5 L 240.5 82 Q 237.5 80.5 240.5 79 Z "
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 79 L 321 82 Q 318.3 83.1 319 80.5 L 320.5 79 Z "
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 816.5 79 L 817 81 L 815 80.5 L 816.5 79 Z "
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 822.5 79 L 825 80.5 L 823.5 83 Q 821.3 83.8 822 81.5 Q 819.8 80.3 822.5 79 Z "
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 993 79 Q 997.5 77.5 996 82 Q 991.5 83.5 993 79 Z "
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 998 79 Q 1002.5 77.3 1001 82.5 Q 1002.2 85 1006 84 L 1005 88.5 L 1006 91.5 L 1003.5 96 L 1003 92.5 L 1004 90.5 L 1000 88 L 1000 82.5 L 998 79 Z "
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1006 79 Q 1009.3 77.7 1008 82.5 L 1006 81.5 L 1006 79 Z "
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1012 79 Q 1018.4 76.7 1016 84.5 L 1017.5 84 L 1021.5 81 L 1023 85.5 L 1020 86.5 L 1021 88.5 L 1018.5 90 L 1016 86 L 1013 84.5 L 1012 79 Z M 1021 83 L 1019 85 L 1021 85 L 1021 83 Z "
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 80 L 252 80.5 L 248.5 81 L 248.5 80 Z "
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 755.5 80 L 757.5 81 L 759 80.5 L 755 82 L 755.5 80 Z "
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1233.5 81 L 1237.5 84 L 1238.5 82 L 1239 83.5 L 1238.5 86 Q 1237.3 83.8 1236 86.5 L 1235.5 88 L 1234.5 86 L 1236 85.5 L 1233.5 82 L 1231.5 86 L 1231 82 L 1233.5 81 Z "
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 82 Q 258.3 81 257 84 L 253 83.5 L 254.5 82 Z "
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 826 82 L 830 84.5 Q 831.5 88.9 828.5 88 L 826 89 Q 824.3 95.6 828 97.5 L 826 98 Q 826.8 94.9 824 95.5 L 824 88.5 L 826 82 Z "
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 997.5 82 L 998 83.5 L 997.5 86 L 995.5 87 L 996 85.5 L 997.5 82 Z "
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 817.5 83 L 820 84 L 819.5 89 Q 815.9 87.1 817.5 83 Z "
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 84 L 623.5 84 L 624 86 L 545.5 86 L 543 88.5 Q 544.3 92.7 539.5 91 L 539.5 90 L 542 89.5 L 539 88.5 Q 544.1 88.1 545.5 84 Z "
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1008 84 Q 1010.7 82.9 1010 85.5 L 1012 89.5 L 1009 91.5 Q 1009.6 86.1 1008 84 Z "
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 754 85 L 758 87.5 L 757.5 92 L 757 89 Q 752.5 87.3 754 92.5 L 751 94 L 754 85 Z "
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 760.5 85 L 760.5 88 Q 757.5 86.5 760.5 85 Z "
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1312.5 85 L 1310.5 88 L 1309 87.5 L 1312.5 85 Z "
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 626 86 L 634 86 L 634 94 L 628 89.5 L 628.5 88 Q 624.8 89 626 86 Z M 631 88 L 629 90 L 631 90 L 631 88 Z "
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 696.5 86 L 697 88.5 L 696 88.5 L 696.5 86 Z "
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189 87 L 192 87.5 L 190 93 L 187.5 94 L 187 91.5 L 190 89.5 L 189 87 Z "
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 691.5 88 L 695 92.5 L 695 96 L 692 97.5 L 692.5 99 L 689.5 98 L 690 99.5 L 691 106 L 689 105.5 L 689.5 104 L 687 102.5 Q 685.8 97.3 688.5 96 L 692 97 L 692 92 L 690.5 92 L 688 93.5 Q 687.3 89.8 689.5 89 L 691 89.5 L 691.5 88 Z "
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 998.5 89 L 999 91 L 997 90.5 L 998.5 89 Z "
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1311.5 89 Q 1313.8 89.8 1313 93.5 L 1312 93.5 L 1311.5 89 Z "
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 544 90 L 623.5 90 L 624 92 L 544.5 92 L 544 90 Z "
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 830.5 91 L 833 98 L 830 98 L 830.5 91 Z "
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1013.5 92 L 1014 96 Q 1011.3 97.1 1012 94.5 L 1013.5 92 Z "
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1308 92 Q 1311 91 1310 94 Q 1307 95 1308 92 Z "
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 762.5 93 L 763 95.5 L 767 105.5 L 765.5 105 Q 762.9 105.8 764 102.5 L 761 102.5 L 758 107.5 L 758 113 Q 755.3 114.1 756 111.5 L 760 102 L 756.5 104 L 757 102.5 L 758.5 99 Q 761.1 98.2 760 101.5 L 762 100.5 Q 763.9 95.1 760.5 96 L 762.5 93 Z "
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1018.5 93 L 1018.5 96 L 1016 95.5 L 1018.5 93 Z "
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 756.5 94 L 757 95.5 L 754.5 99 Q 752.3 99.8 753 97.5 L 756.5 94 Z "
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1226.5 95 L 1228 95.5 L 1227.5 98 L 1225 97.5 L 1226.5 95 Z "
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1308.5 95 L 1309 96.5 L 1306 98 Q 1304.9 95.3 1307.5 96 L 1308.5 95 Z "
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 96 L 192 97.5 L 190 98 L 189 102.5 L 189.5 104 Q 187.3 103.3 188 99.5 L 189.5 96 Z "
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 96 L 232 99.5 L 231 99.5 L 231.5 96 Z "
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 636 96 L 638 96.5 L 638 126.5 L 639 128.5 L 635 130 L 636 126.5 L 636 96 Z "
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1005.5 96 Q 1007.8 95.3 1007 97.5 L 1009.5 98 L 1011 97.5 L 1010.5 96 Q 1013.3 97.2 1011 98.5 L 1012 103.5 L 1011.5 106 L 1008 104.5 L 1010 104 Q 1010.8 100.2 1007.5 99 L 1006 99.5 L 1006.5 101 Q 1003.7 99.8 1006 98.5 L 1005.5 96 Z "
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1301 96 L 1304 96.5 L 1302 97 L 1302 101 Q 1299.3 99.9 1300 102.5 L 1298 103.5 L 1298.5 102 L 1297 101.5 L 1301 98.5 L 1301 96 Z "
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 97 L 228 98.5 L 229 107.5 L 226.5 109 L 225 106.5 L 226 105.5 L 226.5 97 Z "
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 951 97 Q 953.7 95.9 953 98.5 L 951 99.5 L 951 97 Z "
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1218 98 L 1224 99.5 L 1223 101.5 L 1226 100.5 L 1225 103 Q 1222.3 101.9 1223 104.5 L 1219.5 107 L 1221 104.5 L 1220 103.5 Q 1220.7 100.9 1218 102 L 1218 98 Z M 1220 100 Q 1219 103 1222 102 Q 1223 99 1220 100 Z "
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 823.5 99 L 824 102.5 L 823 102.5 L 823.5 99 Z "
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 828 99 Q 831 97.8 830 101.5 L 828 102.5 L 828 99 Z "
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1307.5 101 L 1310 102.5 L 1308.5 105 L 1304 106 L 1302.5 112 Q 1297.8 109.8 1302 107.5 Q 1300.5 103.1 1303.5 104 L 1307.5 101 Z "
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 752.5 102 Q 755 103 754 107.5 L 751 109 L 752.5 102 Z "
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 954.5 103 Q 957.5 105 957 110.5 L 954 112.5 L 956 108.5 Q 953 106.7 954.5 103 Z "
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1062.5 103 L 1063 105.5 L 1062 105.5 L 1062.5 103 Z "
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 826.5 104 Q 829.3 105.3 827 106.5 L 826.5 108 L 825 105.5 L 826.5 104 Z "
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 831.5 105 Q 834.1 104.2 833 107.5 Q 831.5 110.5 830 107.5 L 831.5 105 Z "
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1008.5 106 L 1009.5 108 L 1007.5 109 L 1008 107.5 L 1008.5 106 Z "
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1216.5 106 Q 1219.3 107.3 1217 108.5 Q 1217.7 111.1 1215 110 L 1216.5 106 Z "
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1293.5 106 L 1294 108.5 Q 1294.7 111.5 1291 110 L 1293.5 106 Z "
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 107 Q 194 108.2 193 112 L 190 110.5 L 191.5 107 Z "
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1296 108 Q 1299 107 1298 110 Q 1295 111 1296 108 Z "
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 687 109 Q 690 107.8 689 111.5 L 687 110.5 L 687 109 Z "
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1060.5 109 L 1062 109 L 1062 113 L 1060 113.5 L 1060 222.5 L 1057.5 227 L 1055 226.5 L 1055 223 L 1058 222.5 L 1058 113.5 L 1059.5 113 L 1061 110.5 L 1060.5 109 Z "
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1309.5 109 L 1310 113 L 1306 112.5 L 1309 112 L 1309.5 109 Z "
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224 110 L 228 112.5 Q 229 117 226.5 118 L 224 110 Z "
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 750.5 110 Q 754 112 753 118.5 Q 751.5 121.5 750 118.5 L 749 114.5 L 750.5 110 Z "
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 761.5 110 L 762 112 L 764 112.5 L 762.5 113 L 761.5 110 Z "
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 674.5 111 L 677 112.5 L 675.5 116 L 674.5 111 Z "
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 678.5 111 L 681 115.5 L 678 113.5 L 678.5 111 Z "
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 684 111 Q 686.7 109.9 686 112.5 L 685.5 114 Q 687.8 113.3 687 115.5 L 685.5 115 L 684 115 L 684 111 Z "
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 827 111 L 830 112.5 L 829.5 115 L 827 111 Z "
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1200.5 111 L 1203 112.5 L 1203 114 L 1199 114 L 1200.5 111 Z "
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1208 111 L 1214 111.5 L 1209.5 115 L 1208 111 Z "
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 745.5 112 L 747 116.5 L 746 121 L 743 119.5 L 744 116.5 Q 743.3 112.8 745.5 112 Z "
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1295.5 112 L 1296 114.5 L 1294 113.5 L 1295.5 112 Z "
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 958.5 113 L 961.5 120 L 963 120.5 L 960 121 L 960.5 124 L 961 122 L 963 122.5 L 959 130.5 L 960 131.5 L 960 147 L 962 147 L 962 142 L 965 142 L 965 138.5 Q 961.9 136.8 963.5 135 Q 961.3 135.8 962 133.5 L 963 130.5 Q 962.3 127.9 965 129 L 966 131.5 L 964 134.5 L 966 134.5 L 966.5 137 L 969 135.5 L 969 137.5 L 968 142 Q 964.7 140.7 966 145.5 L 963 146.5 L 964 153.5 L 965.5 155 L 969 153.5 L 968.5 152 L 972.5 158 Q 976.9 156.5 976 159.5 Q 974.4 162.5 969 161 L 968 156 Q 963.5 154.3 965 159.5 Q 963.8 162 960 161 L 960 222.5 L 961 223.5 L 961 232 Q 957.2 231.3 956 234.5 L 953.5 238 L 947.5 237 L 944.5 238 L 942.5 236 L 913.5 236 L 912 236.5 Q 912.8 232.8 910.5 232 Q 905.7 230.8 904.5 233 L 903.5 231 L 902 231.5 L 903.5 229 L 907.5 230 Q 909 227.5 910.5 231 L 912.5 232 L 942.5 232 L 944 233.5 Q 942.8 237.3 946.5 236 L 948.5 233 L 952.5 235 L 956 232.5 Q 954.9 229.2 957.5 230 L 960 229 Q 961 224.8 958 225.5 L 958.5 113 Z M 962 150 L 959 154 L 961 158 L 963 155 Q 965 149 962 150 Z "
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 114 L 232 119.5 L 228 127.5 L 228.5 129 L 225 127.5 L 226.5 124 Q 231.1 125.3 229 119.5 L 230.5 114 Z "
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 673.5 114 Q 675.9 117.1 675 123.5 L 674 129 Q 669.5 130.8 671 125.5 L 674 121 L 671 119.5 Q 670.3 114.8 673.5 114 Z "
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1203.5 115 L 1205.5 115 L 1207 115.5 L 1206 119.5 L 1207 121.5 L 1206 121.5 Q 1206.9 118.5 1202.5 120 L 1203 118.5 L 1204 116.5 L 1203.5 115 Z "
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 682.5 116 L 683 118 Q 686 116.8 685 120.5 L 683.5 123 L 683 121 L 681 120.5 L 682.5 116 Z "
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1291.5 116 Q 1294.3 117.3 1292 118.5 L 1293 122.5 L 1291.5 122 Q 1287.8 123.3 1289 119.5 L 1291.5 116 Z "
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 117 L 237 120 Q 239.7 118.9 239 121.5 Q 242.8 123.2 239.5 125 L 236 122.5 L 236.5 117 Z "
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 679.5 117 L 680 126 L 682 126.5 L 678 129 Q 676.6 121.3 679.5 117 Z "
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 829 117 L 832 117.5 L 831 119.5 L 831.5 121 L 829 117 Z "
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 770 120 L 773 121.5 L 772.5 125 L 771.5 123 L 769 124.5 L 770 120 Z "
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1199.5 120 L 1200.5 123 L 1202.5 121 L 1205 121.5 L 1204 124.5 L 1205 127.5 L 1204 127.5 L 1203.5 125 L 1202 125.5 Q 1202.8 123.3 1200.5 124 Q 1198 123 1199.5 120 Z "
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1054 121 L 1057 122.5 L 1056.5 128 L 1054 124.5 L 1054 122.5 L 1054 121 Z "
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1281.5 121 L 1284 122.5 Q 1281.8 123.7 1284.5 125 L 1288 123 L 1290 129 L 1286 129 L 1286 127.5 Q 1284.6 123.4 1279 123.5 L 1281.5 121 Z "
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 746.5 122 L 750 125.5 L 749 126.5 L 750 128.5 L 746.5 133 L 742 132.5 L 744 129.5 L 743.5 128 L 746 126.5 L 747 123.5 L 746.5 122 Z "
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 767.5 123 L 769 126.5 L 768.5 128 L 770 128.5 L 770 130.5 Q 771.3 135.8 768.5 137 Q 765.8 135.8 767 130.5 L 767 128.5 L 767.5 123 Z "
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 124 L 236 129 Q 232.7 130.3 234 125.5 L 235.5 124 Z "
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242 125 L 244 125.5 L 242 126.5 L 242 125 Z "
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1293 125 L 1297 126 L 1295.5 129 L 1293 127.5 L 1293 125 Z "
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 833 127 L 835 127.5 L 833.5 130 L 833 127 Z "
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1198 127 Q 1201.3 125.9 1200 130 Q 1196.7 131.1 1198 127 Z "
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1049 128 Q 1052.8 126.5 1052 129.5 L 1057 133.5 L 1055.5 137 L 1054 134 L 1052 134 L 1052 130 Q 1047.9 131.3 1049 128 Z "
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1190 128 Q 1193 127 1192 130 L 1195 130 L 1195 132.5 L 1191 134 Q 1192.7 139.2 1189 138 L 1188 135.5 Q 1191.5 135 1191 130.5 L 1190 128 Z "
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104 129 L 112 129.5 L 102 133.5 L 103 135.5 L 100.5 136 L 95.5 137 L 94.5 135 L 104 130.5 L 104 129 Z "
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163 129 L 166 130.5 Q 165 135 167.5 136 Q 169.8 135.3 169 137.5 L 168 141.5 L 170 144.5 L 168.5 145 L 166 139 L 162 137.5 L 163 129 Z "
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 129 L 292 129.5 L 288.5 130 L 288.5 129 Z "
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 630 130 Q 633 128.8 632 132.5 L 635.5 134 L 638 132.5 L 639 135.5 L 636 136 L 637.5 140 L 641 141.5 L 633.5 142 L 632.5 140 Q 635.1 140.8 634 137.5 L 630 135.5 L 630 130 Z "
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 774.5 130 L 776 134.5 L 775 137 L 772 135.5 L 774 135.5 L 773 131.5 L 774.5 130 Z "
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 838 130 L 840 130.5 L 840 132.5 L 838.5 136 L 838 130 Z "
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 131 Q 312.6 130.4 314 133.5 L 309.5 134 L 307.5 131 Z "
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 843.5 132 L 844 135.5 L 843 135.5 L 843.5 132 Z "
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1047.5 132 L 1049 134.5 L 1046 136 L 1045.5 139 L 1045 136.5 L 1048 134.5 L 1047.5 132 Z "
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1275.5 132 L 1276 134 Q 1278.7 135.1 1278 132.5 L 1280 133.5 L 1281 139 L 1278 139 L 1278 137 Q 1275.3 138.1 1276 135.5 Q 1274.8 132.8 1273.5 135 L 1272 135.5 L 1276 138.5 L 1276 142 Q 1279.3 140.9 1278 145 L 1276 145 L 1276 142 Q 1273.3 143.1 1274 140.5 L 1270 138 L 1272.5 133 Q 1274 135.5 1275.5 132 Z "
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 133 L 93 134.5 L 91.5 134 L 90.5 133 Z "
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 676.5 133 L 679 138 Q 673.6 139.7 676.5 133 Z "
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106 134 Q 111.4 132.5 113 135.5 L 112.5 138 L 112 136 L 107.5 138 L 106 134 Z "
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 134 Q 302.8 133.3 302 135.5 L 303 135.5 Q 302.3 133.3 304.5 134 L 307 135.5 L 304 136.5 L 309 138.5 Q 307.6 141.3 303 140 L 303 138 Q 299.3 139.5 300 136.5 L 300.5 134 Z "
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 740.5 134 L 741 136.5 Q 741.5 140.5 738.5 141 L 735.5 142 L 736 140.5 L 737.5 135 Q 739 137.5 740.5 134 Z "
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1184.5 134 L 1184 135.5 Q 1182.9 138.8 1185.5 138 L 1184.5 140 Q 1182.3 139.3 1183 135.5 L 1184.5 134 Z "
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 671 135 Q 675.9 133.2 674 139.5 L 673 139.5 L 672.5 138 L 671.5 140 L 671 135 Z "
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 750 136 Q 753.7 134.8 752 140 Q 748.3 141.2 750 136 Z "
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 137 L 172 138.5 Q 173 142.3 170 141 L 172.5 137 Z "
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 137 L 323 138.5 Q 323.8 141.1 320.5 140 L 315.5 141 L 311.5 144 L 304.5 144 L 304.5 143 L 315 140 Q 313.7 136.7 318.5 138 L 319.5 137 Z "
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1049.5 137 L 1053.5 142 L 1055.5 141 L 1057 143.5 L 1054.5 145 L 1052.5 144 L 1048 145 L 1050 138.5 L 1049.5 137 Z "
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 138 L 99.5 138 L 102.5 141 L 111.5 142 L 113 143.5 L 111.5 145 L 103.5 145 Q 102.8 141.2 97.5 142 L 96 145 Q 92.2 146 91 143.5 L 96 140.5 L 96 138 Z "
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 778.5 138 L 779 140.5 L 778 140.5 L 778.5 138 Z "
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 844 138 Q 847 136.8 846 140.5 L 844 141.5 L 844 138 Z "
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1194.5 138 L 1195 139.5 L 1192 144 Q 1189.3 145.1 1190 142.5 L 1192.5 139 L 1194 139.5 L 1194.5 138 Z "
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 139 L 79 142.5 L 76.5 143 L 75.5 141 Q 78 141.7 77.5 139 Z "
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 139 L 329.5 141 L 326 140.5 L 328.5 139 Z "
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 624 139 L 626 139.5 L 624 140.5 L 624 139 Z "
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 140 Q 90.2 138.4 88 144 Q 84.2 145 83 142.5 L 84.5 140 Z "
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 770.5 140 Q 773.1 139.2 772 142.5 L 771 142.5 L 770.5 140 Z "
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 141 L 162 141 L 162 145 Q 157.9 146.7 159 142.5 L 160.5 141 Z "
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 774 141 Q 777 140 776 143 Q 773 144 774 141 Z "
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173 142 Q 176.3 140.9 175 145 L 172 144.5 L 173 142 Z "
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288 142 Q 293.2 140.3 292 144 Q 286.8 145.7 288 142 Z "
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325 142 Q 330.6 140.1 329 145 L 325 143.5 L 325 142 Z "
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 630.5 142 L 631.5 144 Q 628.7 144.7 630.5 142 Z "
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 744.5 142 L 748 142.5 L 744.5 143 L 744.5 142 Z "
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1184.5 142 L 1189 144 L 1190 146.5 L 1188.5 149 L 1187.5 146 L 1186 146.5 L 1187 144.5 L 1184.5 142 Z "
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1265.5 142 L 1267.5 144 Q 1269.3 140.3 1271 143.5 Q 1269.8 146 1266 145 L 1265.5 142 Z "
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 143 L 73 145.5 L 69 148.5 L 68.5 150 Q 67 147.5 65.5 151 L 63.5 152 L 64 150.5 Q 63.2 147.9 66.5 149 L 70 144 L 72.5 143 Z "
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 143 Q 204.8 142.3 204 144.5 L 202.5 143 Z "
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 143 L 624 143.5 L 545.5 144 L 545.5 143 Z "
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 840.5 143 L 841 146 Q 838.3 147.1 839 144.5 L 840.5 143 Z "
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 970.5 143 L 973 151 L 976 152.5 Q 976.8 154.8 974.5 154 L 972 149 L 970 148.5 L 970 146.5 L 970.5 143 Z "
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1170.5 143 L 1174 144.5 Q 1171 145.8 1172 150 L 1177.5 149 L 1180 150.5 L 1174.5 155 L 1171 152.5 L 1170 146.5 L 1171 144.5 L 1170.5 143 Z "
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1176 143 L 1178 143 Q 1176.5 146.8 1179.5 146 L 1179.5 147 L 1177.5 148 L 1176 143 Z "
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 845 144 Q 850.2 141.9 849 146.5 Q 847 150 845 145.5 L 845 144 Z "
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 145 L 208 147.5 L 206.5 151 L 205 147.5 L 207 147 L 207.5 145 Z "
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 543.5 145 L 544 222.5 L 543 222.5 L 543.5 145 Z "
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 673.5 145 L 675 148.5 L 674 148.5 L 673.5 145 Z "
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1183.5 145 L 1185 147.5 L 1183.5 148 Q 1180.5 146.5 1183.5 145 Z "
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76 146 L 80 146 L 80 147.5 L 75.5 153 L 73 154.5 L 74 161 L 71 160.5 L 72 158 L 68 156.5 L 67 154.5 L 76 152 L 76 146 Z "
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1263.5 147 Q 1265.8 146.3 1265 148.5 L 1262 149.5 L 1261.5 151 L 1259 149.5 L 1263.5 147 Z "
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 148 L 338 150.5 L 337 150.5 L 336.5 148 Z "
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 841.5 148 Q 847.6 150.4 846 160.5 L 845 160.5 L 844 158.5 L 845 156.5 L 843 152 Q 839.2 153.2 841.5 148 Z "
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 149 L 179 151.5 L 177.5 154 L 176 153.5 L 175.5 155 L 175 151 L 178.5 149 Z "
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1184.5 149 L 1187 150.5 L 1185.5 151 L 1184.5 149 Z "
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1258.5 151 Q 1261.1 150.3 1260 153 L 1262 153 L 1262 154.5 L 1259 156.5 L 1258.5 155 L 1257 158.5 L 1257.5 160 Q 1254.8 158.6 1256 154 L 1259 152.5 L 1258.5 151 Z "
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1039 152 Q 1042 151 1041 154 Q 1038 155 1039 152 Z "
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1182 152 Q 1184.7 150.9 1184 153.5 L 1180 156 L 1178.5 161 L 1178 156.5 L 1179 154 Q 1183.1 155.3 1182 152 Z "
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 153 L 63 153.5 L 60.5 158 Q 56.8 159 58 156 Q 60.7 157.1 60 154.5 L 61.5 153 Z "
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 153 Q 341.8 152.3 341 154.5 L 342 157.5 L 341 160 L 338 158.5 L 339 156.5 L 338 154.5 L 339.5 153 Z "
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78 154 Q 82.9 152.2 81 158.5 Q 79.5 161.5 78 158.5 L 78 154 Z "
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 156 L 181 156.5 Q 181.8 158.8 179.5 158 L 179.5 160 L 177 158.5 L 179 157.5 L 178.5 156 Z "
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1264.5 156 L 1265 158 L 1262 157.5 L 1264.5 156 Z "
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 157 L 67 157.5 L 63.5 160 L 62.5 158 L 64.5 157 Z "
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 346.5 157 L 348 157.5 L 346 158.5 L 348 159 Q 349.1 162.3 345 161 L 346.5 157 Z "
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1252.5 158 L 1254 158.5 L 1252 159.5 L 1254 160.5 L 1252.5 161 Q 1249.5 159.5 1252.5 158 Z "
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 159 L 61 161.5 Q 59.6 164.3 55 163 Q 53.5 159.2 56.5 160 L 57.5 159 Z "
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 159 L 219 160.5 L 217.5 160 L 216.5 159 Z "
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 656.5 159 L 658 159.5 L 658 165 L 660 165 Q 659 162 662 163 L 662 166 Q 659 164.8 660 168.5 Q 663 169.8 662 174 Q 659.3 175.1 660 172.5 Q 656.5 170.8 658 165 Q 653.1 166.8 655 160.5 L 656.5 159 Z "
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 663 159 L 666 159.5 L 665 161.5 L 665 163.5 L 664.5 165 L 663 159 Z "
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182 160 L 185 160.5 L 184.5 163 L 182 162 L 182 160 Z "
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 160 Q 237.4 158 236 162 Q 231.1 162.8 230.5 160 Z "
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1037.5 161 L 1041 162 L 1041 168 L 1038 168 L 1039 162 L 1037.5 161 Z "
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1168.5 161 L 1172 163.5 Q 1172.8 165.8 1170.5 165 L 1168 164 L 1169 166.5 L 1167 167 Q 1165.8 162.4 1168.5 161 Z "
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221 162 L 224.5 164 L 228 164 L 227.5 167 Q 225.6 163.4 221 164 L 221 162 Z "
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 848 162 L 858 168.5 L 860 175.5 L 858.5 178 L 856 172 Q 852.3 173.2 854 168 L 851.5 168 L 849.5 168 L 847 166.5 L 848 162 Z "
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 163 L 180 163.5 L 178 164 L 180 171.5 L 179 171.5 L 179 168.5 L 176 164.5 L 177.5 163 Z "
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 976.5 163 L 978 166 L 980 166.5 L 978 167.5 L 980 168 L 980 175 L 984 175 L 984 176.5 L 985 179.5 L 984 179.5 Q 984.9 176.5 980.5 178 L 978 175.5 L 978 168 L 976 167.5 L 976 165.5 L 976.5 163 Z "
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 164 L 64 165.5 L 61 170.5 L 62 172.5 L 61 177 L 58 176.5 L 59 174.5 L 58 171.5 L 63.5 164 Z "
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 666 164 Q 669.3 162.9 668 167 L 664.5 168 L 664 166 Q 667 167 666 164 Z "
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 165 L 189 168.5 L 188 172 L 186 172.5 L 189 174.5 L 187.5 174 Q 183.8 175.3 185 171.5 L 188 168.5 L 187 167.5 L 186.5 165 Z "
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 165 L 352 167.5 L 351 167.5 L 351.5 165 Z "
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 166 L 54 170 L 51 169.5 L 52.5 166 Z "
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182 166 Q 185 164.8 184 168.5 L 182 167.5 L 182 166 Z "
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353 167 Q 356 165.8 355 169.5 L 353 168.5 L 353 167 Z "
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1034.5 167 L 1036 169.5 L 1034.5 170 Q 1031.5 168.5 1034.5 167 Z "
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 169 L 57 170.5 Q 53 171.9 54 177 L 52 176.5 L 54 172.5 L 56.5 169 Z "
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1248.5 169 L 1249 173.5 L 1248 173.5 L 1248.5 169 Z "
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 171 L 357 173 L 355 172.5 L 356.5 171 Z "
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1244.5 171 L 1245 173 L 1247 173.5 L 1245.5 174 L 1244.5 171 Z "
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1035.5 172 L 1041 175.5 L 1039.5 179 L 1039.5 177 L 1037.5 178 L 1035.5 177 L 1031 180.5 Q 1031.7 183.1 1029 182 Q 1027.9 179.3 1030.5 180 L 1030 178.5 L 1031.5 175 L 1036 176 L 1035.5 172 Z "
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 173 L 181 173.5 L 178.5 174 L 178.5 173 Z "
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1239.5 173 L 1240.5 175 Q 1238.3 174.3 1239 176.5 Q 1235.5 178 1238 179.5 L 1236.5 182 L 1233 181.5 L 1235 181 L 1239.5 173 Z "
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 658.5 174 L 660 176.5 L 656.5 181 Q 654.3 180.3 655 176.5 L 658.5 174 Z "
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352 175 L 356 176.5 Q 356.7 179.1 354 178 L 354 182.5 L 351 182.5 L 352 175 Z "
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 664.5 175 L 663.5 177 L 664.5 175 Z "
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 862 175 L 865 175 L 865 181 L 862 181 L 862 175 Z "
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1157.5 175 L 1158 178 L 1161 176.5 Q 1160.3 173.9 1163 175 Q 1163.7 179.2 1160 180.5 L 1160.5 182 Q 1156.3 183.3 1158 178.5 Q 1154.3 176.8 1157.5 175 Z "
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1337.5 175 Q 1342.3 173.3 1341 177.5 L 1345 179 L 1344.5 183 L 1344 180 L 1340 180 Q 1341.3 177 1337.5 178 Q 1334.5 176.5 1337.5 175 Z "
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 176 Q 99 175 98 178 Q 95 179 96 176 Z "
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317.5 176 Q 321.3 174.8 320 178.5 L 317.5 176 Z "
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 851.5 176 L 854 177.5 L 852.5 177 L 851.5 176 Z "
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1152.5 176 L 1156 181.5 L 1154.5 184 L 1154 182 L 1151 180.5 Q 1150.3 176.8 1152.5 176 Z "
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1249 176 L 1326.5 176 L 1327 178 L 1249.5 178 L 1249 176 Z "
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1331.5 176 L 1334 181.5 L 1332.5 181 L 1329.5 180 L 1327.5 182 L 1249 182 L 1249.5 180 L 1327.5 180 L 1328 178 L 1329.5 178 L 1331.5 176 Z "
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1245.5 177 L 1246 180.5 L 1244.5 180 L 1242.5 181 L 1242 178 L 1245.5 177 Z "
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312 178 L 316 180.5 L 316 182 L 318 182.5 L 318 187.5 L 318 189.5 L 317.5 192 L 316 186 Q 313 187.3 314 183.5 Q 311 182.3 312 178 Z "
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 856.5 179 L 860 188 Q 863 187 862 190 L 858 189 L 857.5 192 L 856 189.5 L 858 185.5 Q 854.6 184.1 856.5 179 Z "
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 987.5 179 L 993 181.5 L 986 182 L 987.5 179 Z "
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 975.5 180 L 976 182 L 980 182.5 L 975 183 L 975.5 180 Z "
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1039.5 180 Q 1041.8 180.8 1041 184.5 Q 1039.6 187.3 1035 186 Q 1032.8 192 1039.5 190 Q 1042.5 191.5 1039.5 193 Q 1034.3 194.3 1033 191.5 Q 1033.8 189.3 1031.5 190 L 1029.5 189 L 1026.5 191 L 1024 189.5 L 1029 186.5 L 1027.5 183 L 1026 183.5 Q 1027.3 180.8 1028.5 183 L 1036 184 Q 1034.9 181.3 1037.5 182 L 1039.5 180 Z "
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356 181 Q 359.3 179.9 358 184 Q 354.7 185.1 356 181 Z "
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 661.5 181 L 662.5 183 Q 659.7 183.7 661.5 181 Z "
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1024.5 181 L 1025 183.5 L 1024 183.5 L 1024.5 181 Z "
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 659.5 183 L 660 184.5 L 659 186.5 L 661 186.5 L 656.5 195 L 657 193.5 L 659 187.5 L 657.5 187 L 656 187.5 L 659.5 183 Z "
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1333.5 183 L 1334.5 185 L 1332 184.5 L 1333.5 183 Z "
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 184 L 46 186.5 L 45 186.5 L 45.5 184 Z "
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 184 Q 361.8 183.3 361 185.5 L 360 188 Q 357 189.3 358 185.5 L 359.5 184 Z "
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 982.5 184 L 984 184.5 Q 978.7 186.8 982.5 189 L 985.5 186 L 1023 186 L 1022.5 188 L 993.5 188 L 992.5 190 L 1023 190.5 L 991.5 191 L 985.5 187 L 981.5 192 L 979 190.5 Q 978.3 188.3 980.5 189 L 981 186.5 L 982.5 184 Z "
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1158.5 184 L 1159 186.5 L 1158 186.5 L 1158.5 184 Z "
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1237.5 184 L 1247 184.5 L 1237.5 185 L 1237.5 184 Z "
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1338.5 184 L 1339.5 186 L 1338.5 184 Z "
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1343.5 184 Q 1345.8 184.8 1345 188.5 L 1344 188.5 Q 1344.7 185.9 1342 187 Q 1343.1 189.7 1340.5 189 L 1341 187.5 Q 1340.2 184.9 1343.5 186 L 1343.5 184 Z "
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 185 L 356 187.5 L 357 199.5 L 356 200.5 L 356 215 Q 353.3 216.1 354 213.5 L 353 211.5 L 354 210.5 L 354 191.5 L 353 188.5 L 354.5 185 Z "
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 719.5 186 L 720.5 188 Q 717.7 188.7 719.5 186 Z "
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 783.5 187 L 785.5 190 L 787 189.5 Q 785 193 783 188.5 L 783.5 187 Z "
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1153.5 187 L 1154 189 L 1157 189.5 L 1153 190 L 1153.5 187 Z "
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 975.5 188 L 976.5 190 Q 973.7 190.7 975.5 188 Z "
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 790.5 189 L 792 193 L 795 194.5 L 794.5 196 Q 797.1 195.2 796 198.5 L 799 199.5 L 800 205 Q 795.3 205.8 794 201.5 L 795 198.5 L 793.5 199 L 792 198.5 L 792 196.5 Q 789 193.8 790.5 189 Z "
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341.5 190 L 1341 191.5 L 1340 193.5 L 1340 223 Q 1344.1 221.7 1343 225 L 1341 225.5 L 1342 227.5 Q 1338.9 229.3 1340.5 231 L 1338 229.5 Q 1341 228.5 1340 223.5 L 1339 222.5 L 1339 191 L 1341.5 190 Z "
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 717.5 192 L 720 192.5 L 718.5 197 L 717 193.5 L 717.5 192 Z "
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 784 192 L 786 192.5 L 786 202 L 784 201.5 L 784 192 Z "
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 863.5 192 Q 866.1 191.2 865 194.5 L 863 195.5 L 863.5 194 L 862 193.5 L 863.5 192 Z "
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318 196 L 320 196.5 L 320 204 L 318 203.5 L 318 196 Z "
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 646 198 L 653.5 198 L 654 199.5 Q 652 203.2 650 201.5 L 649.5 204 L 648 203.5 Q 649 207.3 646 206 L 646 198 Z "
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 859 199 L 863 200 L 862 202.5 L 865 206.5 L 863 207.5 L 864 205.5 L 862 205.5 L 863 204.5 L 860.5 200 L 859 200.5 L 859 199 Z "
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 716 202 L 718 202.5 L 718 204.5 Q 717.3 206.8 719.5 206 L 718.5 208 L 716.5 208 L 714 207.5 L 716 207 L 717 204.5 L 716 202 Z "
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86 204 L 88 204.5 L 88 214 Q 81.6 216.3 84 208.5 Q 86.7 207.4 86 204 Z "
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 311.5 204 Q 312.6 206.8 316 206 L 318 209.5 L 318 215.5 L 315.5 221 L 310 222 L 311 218.5 L 309.5 217 Q 308 220.5 306.5 218 Q 303.9 218.7 305 216 Q 307.7 217.1 307 214.5 L 309.5 213 L 311.5 217 L 314 215.5 L 316 208 L 313 208 Q 314 205 311 206 L 311.5 204 Z "
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 788 206 Q 793.2 204.3 792 208 Q 786.8 209.7 788 206 Z "
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 643.5 207 Q 647.3 205.8 646 209.5 L 642 212 Q 641 208.2 643.5 207 Z "
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 867.5 207 L 870 207 L 870 212 Q 866.7 213.3 868 208.5 L 867.5 207 Z "
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 311.5 208 L 310.5 210 L 311.5 208 Z "
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 802.5 209 L 803 211.5 L 800 213.5 L 802.5 209 Z "
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 715.5 211 L 718 211 L 718 216 L 714 218.5 L 713.5 220 L 713 216.5 L 715.5 211 Z "
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 875.5 211 L 876 214 Q 879 213 878 216 L 874 213.5 L 875.5 211 Z "
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 865.5 213 L 866 216.5 L 865 216.5 L 865.5 213 Z "
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 644 214 L 647 215.5 L 648 221.5 L 646 222.5 L 645.5 216 L 644 216.5 L 644 214 Z "
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 803.5 214 L 805 217.5 L 804 221.5 L 805 223.5 L 802 224.5 Q 803.5 228.9 800.5 228 L 799 228.5 Q 797.8 222.4 800.5 223 L 803 222 L 802 215.5 L 803.5 214 Z "
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 640.5 215 L 643 220.5 L 640 222.5 L 639 216.5 L 640.5 215 Z "
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 869.5 217 L 870 221.5 L 868 222.5 L 867 219.5 L 869.5 217 Z "
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 872.5 217 L 875 222.5 L 870 225.5 L 872 226.5 L 869 227 Q 867.3 222.9 871.5 224 L 873 220.5 L 872.5 217 Z "
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 218 L 353 222.5 L 352 222.5 L 352.5 218 Z "
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 219 L 97.5 219 L 219 219.5 L 109.5 220 L 105.5 221 L 100.5 220 L 98 221.5 L 99 223.5 L 96.5 225 Q 93.6 223.6 95.5 219 Z "
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294 219 L 296 219.5 L 294 220.5 L 294 219 Z "
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 219 L 304 221 L 301 220.5 L 303.5 219 Z "
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 221 L 321 222.5 L 319.5 225 L 317 223.5 L 318.5 221 Z "
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 716 221 L 719 222.5 L 717.5 225 L 716 225 L 716 221 Z "
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 222 L 296 222.5 L 295.5 225 Q 291.1 226.5 292 223.5 L 291.5 222 Z "
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 222 Q 307.3 220.7 306 224 Q 301.8 224.1 302.5 222 Z "
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 708.5 222 L 708 223.5 L 707.5 225 L 707 223.5 L 708.5 222 Z "
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 878 222 L 881 223.5 Q 882.3 227.3 878.5 226 L 877 226.5 L 876 224.5 L 878 224 L 878 222 Z "
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 952 223 L 954 223.5 L 954 230 L 951 229.5 L 952 223 Z "
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 539.5 224 L 542 224.5 L 540.5 228 L 539.5 224 Z "
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 643 224 Q 647.5 222.3 646 227.5 L 646.5 229 L 643 226.5 L 643 224 Z "
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 806.5 224 L 808 228 L 811 229.5 Q 811.7 232.1 809 231 L 808.5 229 L 806 230 L 806.5 224 Z "
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 479 226 Q 482 224.8 481 228.5 L 481.5 230 Q 476.9 231.2 479 226 Z "
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 895.5 226 L 897 228.5 L 895 229 L 895.5 226 Z "
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1061 226 L 1064 227.5 L 1065 231 Q 1061.2 232.5 1062 229.5 L 1061 226 Z "
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1152.5 228 L 1154 232 Q 1157 230.8 1156 234.5 Q 1158 232.8 1160 236.5 Q 1161.3 241.3 1158 240 L 1155.5 236 Q 1153.3 236.8 1154 234.5 L 1152 231.5 L 1152 229.5 L 1152.5 228 Z "
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 639.5 229 L 643 231.5 L 645 235.5 L 642.5 241 Q 643 235.1 639 233.5 L 639.5 229 Z "
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 651.5 229 L 654 229.5 L 652.5 232 L 648 231.5 L 651.5 229 Z "
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 687.5 229 L 695 231.5 L 688 232 L 689.5 236 L 704 236.5 L 702.5 238 L 688.5 238 L 686.5 236 L 657.5 236 L 654 238 L 654 234 L 655.5 234 L 657.5 232 L 688 232 L 687.5 229 Z "
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 702.5 229 L 704.5 232 L 696.5 232 L 696 230.5 L 700.5 230 L 702.5 229 Z "
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 813.5 229 L 814.5 231 L 815 229 Q 817.7 227.9 817 230.5 L 813.5 232 Q 810.5 230.5 813.5 229 Z "
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 863.5 229 L 868 231.5 L 862.5 236 L 817 236 Q 818.3 239 814.5 238 L 812.5 238 Q 805.2 238.3 802 234.5 L 800 230.5 L 801.5 231 L 808.5 235 L 811.5 234 L 815.5 236 L 817 232 L 862.5 232 L 863.5 229 Z "
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 943.5 229 Q 945 232.5 946.5 230 L 948 230.5 L 945.5 232 L 943 231 L 943.5 229 Z "
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1103 229 L 1113 231.5 L 1104 233 L 1105.5 236 L 1119.5 236 L 1120 238 L 1104.5 238 L 1102.5 236 L 1073 236 Q 1074.3 239.3 1069.5 238 L 1066.5 237 L 1063.5 241 Q 1060.9 241.8 1062 238.5 Q 1059.8 237.3 1062.5 236 L 1065 236 L 1065.5 234 L 1069.5 234 L 1071.5 235 L 1073 232 L 1104 231.5 L 1103 229 Z "
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1164.5 229 L 1167 230.5 Q 1165.8 233.3 1160.5 232 L 1160.5 231 L 1164.5 229 Z "
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1331.5 229 L 1332 232 Q 1329.3 233.1 1330 230.5 L 1331.5 229 Z "
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 484.5 230 Q 486.8 229.3 486 231.5 L 483 231.5 L 484.5 230 Z "
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 487 230 L 491.5 231 L 495 230 L 494.5 232 L 487 232 L 487 230 Z "
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 530 230 Q 535.4 228.5 537 231.5 L 536 233.5 L 538.5 235 L 540 232 Q 543 230.8 542 234.5 L 541 237 L 535 237 L 535 234.5 Q 533.8 231.3 530 232 L 530 230 Z "
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 871 230 L 874 230 L 874 238 Q 870.2 239 869 236.5 L 869 233.5 L 871 230 Z "
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 899 230 Q 902 229 901 232 Q 898 233 899 230 Z "
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1070.5 230 L 1069.5 232 L 1068 231.5 L 1070.5 230 Z "
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1115.5 230 Q 1121.6 228.8 1121 231.5 L 1118.5 232 Q 1114.7 232.5 1115.5 230 Z "
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1335.5 230 Q 1338.1 229.3 1337 232 L 1334 231.5 L 1335.5 230 Z "
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 879.5 231 Q 882.3 232.4 881 237 Q 876.9 238.3 878 235 Q 881 236.3 880 232.5 L 879.5 231 Z "
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1056.5 231 L 1060 232 L 1061 235.5 Q 1060.3 237.8 1056.5 237 Q 1054.3 236.3 1055 232.5 L 1056.5 231 Z "
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 497.5 232 L 526.5 232 L 527 233.5 Q 528.2 236.8 532 236 Q 533.3 239.3 528.5 238 L 526.5 236 L 497 236 L 496.5 238 L 495.5 236 L 494 236.5 L 497.5 232 Z "
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1169.5 232 L 1326.5 232 L 1328 233.5 L 1329.5 236 Q 1333.3 235.3 1334 237.5 L 1329.5 238 L 1326.5 236 L 1169.5 236 L 1166 238.5 L 1164.5 241 L 1163 240.5 L 1163.5 239 L 1162 238.5 L 1168 235 L 1169.5 232 Z "
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341 232 Q 1347 230 1345 236 Q 1339 238 1341 232 Z "
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 483.5 233 L 485 237.5 Q 483.8 240.3 482.5 238 L 479 236.5 L 479.5 235 L 480.5 236 L 483.5 233 Z "
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 489.5 234 Q 493.3 232.8 492 236.5 Q 489.2 237.6 490 241 L 488 240.5 L 489 237.5 L 488 235.5 L 489.5 234 Z "
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 895.5 234 L 896.5 236 L 899 234.5 L 897.5 238 Q 892.8 239.2 895.5 234 Z "
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 649.5 235 L 652 236 Q 653.3 239 649.5 238 L 648 238.5 L 649.5 235 Z "
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 906.5 235 L 907 237 L 905 236.5 L 906.5 235 Z "
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 902.5 236 L 904 236.5 L 901.5 240 L 901 237.5 L 902.5 236 Z "
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 908 236 L 911 237.5 L 908 238 L 908 236 Z "
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 864.5 237 L 868 238 Q 869.8 242.5 864.5 241 L 863 238.5 L 864.5 237 Z "
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 958.5 237 L 961 238.5 L 959.5 241 L 957 239.5 L 958.5 237 Z "
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1152.5 237 L 1152 238.5 L 1153 240.5 L 1151 239.5 L 1152.5 237 Z "
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1338.5 237 Q 1343.1 235.8 1341 241 L 1336 240.5 L 1340 240 Q 1341.1 237.3 1338.5 238 L 1338.5 237 Z "
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 799.5 238 L 801 240.5 L 799 239.5 L 799.5 238 Z "
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338 239 Q 341 237.8 340 241.5 L 336 244 Q 335 241 338 242 L 338 239 Z "
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 648.5 240 L 652 240.5 L 648.5 241 L 648.5 240 Z "
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 256 L 175.5 256 L 176 258 L 96.5 258 L 96 256 Z "
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288 256 Q 293.2 254.3 292 258 Q 286.8 259.7 288 256 Z "
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314 256 Q 317 255 316 258 Q 313 259 314 256 Z "
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303 259 L 307 259.5 L 304 260.5 L 304.5 262 Q 301.5 262.7 303 259 Z "
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176 260 L 182 260 L 182 264 L 175 263.5 L 176 260 Z "
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 272 L 89 288.5 L 88 289.5 L 88 352 L 86 351.5 L 86 288.5 L 88 286.5 L 88.5 272 Z "
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 8.5 367 L 9 375.5 L 8 375.5 L 8.5 367 Z "
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 374 L 384 380 Q 381.3 378.9 382 381.5 L 381 381.5 L 382.5 374 Z "
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 432 392 Q 438.4 389.7 436 397.5 L 432 400 L 432 392 Z "
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,254)",
    stroke: "rgb(255,255,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 446 398 Q 449 397 448 400 Q 445 401 446 398 Z "
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(65,112,192)",
    stroke: "rgb(65,112,192)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 14.5 16 L 376.5 16 L 379 17 L 379 383 L 16.5 383 L 14.5 383 Q 12.3 383.8 13 381.5 L 12 380.5 L 12 17 L 14.5 16 Z M 249 36 L 248 37 L 237 38 L 226 42 L 209 53 Q 189 68 183 97 L 183 121 Q 185 122 184 127 L 192 146 L 200 157 Q 213 173 236 180 L 246 182 L 296 182 L 304 186 L 309 196 Q 311 206 306 211 L 297 217 L 97 217 L 97 196 L 101 187 L 111 182 L 204 182 Q 192 170 184 156 L 170 126 L 110 126 L 109 127 L 101 127 L 79 135 L 62 147 L 48 168 L 42 186 L 42 363 L 43 363 L 96 363 L 97 358 L 97 278 L 96 277 L 97 272 L 184 272 L 185 273 L 298 273 L 320 268 L 339 256 Q 360 240 365 209 L 365 191 L 363 181 Q 358 164 348 153 Q 334 135 309 128 L 304 127 L 255 127 L 250 126 L 245 123 L 241 120 L 238 111 Q 238 102 242 98 L 252 92 L 327 92 L 329 89 L 329 38 L 328 36 L 249 36 Z "
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(65,112,192)",
    stroke: "rgb(65,112,192)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 432.5 16 L 434 16.5 L 434 384 L 431 382.5 L 431 17.5 L 432.5 16 Z "
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(65,112,192)",
    stroke: "rgb(65,112,192)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 483 16 L 633.5 16 L 634 16.5 L 634 56 L 536 56 L 536 96 L 627 96 L 627 136 L 537.5 136 L 536 137.5 L 536 227 L 483 227 L 483 16 Z "
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(65,112,192)",
    stroke: "rgb(65,112,192)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 726 16 L 788.5 16 L 790 17.5 L 867 227 L 811.5 227 L 811 225.5 L 797 184 L 718.5 184 L 717 185.5 L 703 227 L 649.5 227 L 649 224.5 L 726 16 Z M 758 70 L 755 74 L 731 145 L 732 146 L 783 146 L 758 70 Z "
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(65,112,192)",
    stroke: "rgb(65,112,192)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 898 16 L 960.5 16 L 962 17.5 L 1008 121 Q 1011 122.3 1010 118.5 L 1056 16 L 1118.5 16 L 1119 16.5 L 1119 227 L 1066 227 L 1066 86.5 L 1064 87.5 L 1025.5 177 L 989.5 177 L 988 175.5 L 954 94.5 L 949.5 87 L 949 227 L 898.5 227 L 898 226.5 L 898 16 Z "
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(65,112,192)",
    stroke: "rgb(65,112,192)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1165 16 L 1330.5 16 L 1331 16.5 L 1331 56.5 L 1324 66 Q 1321.3 64.9 1322 67.5 L 1226 185.5 L 1337 186 L 1337 226.5 L 1336.5 227 L 1160 227 L 1160 186.5 L 1265 56.5 L 1165 56 L 1165 16 Z "
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 0 L 379.5 0 Q 378.7 3.5 385 2 L 385.5 0 L 480 0 L 480.5 3 L 491.5 3 L 491.5 2 L 488 0.5 L 624.5 0 L 626.5 1 L 627.5 0 L 635 0 L 636.5 3 Q 640.3 3.8 641 1.5 L 641.5 0 L 718.5 0 L 720.5 2 L 728 2 L 728.5 0 L 788 0 L 787.5 2 L 736.5 2 Q 733.5 4.8 728 4 L 728.5 6 L 736 6 L 737.5 3 L 782.5 3 Q 783 6.5 787.5 6 L 789.5 4 L 800.5 0 L 896 0 L 896.5 3 L 907.5 3 L 907.5 2 L 904 0.5 L 1160 0 L 1160.5 2 L 1167.5 2 L 1168.5 3 L 1327.5 3 L 1328.5 2 L 1338 2 L 1338.5 0 L 1388 0 L 1388 423.5 L 1387.5 424 L 0 424 L 0 384.5 L 2 384 L 2 378 Q -1.5 379.1 0 371.5 L 1 369.5 L 0 368.5 L 0 31.5 L 1 30.5 L 1 17.5 L 0 16.5 L 0 10 L 4 11.5 L 2 16 L 4 16.5 L 4 383.5 L 6 384 L 6 14.5 L 8 14 L 9 16.5 L 8 17.5 L 8 29.5 L 7 31.5 L 8 32.5 L 8.5 385 L 10.5 384 L 11.5 385 L 379.5 385 L 381 382 Q 383.7 383.1 383 380.5 L 384 376.5 L 382.5 374 L 381.5 376 L 381 369.5 L 382 369.5 L 382.5 372 L 384 368.5 L 383 367.5 L 383 32 L 385 31.5 L 381 30 L 381.5 25 L 383.5 25 Q 386.1 25.8 385 22.5 Q 383 18.8 381 20.5 L 382.5 18 Q 383.8 20.3 385 17.5 L 384 14.5 L 385 12.5 Q 383.8 9.8 382.5 12 L 380.5 11 L 380 12.5 L 380.5 14 L 376.5 12 L 375.5 13 L 371 12.5 L 374 10.5 L 16.5 10 L 13.5 9 L 11.5 9 L 5.5 10 L 4 7.5 Q 5.3 3.8 11.5 5 L 15.5 6 L 17.5 4 L 376 4 L 374.5 1 Q 369 -0.5 367.5 2 L 4.5 2 Q 3.4 4.8 0 4 L 0 0 Z M 497 2 L 497 3 L 623 3 L 624 4 L 632 4 L 629 2 L 497 2 Z M 913 2 L 913 3 L 960 3 L 913 2 Z M 1057 2 L 1057 3 L 1104 3 L 1057 2 Z M 432 4 L 432 10 L 438 12 L 436 13 L 441 16 L 444 16 L 444 384 L 441 384 L 438 389 L 439 390 Q 440 387 446 388 L 448 386 L 448 384 L 446 384 L 446 16 L 444 15 L 444 11 Q 441 9 442 6 Q 439 7 438 4 L 432 4 Z M 962 4 L 959 7 L 914 7 L 913 6 L 896 7 L 895 13 L 897 14 L 896 15 L 896 224 L 895 225 Q 894 229 897 231 L 898 228 L 898 231 Q 899 233 904 232 L 904 236 L 903 236 L 901 240 L 904 240 L 904 237 Q 908 238 907 236 L 907 234 L 907 232 L 911 232 L 910 235 Q 911 237 908 236 L 908 238 Q 912 239 914 236 L 943 236 L 945 238 L 948 237 L 954 238 L 956 235 Q 957 231 961 232 L 961 224 L 960 223 L 960 161 Q 964 162 965 160 Q 964 154 968 156 L 969 161 L 976 160 L 976 166 L 977 168 L 978 169 L 978 176 Q 979 179 984 178 L 985 180 L 985 179 L 986 179 Q 984 183 988 182 L 990 182 L 992 183 Q 995 181 991 180 L 1024 179 L 1023 182 L 1024 184 L 1027 184 Q 1030 183 1029 187 L 1024 190 L 993 190 L 994 188 L 1023 188 L 1023 186 L 988 186 L 983 184 L 981 187 L 979 188 Q 974 187 975 190 Q 979 189 982 192 L 986 187 L 993 192 L 1026 192 L 1030 189 L 1033 190 L 1035 193 Q 1040 194 1041 192 Q 1040 189 1035 190 Q 1033 184 1040 186 Q 1042 185 1041 182 Q 1039 178 1038 182 Q 1035 181 1036 184 L 1033 184 L 1031 181 L 1036 177 L 1040 179 L 1041 176 L 1039 174 L 1033 166 Q 1032 163 1035 164 L 1035 162 Q 1040 160 1038 167 L 1038 168 Q 1044 170 1041 163 Q 1038 161 1040 159 Q 1035 158 1036 161 L 1035 161 L 1036 158 L 1038 158 L 1040 157 L 1040 156 Q 1037 157 1038 155 L 1040 155 L 1041 153 L 1039 151 L 1043 147 L 1042 146 L 1043 144 L 1043 146 L 1044 146 L 1043 143 L 1045 139 L 1046 143 Q 1044 147 1048 146 L 1047 145 L 1048 143 L 1048 145 L 1053 144 L 1055 145 L 1057 144 L 1056 141 L 1054 142 L 1051 138 L 1049 142 L 1048 139 L 1047 139 Q 1048 137 1045 136 L 1047 133 L 1047 135 L 1047 136 Q 1049 135 1048 138 L 1050 138 L 1048 130 Q 1052 129 1050 134 L 1053 134 L 1052 136 L 1054 138 L 1054 137 L 1056 137 L 1057 134 L 1055 132 L 1051 127 L 1051 125 L 1053 121 L 1053 123 L 1054 126 Q 1053 130 1057 128 Q 1058 123 1056 121 Q 1053 122 1054 120 L 1056 116 L 1055 114 L 1058 112 L 1058 223 L 1055 223 L 1056 228 Q 1055 231 1058 230 L 1057 228 L 1060 223 L 1060 114 L 1062 113 L 1062 112 L 1063 112 L 1063 224 L 1061 227 L 1062 230 Q 1061 232 1064 231 Q 1068 233 1065 235 Q 1066 237 1063 236 L 1061 240 L 1064 241 L 1065 239 L 1069 237 Q 1071 238 1069 240 L 1072 240 L 1073 236 L 1103 236 L 1105 238 L 1120 238 L 1120 236 L 1106 236 L 1104 233 L 1113 232 L 1106 230 L 1106 229 L 1114 229 L 1114 231 Q 1116 233 1121 232 L 1120 230 L 1121 228 L 1121 16 L 1120 13 L 1117 13 Q 1118 10 1120 12 L 1120 10 L 1117 9 L 1114 10 L 1116 10 L 1115 13 L 1112 12 Q 1105 10 1104 13 L 1058 13 L 1052 16 L 1050 16 L 1045 15 L 1044 19 L 1048 18 L 1050 21 L 1051 18 L 1053 19 L 1052 21 Q 1049 20 1050 24 L 1050 26 L 1047 23 L 1046 25 L 1044 25 L 1044 20 Q 1041 19 1042 24 L 1039 25 L 1040 29 L 1039 33 L 1039 36 L 1043 42 L 1040 43 L 1041 45 L 1040 48 L 1039 47 L 1035 49 L 1038 50 L 1036 57 L 1033 59 L 1034 62 L 1030 60 L 1032 56 L 1032 58 L 1034 57 L 1033 53 L 1033 51 Q 1035 50 1034 53 L 1036 53 Q 1037 50 1034 49 Q 1035 46 1033 47 L 1030 53 L 1026 51 L 1027 63 L 1031 65 L 1031 64 L 1033 65 L 1031 65 L 1030 68 L 1027 67 L 1027 70 L 1025 68 L 1027 67 L 1025 62 L 1023 66 L 1025 71 L 1026 73 Q 1028 72 1027 75 L 1025 73 L 1023 76 Q 1022 80 1025 82 L 1022 83 L 1021 79 L 1019 80 L 1018 82 Q 1020 81 1019 84 L 1016 84 L 1016 79 L 1012 79 L 1013 85 L 1016 86 Q 1018 91 1014 90 L 1012 96 L 1016 94 L 1017 98 L 1015 103 Q 1016 106 1012 104 L 1011 100 L 1012 98 L 1009 96 Q 1008 91 1012 90 L 1008 82 Q 1009 78 1006 79 L 1009 87 L 1009 91 Q 1006 90 1007 96 L 1005 96 L 1005 98 L 1003 104 L 1002 103 L 1002 101 L 1001 97 Q 998 98 999 95 L 998 92 L 999 90 L 998 90 L 994 82 L 996 82 L 996 86 L 998 86 L 999 84 L 1000 84 L 999 87 L 1002 88 L 1004 92 Q 1003 94 1002 92 L 1000 95 L 1004 96 Q 1003 93 1006 92 L 1006 84 Q 1002 85 1001 83 Q 1003 78 999 79 L 998 82 L 996 79 L 993 80 L 991 79 L 992 76 Q 993 71 990 70 L 993 66 L 991 64 Q 988 65 990 67 L 987 67 L 987 66 L 986 64 Q 987 59 992 60 L 989 51 L 988 57 Q 985 58 986 56 L 984 55 L 983 58 L 982 58 L 983 55 L 980 53 L 981 49 L 982 52 Q 985 53 984 50 L 987 50 L 988 51 L 987 47 L 985 48 L 982 47 L 979 49 L 976 43 L 974 39 L 975 38 L 974 35 L 973 37 L 972 36 L 972 34 L 974 34 L 973 31 L 973 29 L 972 26 L 974 21 Q 975 16 972 15 L 972 9 Q 971 2 962 4 Z M 1152 4 Q 1150 10 1156 8 Q 1158 2 1152 4 Z M 1340 4 L 1340 6 L 1344 8 Q 1346 2 1340 4 Z M 632 5 L 630 8 L 633 10 L 635 10 L 641 8 L 640 6 Q 633 8 632 5 Z M 721 5 L 719 7 L 721 10 L 726 7 Q 725 4 721 5 Z M 375 6 L 373 8 L 376 9 L 377 11 L 379 10 L 382 9 L 384 10 L 385 8 L 384 6 L 375 6 Z M 494 6 L 493 7 L 480 7 L 479 12 Q 478 14 481 13 L 480 15 L 481 17 L 481 224 Q 478 225 479 230 Q 481 233 483 229 L 484 232 L 495 232 L 495 230 L 492 231 L 489 230 L 491 230 L 493 229 L 497 230 L 528 230 L 529 229 L 537 229 L 538 230 L 538 229 L 538 227 L 541 228 L 542 227 L 542 229 L 544 230 L 543 226 L 543 224 L 539 224 L 539 145 Q 537 143 540 142 L 541 144 L 543 141 Q 541 139 544 138 L 545 139 L 623 139 L 625 141 L 627 140 L 627 138 L 629 139 L 629 129 L 630 128 L 630 97 L 630 95 L 629 91 L 625 91 Q 626 94 624 93 L 625 91 L 544 90 L 546 86 L 624 86 L 624 84 L 546 84 Q 544 89 539 88 L 539 82 L 540 81 L 539 80 L 539 63 L 539 61 L 540 64 L 543 63 L 542 57 L 546 58 L 624 58 L 624 62 L 628 64 L 630 63 L 628 61 Q 625 62 626 59 L 629 58 Q 633 57 635 59 Q 639 60 640 57 L 638 56 L 639 54 L 638 47 L 636 52 L 635 18 Q 638 16 637 14 L 640 16 L 641 13 Q 640 10 639 12 L 637 11 L 635 12 L 633 12 L 630 12 L 630 10 L 624 10 L 623 13 L 497 13 L 496 12 L 494 13 L 492 12 L 490 13 L 485 11 L 485 10 L 487 11 L 489 10 Q 493 11 492 9 L 494 9 L 498 8 L 623 8 L 498 7 L 494 6 Z M 796 6 L 794 10 Q 799 11 801 9 L 801 6 L 796 6 Z M 1167 6 L 1165 8 L 1161 8 Q 1162 11 1159 10 L 1154 17 L 1154 47 L 1156 48 L 1156 16 L 1160 18 L 1160 47 L 1162 47 L 1162 18 L 1160 16 L 1163 16 L 1163 48 L 1162 49 Q 1161 54 1163 56 L 1162 58 L 1249 58 L 1250 60 L 1248 61 L 1250 64 Q 1246 65 1247 62 L 1168 63 L 1232 63 L 1231 65 L 1233 67 L 1238 65 L 1238 63 L 1246 64 L 1245 67 L 1249 66 L 1252 68 L 1249 72 L 1250 73 L 1247 71 L 1245 74 L 1243 75 L 1240 81 L 1237 80 L 1236 77 L 1234 78 Q 1231 77 1232 80 L 1236 82 L 1235 82 L 1233 82 Q 1230 81 1231 86 Q 1232 88 1234 86 L 1235 88 L 1234 91 Q 1235 93 1232 92 L 1232 95 L 1229 96 L 1229 99 L 1228 95 L 1224 96 L 1225 99 L 1224 102 L 1223 102 L 1224 100 L 1218 98 L 1219 104 Q 1221 105 1219 106 L 1217 105 L 1215 108 Q 1214 111 1217 110 L 1219 111 L 1216 112 L 1216 114 L 1215 116 L 1214 115 L 1214 113 L 1214 111 L 1208 111 Q 1207 114 1210 116 Q 1211 118 1208 117 Q 1206 121 1210 120 L 1210 121 L 1208 120 Q 1205 119 1206 123 L 1206 125 L 1206 126 L 1203 122 Q 1202 118 1206 120 L 1206 117 L 1207 115 Q 1202 113 1203 118 L 1199 121 L 1202 128 L 1206 128 Q 1204 132 1203 129 L 1200 131 L 1201 134 Q 1200 136 1199 134 L 1195 135 L 1194 138 Q 1195 140 1193 139 L 1190 143 Q 1191 146 1187 144 L 1186 147 L 1184 147 L 1186 146 L 1186 145 L 1182 147 L 1180 146 Q 1177 147 1178 143 L 1176 143 L 1177 147 L 1176 150 Q 1170 152 1172 147 Q 1176 145 1173 143 Q 1168 143 1168 146 L 1170 146 L 1171 153 L 1174 155 Q 1180 154 1183 148 L 1184 151 L 1187 152 L 1186 152 L 1184 152 L 1179 154 L 1178 158 L 1178 160 L 1176 162 L 1176 160 Q 1173 161 1174 158 Q 1172 154 1170 159 Q 1169 162 1173 161 L 1173 162 L 1169 161 Q 1166 162 1167 167 L 1170 168 L 1170 167 L 1172 167 Q 1171 164 1174 165 L 1174 168 Q 1172 171 1170 170 L 1171 172 L 1170 171 L 1168 175 L 1165 176 L 1160 185 L 1153 177 L 1151 178 Q 1150 181 1153 182 Q 1156 181 1154 185 L 1158 187 L 1158 189 L 1155 188 L 1155 187 L 1152 186 Q 1150 191 1154 190 L 1155 193 L 1157 192 L 1157 224 L 1156 228 L 1158 229 L 1164 230 L 1160 232 L 1165 232 L 1166 235 Q 1167 237 1165 236 L 1162 240 L 1165 241 L 1166 239 L 1170 236 L 1327 236 L 1330 238 L 1334 238 Q 1333 235 1330 236 L 1327 232 L 1170 232 L 1169 233 L 1167 231 L 1167 229 L 1169 230 L 1328 230 L 1329 229 L 1331 230 L 1329 234 L 1338 231 L 1341 232 L 1342 232 L 1341 236 Q 1347 238 1345 233 L 1341 230 L 1343 229 L 1342 225 L 1344 225 L 1343 224 L 1343 194 L 1342 194 L 1342 223 L 1341 223 L 1339 224 L 1340 223 L 1340 194 L 1341 192 L 1345 189 Q 1346 185 1344 184 L 1341 188 Q 1340 185 1336 185 Q 1334 181 1332 185 L 1330 184 L 1328 185 L 1248 185 L 1245 184 L 1246 178 L 1243 176 L 1246 174 L 1248 174 L 1249 174 L 1249 169 L 1247 168 L 1246 170 L 1245 169 L 1244 171 Q 1241 172 1243 174 L 1241 173 L 1243 170 L 1242 169 L 1246 166 L 1250 160 L 1254 161 L 1255 159 L 1254 158 L 1254 157 Q 1253 153 1256 154 L 1255 153 L 1259 150 L 1259 153 L 1258 154 Q 1254 153 1256 159 Q 1257 161 1259 159 Q 1261 160 1260 157 L 1262 156 Q 1261 160 1265 158 L 1264 156 Q 1265 153 1262 154 Q 1261 150 1265 149 L 1264 145 L 1262 148 L 1260 148 L 1262 147 L 1264 144 L 1270 145 L 1272 139 L 1274 141 L 1273 144 L 1275 144 L 1276 144 Q 1275 146 1278 145 L 1278 140 L 1277 139 Q 1274 138 1274 135 L 1276 136 Q 1275 138 1278 137 L 1278 139 L 1281 139 L 1278 127 L 1280 127 L 1280 124 Q 1285 123 1286 128 L 1286 129 L 1290 129 L 1288 123 L 1283 122 L 1280 122 L 1283 120 L 1287 114 L 1292 110 L 1291 112 L 1292 114 L 1289 116 Q 1285 115 1286 118 L 1287 120 Q 1290 119 1289 122 L 1292 122 L 1293 118 L 1292 116 L 1295 114 L 1296 115 Q 1297 111 1294 112 L 1294 109 L 1297 110 L 1299 109 L 1303 112 L 1304 106 L 1310 104 L 1309 101 L 1307 102 L 1306 99 L 1304 100 Q 1300 98 1304 97 L 1303 95 L 1307 92 L 1306 91 L 1310 86 L 1312 87 Q 1314 86 1312 85 L 1316 79 L 1322 80 L 1323 78 L 1320 74 L 1322 71 L 1323 75 L 1324 72 L 1326 72 L 1329 70 L 1328 65 L 1334 62 L 1335 65 L 1339 64 L 1338 58 L 1341 59 L 1344 57 Q 1347 58 1345 54 L 1339 55 L 1337 52 L 1338 50 Q 1340 48 1338 47 L 1336 47 L 1336 51 L 1335 51 L 1333 50 L 1333 15 L 1339 17 L 1339 48 L 1342 51 L 1344 50 L 1342 47 L 1342 16 L 1341 14 L 1338 10 L 1329 6 L 1327 7 L 1170 7 L 1167 6 Z M 738 7 L 738 8 L 783 8 L 784 12 L 783 13 L 738 13 L 736 10 L 726 12 L 728 12 L 728 13 L 724 10 L 719 13 L 721 19 L 721 18 Q 724 16 722 15 L 724 16 L 722 21 L 723 22 L 721 21 L 719 25 L 721 26 Q 718 28 719 32 L 717 33 L 716 31 L 712 32 L 714 36 L 713 35 L 712 39 L 707 42 L 705 37 Q 702 38 703 44 L 708 46 L 706 46 L 705 49 Q 705 53 708 54 L 707 53 L 704 55 Q 702 61 706 60 L 707 62 L 707 61 L 708 61 L 706 66 L 705 65 L 702 71 L 698 74 L 695 70 Q 692 71 693 65 L 690 63 L 689 71 L 692 72 Q 693 76 690 78 Q 689 83 693 84 L 696 83 L 696 90 L 697 91 L 696 93 L 692 88 L 688 91 L 689 94 L 692 92 Q 693 96 691 97 L 689 96 Q 686 97 687 103 Q 690 104 688 106 L 691 108 L 687 110 L 689 113 L 688 115 L 686 113 Q 687 110 684 111 L 684 114 L 683 112 L 679 111 L 678 114 L 681 115 L 678 121 L 678 128 L 676 131 Q 679 132 678 129 L 682 128 L 680 124 L 681 121 L 684 124 L 683 130 L 680 133 L 681 135 L 680 137 L 677 133 L 675 138 L 674 138 Q 675 133 671 135 L 671 140 L 674 140 L 674 144 L 676 144 L 677 146 L 672 144 L 675 151 Q 676 153 673 152 L 671 161 L 670 160 L 668 163 L 670 163 L 669 168 Q 669 164 666 163 Q 668 157 663 159 L 665 166 L 664 169 L 665 169 Q 664 166 667 167 L 666 175 L 664 174 Q 665 171 662 172 L 660 169 Q 659 165 662 166 L 662 163 L 658 165 Q 657 171 660 173 L 662 176 L 665 177 L 663 182 L 661 182 Q 660 184 663 183 L 663 184 L 660 183 L 657 184 L 656 187 L 658 190 Q 655 191 656 196 L 658 196 L 653 208 L 652 207 L 650 208 L 648 212 L 650 211 L 651 212 L 650 212 Q 646 214 650 216 L 649 217 Q 646 218 647 216 L 644 214 Q 643 219 646 219 L 646 223 L 648 222 L 647 224 Q 642 222 643 227 L 647 229 L 646 228 L 647 226 L 649 230 L 648 232 L 653 232 Q 655 233 654 238 L 658 236 L 687 236 L 689 238 L 703 238 L 704 237 L 690 236 L 688 232 L 658 232 L 657 233 L 656 231 L 654 231 L 688 230 L 689 229 L 696 229 L 697 232 L 705 232 L 704 229 L 707 228 L 705 227 L 707 224 L 708 227 L 709 227 Q 710 221 707 220 L 709 217 L 710 219 L 710 217 L 713 216 L 714 220 L 717 216 L 718 216 L 718 211 L 715 212 L 712 211 L 714 207 L 720 208 L 717 204 L 720 197 L 719 195 L 720 192 L 720 190 L 718 189 L 721 188 L 720 187 L 784 186 L 785 185 L 793 186 L 795 186 L 796 189 Q 797 191 794 190 L 794 188 L 790 190 Q 789 196 793 198 L 792 200 L 794 199 L 794 202 Q 795 206 800 205 L 801 208 L 803 207 L 804 211 L 803 211 Q 804 208 801 209 L 801 211 L 800 213 L 800 217 L 802 222 L 799 223 Q 798 231 802 235 L 806 237 Q 808 236 807 240 Q 810 241 809 238 Q 813 237 814 240 Q 813 242 816 241 L 817 236 L 863 236 L 869 231 L 868 228 L 872 227 Q 873 223 870 224 L 871 221 L 873 224 L 875 223 L 872 215 L 867 218 L 867 217 L 866 214 L 864 214 Q 863 208 865 207 L 863 201 L 864 199 L 864 197 L 860 199 L 857 195 L 860 196 L 860 194 Q 863 193 862 196 L 865 195 Q 866 191 863 192 L 861 192 L 859 193 L 858 189 L 862 190 L 862 183 L 858 181 L 860 176 L 858 169 L 849 162 L 847 165 L 845 163 L 847 154 L 842 148 L 841 149 L 840 148 L 840 146 Q 842 147 841 144 L 840 144 L 840 143 L 838 142 L 840 140 L 840 130 Q 837 129 838 134 L 838 136 Q 839 138 837 137 L 835 135 Q 838 133 836 132 L 837 128 L 832 127 L 831 124 Q 834 122 832 117 L 830 116 Q 831 118 828 117 L 827 114 L 830 115 L 831 113 L 828 111 L 830 108 L 830 110 L 833 108 Q 834 104 832 105 L 830 105 Q 831 108 828 107 L 827 112 L 826 112 L 826 109 L 829 105 L 826 104 Q 824 106 823 104 L 824 100 L 824 98 L 824 96 L 826 96 L 826 89 Q 829 88 828 91 L 828 93 Q 827 96 830 95 L 830 98 L 833 98 Q 833 93 830 91 L 830 85 L 826 82 L 825 88 L 821 95 L 818 89 L 820 89 Q 822 83 819 84 L 815 83 Q 814 80 817 81 L 814 76 L 817 74 L 816 65 L 814 64 Q 811 65 812 63 L 816 60 L 815 58 Q 816 53 814 54 L 810 62 L 808 63 Q 806 57 810 58 L 810 53 L 809 53 L 807 57 L 805 55 L 806 52 L 805 52 L 803 49 L 805 49 Q 807 48 806 51 L 808 50 Q 811 49 810 53 L 812 52 L 812 48 L 809 48 L 809 42 Q 807 38 801 39 L 801 41 L 800 39 L 800 37 Q 801 34 799 35 L 798 31 L 800 32 L 802 34 L 800 27 Q 801 24 798 25 L 798 22 L 796 22 L 794 19 Q 793 15 796 16 L 800 18 L 801 14 L 795 13 Q 792 12 793 15 Q 792 18 790 15 Q 793 14 792 10 Q 791 7 790 9 L 785 7 L 738 7 Z M 1057 7 L 1057 8 L 1112 8 L 1113 9 L 1120 8 L 1057 7 Z M 424 8 L 424 10 L 426 9 L 424 8 Z M 430 8 Q 428 11 431 10 L 430 8 Z M 426 10 L 424 12 L 426 12 L 426 10 Z M 1114 10 L 1112 12 L 1114 12 L 1114 10 Z M 428 11 L 426 13 L 428 13 L 428 11 Z M 429 11 L 428 14 L 431 14 L 431 12 L 429 11 Z M 427 14 L 426 16 L 428 15 L 427 14 Z M 433 14 L 430 17 L 429 16 L 428 384 Q 430 382 432 385 L 435 384 L 435 17 L 433 14 Z M 1039 15 Q 1037 21 1042 19 Q 1044 13 1039 15 Z M 418 16 L 418 384 L 420 384 L 420 17 L 418 16 Z M 422 16 L 422 384 L 424 384 L 424 17 L 422 16 Z M 436 17 L 436 384 L 438 384 L 438 18 L 436 17 Z M 975 24 Q 972 29 976 31 L 977 29 Q 978 25 975 26 L 975 24 Z M 706 31 L 706 36 L 709 35 Q 711 29 706 31 Z M 806 32 L 806 34 L 812 36 L 812 32 L 806 32 Z M 814 36 L 814 42 L 816 42 L 816 36 L 814 36 Z M 814 46 L 815 54 L 816 54 L 816 47 L 814 46 Z M 990 47 L 992 51 L 993 49 L 990 47 Z M 1023 47 L 1023 50 L 1026 51 Q 1028 45 1023 47 Z M 1159 47 L 1154 51 Q 1149 50 1151 54 L 1155 53 L 1158 51 L 1159 52 L 1159 47 Z M 1159 53 Q 1157 57 1151 56 Q 1150 60 1155 58 L 1158 62 Q 1162 61 1160 65 L 1163 64 L 1161 60 L 1157 57 L 1160 56 L 1159 53 Z M 632 59 L 632 60 L 634 60 L 632 59 Z M 638 59 L 638 61 L 636 61 Q 637 64 635 63 L 635 61 Q 630 60 632 65 L 640 63 Q 642 62 640 61 Q 641 58 638 59 Z M 1164 61 L 1165 62 L 1164 64 L 1167 64 L 1166 63 L 1168 62 L 1164 61 Z M 1344 61 L 1342 63 Q 1341 67 1345 65 L 1344 61 Z M 546 62 L 546 63 L 623 63 L 546 62 Z M 1155 62 L 1153 64 L 1155 64 L 1155 62 Z M 696 63 L 696 68 Q 700 69 701 66 L 701 63 L 696 63 Z M 544 64 L 543 79 L 542 82 L 545 81 L 544 79 L 544 64 Z M 1241 66 L 1237 72 L 1233 69 L 1231 73 Q 1232 75 1236 74 L 1237 76 L 1241 74 L 1241 72 L 1244 68 L 1241 66 Z M 1326 74 L 1326 79 Q 1328 82 1329 79 Q 1331 72 1326 74 Z M 823 79 L 821 82 L 824 83 L 825 81 L 823 79 Z M 626 86 L 625 89 L 629 90 L 630 93 L 634 94 L 634 86 L 626 86 Z M 1310 87 L 1311 89 Q 1312 86 1310 87 Z M 1310 89 L 1307 93 L 1308 95 Q 1309 97 1306 96 L 1306 98 L 1311 96 L 1310 95 L 1312 95 Q 1314 94 1313 91 L 1310 89 Z M 636 96 L 636 127 L 635 130 L 639 129 L 638 127 L 638 97 L 636 96 Z M 827 96 Q 825 99 828 98 L 827 96 Z M 828 99 L 828 103 L 830 102 Q 831 98 828 99 Z M 1309 108 L 1306 111 Q 1305 115 1310 113 Q 1311 109 1309 108 Z M 674 111 Q 675 115 671 117 L 671 120 L 674 121 L 671 126 Q 670 131 674 129 L 675 117 L 677 113 L 674 111 Z M 1201 111 L 1199 114 L 1203 114 L 1203 113 L 1201 111 Z M 1294 119 L 1294 122 L 1297 121 Q 1298 118 1294 119 Z M 1293 122 Q 1288 124 1292 126 Q 1294 125 1293 128 L 1296 129 L 1297 126 L 1294 125 Q 1295 121 1293 122 Z M 1198 127 L 1198 130 L 1201 129 L 1198 127 Z M 632 128 Q 631 131 634 130 Q 635 127 632 128 Z M 1184 128 L 1184 130 L 1186 129 L 1184 128 Z M 1190 128 L 1191 131 L 1191 133 L 1190 131 L 1188 130 L 1186 133 Q 1187 135 1185 134 Q 1182 135 1183 139 Q 1185 142 1186 139 Q 1184 134 1188 135 L 1189 138 Q 1193 139 1191 134 L 1195 133 L 1195 130 L 1192 130 Q 1193 127 1190 128 Z M 630 130 Q 628 137 632 139 L 630 140 Q 632 143 639 142 Q 640 144 641 142 L 638 140 L 636 136 L 640 135 Q 642 136 641 134 L 638 132 L 636 134 L 632 133 Q 633 129 630 130 Z M 842 132 Q 840 137 844 136 Q 846 131 842 132 Z M 844 138 Q 843 145 848 148 L 849 144 L 846 143 Q 848 137 844 138 Z M 628 142 L 629 144 Q 633 145 632 142 L 630 143 L 628 142 Z M 1185 142 L 1186 143 L 1187 144 Q 1188 141 1185 142 Z M 546 143 L 546 144 L 624 144 L 546 143 Z M 544 145 L 543 223 L 544 223 L 544 145 Z M 1046 146 L 1044 148 L 1046 148 L 1046 146 Z M 1048 147 L 1045 151 L 1047 151 L 1048 149 L 1048 147 Z M 1044 148 L 1042 150 L 1044 150 L 1044 148 Z M 1041 150 L 1042 152 Q 1043 149 1041 150 Z M 657 159 L 655 161 Q 653 167 658 165 L 658 160 L 657 159 Z M 846 161 L 846 163 L 848 162 L 846 161 Z M 1040 169 L 1038 172 L 1040 173 L 1040 169 Z M 659 174 L 655 177 Q 654 180 657 181 L 660 177 L 659 174 Z M 862 175 L 862 181 L 865 181 L 865 175 L 862 175 Z M 1158 175 L 1156 177 L 1158 178 L 1158 175 Z M 1162 175 L 1160 177 Q 1161 179 1158 178 Q 1156 183 1161 182 Q 1159 180 1163 178 Q 1165 179 1164 177 L 1162 175 Z M 1338 175 L 1336 177 L 1340 178 L 1339 182 L 1343 183 Q 1347 184 1345 179 L 1341 178 Q 1342 173 1338 175 Z M 662 176 L 660 178 L 662 178 L 662 176 Z M 1249 176 L 1250 178 L 1327 178 L 1327 176 L 1249 176 Z M 1332 176 L 1330 178 L 1328 178 L 1328 180 L 1250 180 L 1249 182 L 1328 182 L 1333 181 L 1334 182 L 1332 176 Z M 976 178 L 975 183 L 980 183 L 980 180 L 976 178 Z M 1339 184 L 1340 186 Q 1341 183 1339 184 Z M 783 187 L 784 190 L 721 190 L 721 191 L 786 191 L 787 190 Q 788 185 783 187 Z M 784 192 L 784 202 L 786 202 L 786 193 L 784 192 Z M 646 198 L 646 206 L 651 204 L 654 200 L 654 198 L 646 198 Z M 651 204 L 651 206 L 653 205 L 651 204 Z M 788 206 Q 787 210 792 208 Q 793 204 788 206 Z M 644 207 Q 641 208 642 212 L 646 210 Q 647 206 644 207 Z M 868 207 L 866 211 L 870 212 L 870 207 L 868 207 Z M 875 207 L 873 209 L 874 214 Q 875 217 879 216 L 880 218 L 880 213 L 878 214 L 876 214 L 876 207 L 875 207 Z M 641 215 L 639 217 L 640 223 L 643 221 L 641 215 Z M 712 218 L 709 221 Q 708 223 711 222 L 712 220 L 712 218 Z M 716 221 L 716 225 L 718 225 L 719 223 L 716 221 Z M 878 222 Q 879 225 876 224 L 876 227 L 879 226 Q 882 227 881 224 L 878 222 Z M 1152 224 Q 1151 232 1154 236 L 1158 239 Q 1157 241 1160 240 Q 1161 234 1156 233 L 1160 231 L 1160 230 L 1156 231 L 1153 230 L 1155 229 L 1153 225 L 1155 225 L 1152 224 Z M 641 228 L 639 230 Q 638 236 642 237 L 641 239 L 643 241 L 645 236 L 642 231 Q 643 227 641 228 Z M 709 228 L 709 230 L 711 229 L 709 228 Z M 541 229 L 542 231 Q 543 228 541 229 Z M 530 230 L 530 232 Q 534 231 535 235 L 535 237 L 541 237 L 542 233 Q 541 230 540 232 Q 537 229 530 230 Z M 688 230 L 688 232 L 695 232 L 688 230 Z M 870 230 L 869 234 Q 868 237 871 238 Q 874 237 873 240 L 874 240 L 874 230 L 870 230 Z M 880 231 L 878 233 Q 876 239 881 237 Q 882 232 880 231 Z M 1057 231 L 1055 233 Q 1054 236 1057 237 Q 1060 238 1061 236 L 1060 232 L 1057 231 Z M 498 232 L 494 237 L 496 241 L 497 236 L 527 236 L 529 238 Q 533 239 532 236 Q 528 237 527 234 L 527 232 L 498 232 Z M 528 232 Q 527 235 530 234 Q 531 231 528 232 Z M 480 233 L 479 237 L 483 238 Q 484 240 485 238 L 484 234 L 483 234 L 480 233 Z M 897 233 L 895 235 Q 893 239 898 238 L 899 235 L 897 233 Z M 490 234 L 486 240 L 490 241 Q 489 238 492 237 Q 493 233 490 234 Z M 959 234 L 957 236 L 958 238 L 957 240 L 960 241 L 961 239 L 959 234 Z M 650 235 Q 647 236 648 241 Q 654 243 652 236 L 650 235 Z M 801 237 L 799 240 Q 801 243 802 240 L 801 237 Z M 865 237 L 863 239 L 865 241 Q 870 243 868 238 L 865 237 Z M 1153 237 L 1151 240 Q 1153 243 1154 240 L 1153 237 Z M 1339 237 L 1336 238 L 1336 241 L 1341 241 Q 1343 236 1339 237 Z M 534 238 L 532 240 L 534 240 L 534 238 Z M 544 238 L 542 240 L 544 240 L 544 238 Z M 513 248 L 507 252 L 505 252 L 501 256 L 499 255 L 499 257 L 498 256 L 497 258 L 495 259 L 492 258 L 494 261 L 494 262 L 493 260 Q 490 261 492 263 L 490 266 L 489 265 L 486 269 L 489 268 Q 487 272 486 269 L 484 276 L 484 278 L 483 278 L 483 280 L 481 284 Q 480 288 482 290 Q 483 294 480 293 L 481 296 L 481 295 L 482 295 L 481 297 L 483 303 L 484 306 L 483 308 L 486 309 L 485 311 L 487 310 L 487 312 Q 489 311 488 316 L 490 315 L 491 318 L 491 320 Q 492 322 494 320 L 497 325 L 506 329 L 509 331 L 513 331 L 513 333 L 516 332 L 521 333 L 546 333 L 548 334 L 550 335 Q 549 337 552 336 L 554 340 L 553 342 L 554 344 L 553 348 L 548 352 L 483 352 L 480 355 L 482 356 L 480 357 L 482 360 L 482 384 L 554 384 L 556 383 Q 557 386 559 382 L 560 384 L 562 383 L 560 382 L 569 378 L 570 375 L 574 374 L 578 369 Q 577 366 580 367 L 581 362 L 584 361 L 583 359 L 585 359 Q 587 360 586 357 L 584 357 L 585 354 L 585 352 L 588 351 L 588 346 L 587 350 L 586 350 L 588 343 L 586 343 L 587 339 L 588 341 L 589 339 L 589 335 L 588 338 L 585 333 L 586 330 L 585 330 Q 584 325 581 323 L 583 322 L 583 320 L 580 321 L 577 317 L 579 316 L 580 318 L 584 316 L 582 314 L 580 314 Q 579 316 582 315 L 582 316 L 579 315 L 576 315 L 577 313 L 576 313 L 575 312 L 573 312 L 576 310 L 576 308 L 574 309 L 571 310 L 568 308 L 569 306 L 567 307 Q 564 306 566 305 L 565 304 L 563 304 Q 559 305 560 303 L 559 303 L 558 301 L 556 302 L 555 301 L 556 299 L 552 301 Q 547 302 546 300 L 528 300 L 527 301 L 525 301 L 528 299 L 544 299 L 526 298 L 524 297 L 524 299 Q 525 302 520 300 Q 517 299 518 294 Q 515 295 517 297 L 515 296 L 516 294 L 515 294 L 515 293 L 514 291 L 515 288 L 518 290 L 519 290 L 518 285 L 516 285 L 523 281 L 525 282 L 524 282 L 524 283 L 528 281 L 560 281 L 566 281 L 566 283 L 568 283 L 567 282 L 567 256 L 566 280 L 565 280 L 565 256 L 568 255 L 568 252 Q 567 249 566 251 L 565 249 L 564 249 L 562 248 L 561 249 L 521 249 L 519 249 L 513 248 Z M 626 248 L 626 250 L 625 249 L 620 251 L 618 251 L 614 252 L 613 255 L 613 253 Q 610 252 611 256 L 608 257 L 604 262 L 601 261 L 602 265 L 601 264 Q 598 265 600 267 L 597 272 Q 598 274 596 273 L 596 275 L 593 277 L 595 277 L 592 285 L 593 288 L 593 346 L 592 347 L 593 349 L 592 351 L 594 351 L 594 352 Q 591 351 592 354 L 594 353 L 595 355 L 595 359 L 593 361 L 596 362 L 597 360 L 597 362 L 598 365 Q 597 367 600 366 L 599 368 L 602 368 L 601 372 L 603 373 L 605 372 L 606 376 L 608 375 Q 610 374 609 377 L 611 377 L 611 379 L 613 378 L 620 383 L 622 382 L 626 384 L 664 384 L 665 383 L 667 384 L 669 384 L 669 383 L 671 383 L 671 382 L 673 382 L 674 380 L 674 382 L 676 383 L 675 380 L 677 380 L 679 379 L 680 376 L 685 375 L 686 372 Q 688 373 687 371 L 689 371 Q 691 372 690 369 Q 688 367 691 366 Q 693 367 692 365 L 693 362 L 695 363 L 693 361 L 696 356 L 696 351 Q 699 352 698 350 L 698 348 L 697 346 L 697 344 L 697 297 L 698 296 L 697 294 Q 695 287 698 286 L 698 283 L 695 278 L 696 276 L 694 275 L 695 273 L 694 273 L 692 271 L 694 271 Q 695 268 692 269 L 692 267 L 690 267 Q 691 264 688 265 L 685 261 Q 686 256 684 257 L 684 259 L 682 257 Q 679 258 680 256 L 679 256 L 676 253 L 676 251 L 671 251 L 671 249 L 670 251 Q 667 252 668 250 L 667 250 L 663 249 L 661 249 L 659 248 L 657 249 L 631 249 L 626 248 Z M 706 248 L 704 250 L 704 348 L 703 349 L 705 354 L 705 356 L 707 359 L 705 360 Q 706 362 708 360 L 709 363 L 708 362 L 707 364 L 711 366 L 709 367 L 714 370 L 714 372 Q 717 371 716 374 L 719 374 L 722 379 L 723 377 L 723 379 L 738 384 L 777 384 L 777 360 L 778 359 L 777 356 L 778 354 L 777 352 L 744 352 L 742 351 L 743 349 L 739 347 L 736 345 L 736 250 L 733 248 L 731 249 L 729 249 L 712 249 L 711 248 L 709 249 L 706 248 Z M 786 248 L 784 250 L 784 349 L 785 350 L 783 355 L 785 355 L 786 355 L 785 358 Q 788 359 786 361 L 788 361 L 789 364 Q 788 366 791 365 L 791 368 L 794 369 L 793 372 L 795 375 L 795 376 Q 798 377 796 373 L 798 373 L 797 375 L 798 376 L 800 375 L 801 378 L 803 377 L 803 379 L 808 380 L 807 383 L 809 383 L 810 381 L 813 382 Q 814 385 816 383 L 818 384 L 857 384 L 858 383 L 861 384 L 860 383 L 862 382 L 863 383 Q 862 380 865 381 L 867 381 Q 866 377 870 379 L 872 376 Q 875 377 874 375 L 879 370 L 880 371 Q 878 366 883 367 L 882 366 L 884 363 Q 887 364 886 362 L 885 362 L 887 359 L 886 357 L 888 357 L 887 355 L 889 344 L 889 286 L 891 286 L 891 284 L 889 284 L 889 257 L 889 255 L 890 250 L 891 248 L 889 249 L 863 249 L 862 248 L 860 249 L 858 248 Q 855 249 857 251 L 856 254 L 857 256 L 857 336 Q 854 337 856 344 L 856 346 L 854 349 L 850 352 L 825 352 Q 825 349 822 350 L 822 348 L 821 351 Q 818 350 820 349 L 818 348 L 820 347 Q 819 344 818 346 L 816 345 L 816 250 L 813 248 L 811 249 L 809 249 L 791 249 L 788 248 L 786 248 Z M 896 248 L 895 250 L 895 252 L 894 256 L 895 257 L 895 280 Q 893 281 896 282 L 897 281 L 925 281 L 926 284 L 923 283 L 925 285 L 926 286 L 926 384 L 959 384 L 959 288 L 958 287 L 985 286 L 986 283 L 984 284 L 984 285 L 960 285 L 960 283 L 959 285 L 958 285 L 959 283 L 960 281 L 984 281 L 990 281 L 990 283 L 992 283 L 991 282 L 991 256 L 990 280 L 989 280 L 989 256 L 992 255 Q 994 254 992 253 L 993 251 L 990 251 L 989 248 L 987 249 L 985 249 L 897 249 L 896 248 Z M 997 248 L 995 250 L 996 252 L 996 384 L 1028 384 L 1028 384 L 1028 257 L 1028 255 L 1029 251 L 1028 248 L 1026 249 L 1000 249 L 997 248 Z M 1049 248 L 1049 250 L 1048 252 L 1050 254 L 1051 250 L 1049 248 Z M 1056 248 L 1055 250 L 1051 252 L 1053 252 L 1054 254 L 1056 253 L 1054 252 L 1056 251 L 1056 248 Z M 1057 248 L 1057 250 L 1059 249 L 1057 248 Z M 1060 248 L 1059 251 L 1061 251 L 1062 249 L 1060 248 Z M 1074 248 L 1069 249 L 1067 249 Q 1062 248 1063 251 L 1060 252 L 1058 252 L 1051 258 L 1049 257 L 1049 259 L 1047 260 Q 1044 261 1046 263 L 1045 262 L 1044 265 L 1043 265 Q 1044 260 1042 261 L 1042 265 L 1041 267 L 1042 268 L 1038 272 L 1039 273 L 1038 275 L 1035 278 L 1036 279 Q 1037 282 1034 281 L 1033 286 L 1034 288 L 1035 289 Q 1032 288 1033 293 L 1035 292 L 1035 295 L 1035 297 L 1035 349 L 1034 350 L 1037 357 L 1036 359 L 1038 358 L 1042 366 L 1041 368 L 1043 367 Q 1045 368 1043 370 L 1045 370 L 1044 372 L 1048 373 L 1048 374 Q 1045 373 1046 376 L 1048 375 L 1057 379 L 1058 382 L 1061 381 L 1061 383 L 1064 382 L 1068 384 L 1107 384 L 1108 383 L 1110 384 Q 1112 385 1111 383 L 1113 383 Q 1114 379 1120 379 L 1124 375 L 1125 376 Q 1128 374 1127 372 L 1129 373 L 1128 372 L 1129 370 L 1132 368 Q 1134 367 1132 366 L 1135 364 L 1134 363 L 1136 362 L 1135 361 L 1137 358 L 1137 360 L 1138 360 L 1137 357 L 1138 355 L 1138 357 L 1139 357 L 1138 354 Q 1137 349 1141 351 L 1141 349 Q 1138 350 1139 348 L 1142 349 L 1139 344 L 1139 288 L 1140 287 L 1138 282 L 1139 280 L 1141 285 L 1141 282 L 1141 280 L 1139 279 L 1138 277 L 1140 278 Q 1141 275 1138 276 L 1138 274 L 1137 276 L 1136 276 L 1137 274 L 1135 270 L 1134 270 L 1134 269 L 1133 267 L 1134 265 L 1132 266 L 1130 264 L 1129 261 L 1131 265 L 1132 265 L 1129 257 Q 1126 256 1127 259 L 1119 255 L 1120 253 L 1119 253 L 1116 251 L 1116 253 L 1112 251 Q 1109 252 1110 250 L 1112 250 L 1113 248 Q 1108 247 1107 250 L 1104 248 L 1100 249 L 1080 249 Q 1078 247 1074 248 Z M 1177 248 L 1178 250 L 1171 252 L 1169 253 L 1170 251 L 1169 250 Q 1166 251 1168 253 L 1161 259 L 1157 260 L 1156 264 L 1153 265 L 1153 267 Q 1154 269 1151 268 L 1149 273 Q 1146 272 1147 275 L 1149 275 L 1147 278 L 1147 280 L 1145 285 L 1146 287 L 1146 384 L 1147 384 L 1178 384 L 1178 295 L 1179 294 L 1178 290 L 1180 290 L 1180 288 L 1178 288 L 1180 287 L 1179 286 L 1186 281 L 1187 282 L 1185 283 L 1185 284 Q 1189 285 1190 281 L 1209 281 L 1209 284 L 1211 283 L 1212 284 L 1210 284 L 1211 286 L 1213 285 L 1214 282 L 1214 284 L 1216 285 L 1214 286 Q 1215 288 1217 286 Q 1219 287 1217 289 L 1218 291 L 1218 384 L 1250 384 L 1250 288 L 1251 287 L 1250 285 L 1251 282 L 1250 282 L 1249 281 Q 1251 279 1248 278 L 1249 276 Q 1251 277 1251 281 L 1252 281 Q 1253 276 1250 275 Q 1246 276 1247 274 L 1247 271 Q 1243 272 1245 268 L 1243 268 L 1245 265 L 1242 266 L 1240 263 L 1236 259 Q 1233 258 1235 257 L 1230 254 Q 1227 255 1228 252 L 1226 252 Q 1224 248 1223 251 L 1221 251 L 1223 250 L 1223 249 L 1220 250 L 1218 249 L 1185 249 L 1184 248 L 1182 249 L 1177 248 Z M 1277 248 L 1277 249 L 1279 249 L 1277 248 Z M 1285 248 L 1285 250 L 1282 252 L 1280 252 L 1277 253 L 1277 255 L 1275 252 L 1272 254 L 1275 254 L 1274 257 L 1273 255 L 1269 257 L 1272 257 L 1272 258 Q 1269 257 1270 260 L 1265 263 L 1266 265 L 1263 267 L 1263 269 L 1260 271 L 1260 275 L 1258 277 L 1259 278 L 1258 278 L 1258 280 L 1257 282 L 1257 286 L 1256 289 L 1257 291 L 1256 295 L 1256 297 L 1257 300 L 1257 302 Q 1256 304 1259 303 L 1262 313 L 1266 317 L 1265 318 L 1267 318 L 1272 324 Q 1270 325 1273 326 L 1274 324 L 1289 333 L 1291 332 L 1293 332 L 1294 333 L 1292 334 L 1292 335 Q 1297 336 1296 333 L 1320 333 L 1322 333 L 1322 335 L 1325 334 L 1329 341 L 1329 343 L 1327 342 L 1329 346 L 1327 347 L 1327 349 L 1324 351 L 1321 350 L 1322 352 L 1321 351 L 1320 352 L 1258 352 L 1256 354 L 1256 358 L 1257 359 L 1257 384 L 1329 384 L 1330 383 L 1333 384 L 1333 382 L 1335 383 L 1335 382 L 1337 382 L 1338 380 L 1339 382 Q 1341 381 1339 380 L 1341 380 L 1343 379 L 1344 377 Q 1345 374 1347 376 L 1349 375 L 1348 374 L 1350 373 L 1351 374 L 1350 372 L 1352 372 Q 1350 367 1354 368 L 1355 366 L 1358 364 L 1356 363 L 1358 359 L 1360 359 L 1359 357 L 1362 351 L 1361 349 L 1362 347 L 1361 342 L 1362 340 L 1361 338 L 1362 336 L 1359 329 L 1360 326 L 1359 326 L 1356 323 L 1357 321 L 1356 321 L 1353 318 L 1355 318 L 1355 317 Q 1354 314 1353 316 Q 1349 316 1350 312 L 1349 312 L 1347 309 Q 1346 306 1345 308 L 1345 307 L 1342 304 L 1342 306 L 1342 307 L 1339 304 L 1329 301 L 1327 301 L 1322 300 L 1303 300 L 1302 301 L 1295 300 L 1290 295 L 1289 292 Q 1288 289 1291 290 L 1290 289 Q 1289 284 1293 283 L 1295 284 L 1294 283 L 1299 281 L 1299 283 L 1303 281 L 1339 281 L 1340 282 L 1340 257 L 1342 254 L 1341 254 L 1340 251 L 1342 251 L 1339 248 L 1337 248 L 1336 249 L 1291 249 L 1287 250 Q 1288 247 1285 248 Z M 616 249 L 616 250 L 618 250 L 616 249 Z M 1118 249 L 1118 252 L 1119 252 Q 1120 248 1118 249 Z M 1163 249 L 1161 250 L 1161 251 L 1164 250 L 1163 249 Z M 1171 249 L 1171 250 L 1173 250 L 1171 249 Z M 1273 249 L 1274 251 L 1276 250 L 1273 249 Z M 1282 249 Q 1280 252 1283 251 L 1282 249 Z M 499 250 L 499 253 L 500 253 Q 501 249 499 250 Z M 505 250 L 506 252 Q 507 249 505 250 Z M 614 250 L 612 251 L 612 252 L 615 251 L 614 250 Z M 892 250 L 890 253 L 892 252 L 892 250 Z M 1165 250 L 1163 253 L 1166 251 L 1165 250 Z M 678 251 L 679 253 Q 680 250 678 251 Z M 894 251 L 893 254 L 891 254 Q 890 257 894 255 L 894 251 Z M 497 252 L 496 254 Q 498 257 499 254 L 497 252 Z M 1161 253 L 1161 255 L 1163 254 L 1161 253 Z M 1051 254 Q 1051 258 1053 255 L 1051 254 Z M 496 256 L 494 258 L 496 258 L 496 256 Z M 604 256 L 602 258 L 603 259 L 606 258 L 604 256 Z M 892 256 L 891 280 L 890 281 Q 892 284 893 281 L 892 280 L 892 256 Z M 1156 256 L 1154 258 L 1155 260 L 1157 259 L 1156 256 Z M 1238 256 L 1236 258 L 1238 259 L 1238 256 Z M 1132 257 L 1132 258 Q 1135 257 1134 260 L 1135 260 Q 1136 255 1132 257 Z M 1266 257 L 1268 261 Q 1270 260 1268 259 Q 1269 256 1266 257 Z M 1154 258 L 1152 260 L 1154 261 L 1154 258 Z M 489 259 L 488 262 L 489 262 L 489 259 Z M 688 259 L 686 261 L 688 262 L 688 259 Z M 1131 259 Q 1130 262 1133 261 Q 1134 258 1131 259 Z M 1264 259 L 1264 261 L 1266 260 L 1264 259 Z M 1341 262 Q 1340 265 1343 264 Q 1344 261 1341 262 Z M 481 264 Q 480 268 483 271 L 484 271 L 482 267 L 483 265 L 481 264 Z M 486 264 L 484 267 L 486 266 L 486 264 Z M 596 264 L 594 267 L 596 266 L 596 264 Z M 1144 264 L 1144 266 L 1147 268 L 1145 268 L 1144 272 L 1145 273 L 1147 269 L 1148 272 L 1149 265 L 1148 265 L 1144 264 Z M 1151 264 L 1149 269 L 1152 267 L 1151 264 Z M 1258 264 L 1256 266 L 1259 266 L 1258 264 Z M 598 266 L 598 269 Q 601 268 598 266 Z M 1035 266 L 1033 268 L 1035 268 L 1035 266 Z M 1039 267 L 1037 269 L 1040 269 L 1039 267 Z M 1260 267 L 1258 269 L 1259 271 L 1260 269 L 1260 267 Z M 1036 269 Q 1034 274 1037 274 L 1037 272 L 1036 269 Z M 1341 270 Q 1340 273 1343 272 Q 1344 269 1341 270 Z M 483 272 L 484 274 Q 485 271 483 272 Z M 1140 272 L 1141 276 L 1142 273 L 1140 272 Z M 1251 272 L 1249 274 L 1252 274 L 1251 272 Z M 482 274 L 480 278 Q 483 279 482 277 Q 484 275 482 274 Z M 1033 274 L 1033 277 L 1035 276 Q 1036 273 1033 274 Z M 1253 274 L 1254 280 L 1255 280 Q 1256 275 1253 274 Z M 1255 274 L 1255 276 L 1257 275 L 1255 274 Z M 1145 275 L 1144 277 L 1146 278 L 1145 275 Z M 593 278 L 592 281 L 593 281 L 593 278 Z M 1341 278 L 1340 283 L 1341 284 L 1343 282 L 1343 280 Q 1344 277 1341 278 Z M 700 280 Q 702 281 701 287 L 702 287 L 702 280 L 700 280 Z M 1254 280 L 1252 283 L 1253 285 L 1254 283 L 1254 280 Z M 1256 281 L 1256 284 Q 1259 283 1256 281 Z M 562 282 L 560 285 L 528 286 L 561 286 L 562 284 L 562 282 Z M 893 282 L 892 284 L 896 284 L 893 282 Z M 1033 282 L 1032 285 L 1033 285 L 1033 282 Z M 1192 282 L 1186 286 L 1183 285 L 1182 287 L 1185 288 Q 1187 285 1191 286 L 1192 284 L 1192 282 Z M 563 283 Q 562 286 565 285 Q 566 282 563 283 Z M 987 283 Q 986 286 989 285 Q 990 282 987 283 Z M 1297 283 L 1297 284 L 1299 284 L 1297 283 Z M 524 284 L 524 285 L 528 285 L 524 284 Z M 1337 284 Q 1336 286 1339 286 L 1337 286 L 1338 288 L 1340 287 Q 1342 283 1337 284 Z M 1342 284 L 1341 286 L 1344 286 L 1342 284 Z M 520 285 L 520 289 L 520 288 Q 522 286 520 285 Z M 897 285 L 897 286 L 922 286 L 924 288 L 924 287 L 923 285 L 897 285 Z M 1193 285 L 1193 286 L 1208 286 L 1193 285 Z M 1295 285 L 1294 287 L 1298 287 L 1295 285 Z M 1299 285 L 1299 286 L 1303 286 L 1299 285 Z M 1305 285 L 1305 286 L 1336 286 L 1305 285 Z M 526 286 L 526 287 L 528 287 L 526 286 Z M 565 286 L 566 288 L 568 287 L 565 286 Z M 892 286 L 893 288 Q 894 285 892 286 Z M 989 286 L 990 288 L 992 287 L 989 286 Z M 1142 286 L 1141 288 L 1145 288 L 1142 286 Z M 1292 286 L 1291 289 L 1293 289 L 1292 286 Z M 702 288 L 701 296 L 702 296 L 702 288 Z M 1296 288 L 1295 291 L 1296 291 L 1296 288 Z M 516 290 Q 514 293 517 292 L 516 290 Z M 1181 290 L 1180 296 L 1181 296 L 1181 290 Z M 1292 290 L 1291 292 L 1293 293 L 1292 290 Z M 1183 291 L 1182 294 L 1183 294 L 1183 291 Z M 1217 291 L 1216 296 L 1217 296 L 1217 291 Z M 1296 293 L 1293 296 L 1295 299 L 1295 298 Q 1293 296 1296 295 L 1296 293 Z M 521 296 L 521 297 L 523 297 L 521 296 Z M 545 296 L 546 299 L 552 298 L 553 299 Q 554 296 551 297 L 549 297 L 545 296 Z M 700 296 L 699 344 L 700 344 L 700 296 Z M 1034 296 L 1033 347 L 1034 347 L 1034 296 Z M 1296 296 L 1296 297 L 1298 297 L 1296 296 Z M 1323 296 L 1323 299 L 1323 300 L 1327 299 Q 1329 300 1328 298 L 1327 298 Q 1324 299 1325 296 L 1323 296 Z M 1301 297 L 1303 299 L 1320 299 L 1301 297 Z M 1331 297 L 1330 299 L 1333 298 L 1331 297 Z M 520 298 L 520 299 L 523 299 L 520 298 Z M 557 298 L 557 299 L 560 299 L 557 298 Z M 548 299 L 548 300 L 552 300 L 548 299 Z M 1331 300 L 1331 301 L 1333 301 L 1331 300 Z M 573 304 L 573 305 L 575 305 L 573 304 Z M 1345 304 L 1346 306 L 1347 306 L 1345 304 Z M 481 305 L 481 307 L 483 306 L 481 305 Z M 1350 307 L 1351 308 L 1352 309 Q 1353 306 1350 307 Z M 483 309 L 482 311 L 485 312 L 483 309 Z M 1258 310 L 1258 312 L 1260 311 L 1258 310 Z M 1261 311 L 1260 314 L 1261 314 L 1261 311 Z M 1354 312 Q 1352 315 1355 314 L 1354 312 Z M 1356 312 Q 1356 316 1358 313 L 1356 312 Z M 1262 314 L 1264 317 L 1265 317 L 1262 314 Z M 1257 316 L 1258 319 L 1258 317 L 1260 317 L 1257 316 Z M 1356 316 L 1356 318 L 1358 317 L 1356 316 Z M 1261 317 L 1259 320 L 1261 320 L 1263 320 L 1263 318 L 1261 317 Z M 1359 317 Q 1357 320 1360 319 L 1359 317 Z M 490 320 L 490 322 Q 489 325 492 324 L 491 322 Q 492 319 490 320 Z M 1267 321 L 1266 323 L 1268 324 L 1267 321 Z M 1270 322 Q 1268 325 1271 324 L 1270 322 Z M 493 324 L 492 326 L 497 326 L 493 324 Z M 489 325 Q 488 328 491 327 Q 492 324 489 325 Z M 498 326 L 497 328 L 499 327 L 498 326 Z M 1267 326 L 1267 328 L 1269 327 L 1267 326 Z M 1361 328 L 1363 336 L 1364 336 Q 1365 331 1362 331 L 1363 329 L 1361 328 Z M 1281 330 L 1282 332 L 1283 332 L 1281 330 Z M 1366 330 L 1367 336 L 1368 331 L 1366 330 Z M 506 331 L 505 333 L 507 332 L 506 331 Z M 588 331 L 587 334 L 588 334 L 588 331 Z M 590 331 L 589 335 L 591 335 L 590 331 Z M 1287 333 L 1286 335 L 1288 334 L 1287 333 Z M 1290 333 L 1288 335 L 1290 335 L 1290 333 Z M 516 334 L 516 335 L 518 335 L 516 334 Z M 1325 335 L 1323 337 L 1324 339 L 1325 337 L 1325 335 Z M 591 336 L 589 340 L 590 341 L 590 349 L 591 349 L 591 336 Z M 891 336 L 890 341 L 891 341 L 891 336 Z M 894 336 L 893 339 L 894 339 L 894 336 Z M 1365 336 L 1365 339 L 1366 339 Q 1367 335 1365 336 Z M 1326 339 Q 1326 343 1328 340 L 1326 339 Z M 1364 339 L 1363 343 L 1364 343 L 1364 339 Z M 1367 339 L 1366 342 L 1367 342 L 1367 339 Z M 1322 340 L 1324 343 L 1325 343 L 1322 340 Z M 1366 343 L 1364 345 L 1366 346 L 1366 343 Z M 701 344 L 701 345 Q 703 344 702 347 L 703 347 Q 704 343 701 344 Z M 741 344 L 740 347 L 742 347 Q 743 343 741 344 Z M 820 344 L 820 346 L 822 345 L 820 344 Z M 852 344 L 852 345 L 854 345 L 852 344 Z M 698 345 L 698 347 L 700 346 L 698 345 Z M 547 346 L 547 348 L 546 348 L 545 350 L 548 349 Q 549 345 547 346 Z M 551 346 L 549 348 L 551 348 L 551 346 Z M 1364 346 L 1363 352 L 1366 352 L 1364 351 L 1364 346 Z M 701 347 Q 698 348 700 350 Q 699 352 702 351 L 703 352 Q 704 349 701 350 L 701 347 Z M 849 347 L 848 350 L 849 350 L 849 347 Z M 1367 347 L 1366 351 L 1367 351 L 1367 347 Z M 1324 348 Q 1324 352 1326 349 L 1324 348 Z M 1032 350 L 1032 352 L 1035 353 L 1034 352 Q 1035 349 1032 350 Z M 587 353 L 586 356 L 587 356 L 587 353 Z M 591 353 L 590 357 L 591 357 L 591 353 Z M 1142 353 L 1140 355 L 1142 355 L 1142 353 Z M 778 354 Q 777 357 780 356 Q 781 353 778 354 Z M 589 355 L 588 358 L 589 358 L 589 355 Z M 782 355 L 780 358 L 783 356 L 782 355 Z M 1034 355 Q 1032 358 1035 357 L 1034 355 Z M 591 357 L 592 360 L 593 358 L 591 357 Z M 1142 357 Q 1141 360 1144 359 Q 1145 356 1142 357 Z M 785 358 L 783 360 L 785 361 L 785 358 Z M 780 359 L 779 384 L 780 384 L 780 359 Z M 1036 360 L 1033 367 L 1034 368 L 1035 366 L 1038 367 L 1036 360 Z M 1038 361 L 1037 363 L 1039 364 L 1038 361 Z M 595 362 L 593 364 L 595 364 L 595 362 Z M 705 363 Q 703 366 706 365 L 705 363 Z M 787 363 L 786 364 Q 783 363 784 366 L 787 366 L 788 364 L 787 363 Z M 581 364 L 581 366 L 583 367 Q 584 363 581 364 Z M 706 365 L 706 367 L 708 366 L 706 365 Z M 885 365 L 884 367 L 886 368 L 885 365 Z M 1357 365 L 1358 367 Q 1359 364 1357 365 Z M 593 366 Q 592 369 595 368 Q 596 365 593 366 Z M 584 367 L 583 369 L 581 369 Q 580 372 584 370 L 584 367 Z M 580 368 L 578 370 L 580 370 L 580 368 Z M 1133 368 L 1131 370 L 1133 370 L 1133 368 Z M 578 370 L 576 372 L 578 372 L 578 370 Z M 581 370 L 579 372 L 581 372 L 581 370 Z M 1042 370 L 1041 372 L 1043 373 L 1042 370 Z M 584 371 L 581 372 L 582 374 L 584 373 L 584 371 Z M 1132 371 Q 1130 374 1133 373 L 1132 371 Z M 579 372 L 578 375 L 580 375 L 579 372 Z M 714 372 L 713 374 L 716 375 L 714 372 Z M 878 372 Q 878 375 876 374 L 876 375 L 879 374 Q 881 375 880 373 L 878 372 Z M 1135 372 L 1134 375 L 1135 375 L 1135 372 Z M 575 373 Q 574 376 577 375 Q 578 372 575 373 Z M 793 373 L 794 375 Q 795 372 793 373 Z M 1044 373 L 1043 375 L 1045 376 L 1044 373 Z M 713 374 Q 711 377 714 376 L 713 374 Z M 1124 376 L 1122 378 L 1124 378 L 1124 376 Z M 1127 376 L 1124 380 L 1127 378 L 1127 376 Z M 571 378 L 569 380 L 571 380 L 571 378 Z M 573 379 L 573 381 L 576 382 L 576 381 L 573 379 Z M 680 379 L 678 381 L 679 383 L 680 381 L 680 379 Z M 871 379 L 870 384 L 872 384 L 872 379 L 871 379 Z M 802 380 L 800 382 L 802 382 L 802 380 Z M 803 380 L 803 382 L 806 383 L 805 382 Q 806 379 803 380 Z M 1053 380 L 1053 381 L 1055 381 L 1053 380 Z M 1127 380 L 1125 382 L 1126 384 L 1127 384 L 1127 380 Z M 1343 380 L 1342 382 L 1339 383 L 1343 383 L 1343 380 Z M 572 381 L 570 383 L 573 384 L 575 384 L 572 381 Z M 1049 381 L 1049 382 L 1052 382 L 1049 381 Z M 1120 381 L 1120 382 L 1122 382 L 1120 381 Z M 867 382 L 867 383 L 869 383 L 867 382 Z M 1053 382 L 1053 383 L 1055 383 L 1053 382 Z M 1119 382 L 1117 384 L 1120 384 L 1119 382 Z M 1124 382 L 1125 384 Q 1126 381 1124 382 Z M 616 383 L 616 384 L 618 384 L 616 383 Z M 1049 383 L 1049 384 L 1051 384 L 1049 383 Z M 436 384 L 434 387 L 436 386 L 436 384 Z M 426 386 L 427 388 Q 428 385 426 386 Z M 437 386 Q 435 389 438 388 L 437 386 Z M 430 387 L 429 389 L 432 391 L 432 400 L 434 400 Q 437 399 436 393 Q 435 390 434 392 L 434 391 L 430 387 Z M 426 388 L 424 390 Q 423 393 426 392 L 426 390 L 426 388 Z M 429 390 L 429 392 L 431 391 L 429 390 Z M 438 390 L 436 392 L 438 392 L 438 390 Z M 446 398 Q 445 401 448 400 Q 449 397 446 398 Z "
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1168.5 0 L 1328 0.5 L 1326.5 2 L 1169.5 2 L 1168.5 0 Z "
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 906 8 L 912.5 9 L 913.5 8 L 960 8 L 960.5 10 L 961 8 Q 963.7 6.9 963 9.5 L 968 13.5 L 967 15.5 L 972 17.5 Q 973.3 22.8 970.5 24 L 969 24.5 L 970 26.5 L 969 26.5 L 968 24.5 L 969 22.5 L 968 18 L 966 17.5 Q 968.3 16.3 965.5 15 L 964 15.5 L 965 17.5 L 964 17.5 L 962.5 15 L 961 14.5 L 963 13.5 L 912.5 13 L 910.5 12 Q 909.2 14.2 904.5 13 L 903.5 12 L 901 13.5 L 902 11 L 900 10.5 L 901.5 10 L 903.5 11 L 906 10 L 906 8 Z M 961 11 L 961 12 L 963 12 L 961 11 Z "
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1169 8 L 1326.5 8 L 1327 9.5 L 1328.5 12 L 1326.5 13 L 1168.5 13 Q 1165.3 11.3 1169 9.5 L 1169 8 Z "
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1163.5 12 L 1164 14 L 1161 13.5 L 1163.5 12 Z "
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1333.5 12 L 1334.5 14 Q 1331.7 14.7 1333.5 12 Z "
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1046 26 Q 1049.3 24.9 1048 29 Q 1044.7 30.1 1046 26 Z "
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1041 29 Q 1044.7 27.5 1044 30.5 L 1045 32.5 L 1044 34.5 L 1044.5 36 L 1043 35.5 Q 1042.3 37.8 1044.5 37 L 1044.5 38 L 1042 36.5 L 1041 29 Z "
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 715.5 36 L 716.5 38 L 715.5 36 Z "
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322 38 L 324 38.5 L 323 41 L 325.5 40 L 326 42 Q 323.3 40.9 324 43.5 L 320 46 L 321 49.5 L 321 78.5 L 319 82 Q 324.2 80.3 323 84 L 257.5 84 Q 258.3 80.7 253 82 L 252.5 84 L 240.5 84 L 242 86.5 L 240.5 88 L 236 89 Q 237.6 93.9 232 92 L 232 95.5 L 231 99.5 Q 233.3 100.8 232 105.5 Q 228.5 106 229 110.5 L 231.5 112 L 234.5 111 L 237 113.5 L 236.5 115 L 235 114.5 L 236 123.5 Q 233 124.8 234 129 L 238 128 Q 236.5 124.3 239.5 125 L 242 124 L 241 126.5 L 244.5 128 L 247.5 127 L 250.5 129 L 287.5 129 L 291.5 130 L 298 129 Q 296.8 132 300.5 131 L 305.5 133 L 307.5 132 Q 308.5 135 313.5 134 L 313.5 133 L 311 131.5 L 312.5 132 L 319.5 134 L 326 138 Q 327.1 140.7 324.5 140 Q 322.1 135.4 314.5 136 L 310 138.5 L 315 139.5 L 304 143.5 L 311.5 144 L 315.5 141 L 321.5 140 L 321.5 142 L 329 145 L 329.5 143 L 332.5 144 L 334 143.5 L 334.5 145 Q 335.8 142.8 337 145.5 L 336 148.5 L 338.5 152 L 342 151.5 L 340 150.5 L 341.5 150 L 345 152.5 Q 342.3 154.2 346.5 156 L 348 156.5 L 345 157 Q 342.9 162.2 347.5 161 L 351 160 L 352 164.5 L 351 167.5 L 353.5 171 L 355.5 168 L 357 170.5 L 355 174.5 L 355.5 176 L 353.5 173 L 351 182.5 Q 352.5 185.5 354 182.5 Q 352.3 176.7 356 178 L 356 184 L 358 184 L 358 179 L 360 179 Q 361.2 184.1 358 185.5 L 358 191.5 L 358 193.5 L 357.5 203 Q 357.9 192.1 354.5 185 L 353 190.5 L 354 191.5 L 354 202.5 L 353 205.5 L 354 208 Q 351.3 206.9 352 209.5 Q 354.2 210.8 353 215.5 Q 350.3 217.3 352 223.5 L 350.5 226 L 348 225 L 348 230.5 L 342.5 238 L 341 238.5 L 341.5 240 L 338 239 Q 339 242 336 241 L 336 243.5 L 336.5 245 L 334 246.5 L 333.5 249 L 330.5 248 L 328 249.5 L 331 250.5 L 324 254 L 321.5 249 L 320.5 251 Q 323.1 250.2 322 253.5 L 323 256 L 313 256.5 L 316 258 Q 317 261 314 260 L 313.5 258 L 311.5 261 L 303 259 Q 301.2 263.9 307.5 262 L 307.5 263 L 305.5 264 L 221.5 264 L 220.5 265 L 189.5 265 L 188.5 264 L 182 264 L 182 260 L 176 260 L 174.5 264 L 92.5 264 L 90.5 265 L 89 264.5 L 88 270.5 L 88 272.5 L 88 286.5 L 86 288.5 L 86 352 L 88 351.5 L 88 289.5 L 89 289.5 L 89 350.5 L 91 352.5 L 88.5 354 L 47 354 L 48 351.5 L 48 194.5 Q 45.2 192.8 46 187.5 L 48 182.5 L 47 180.5 L 50 173 L 52 172.5 L 50 169.5 L 52 170.5 L 53 173.5 L 52 177 Q 55 178.3 54 174.5 L 57 169 L 54 167.5 L 57 166.5 Q 58 162.8 55 164 Q 56.3 167 52.5 166 L 51 166.5 L 55 163.5 L 54 161.5 L 55 161.5 Q 54.1 164.9 59.5 163 Q 62.5 161.5 59.5 160 L 57.5 159 L 56 159.5 Q 55.2 156.9 58.5 158 Q 60 160.5 61.5 157 L 63 157.5 L 61 158 Q 59.8 161 63.5 160 L 68.5 157 L 71.5 161 Q 75.7 162.3 74 157.5 L 73 154.5 L 78 150.5 L 80 146 Q 74.4 145 73 149.5 L 71.5 153 L 64 154 Q 65 157 62 156 Q 60.9 153.3 63.5 154 L 63.5 153 Q 61.3 153.8 62 151.5 L 64.5 151 L 69 150 Q 67.9 147.3 70.5 148 L 73 144 L 80 144 L 80 141.5 L 78 141.5 L 78 139.5 L 80.5 137 L 85 136 Q 83.7 139.7 89.5 138 L 87.5 134 L 91.5 134 L 92 136 L 94.5 136 L 96.5 137 L 101.5 135 L 103.5 136 Q 101.7 133.5 106.5 131 L 112.5 129 L 159.5 129 Q 161 131.5 162.5 128 L 164 128.5 Q 161.1 133.4 162 141 L 166 139 L 168.5 145 L 171.5 144 L 175 145 L 175.5 143 L 177 145.5 L 176 147.5 L 177.5 150 L 175 151.5 L 176.5 157 L 179 153.5 Q 176.8 152.3 179.5 151 L 181 153.5 Q 176.3 154.9 177 160 Q 181.1 158.7 180 162 L 183.5 162 L 186 162.5 L 185 164.5 L 188 168.5 Q 184.2 169.7 185 174 L 181 173.5 L 183 172.5 L 182 169 Q 184.7 170.1 184 167.5 L 185 165.5 L 183.5 166 Q 180.9 165.3 182 168 L 180 168 L 180 163 L 177.5 163 L 176 165.5 Q 179.7 166.2 179 171.5 L 178 174 L 104.5 174 L 104 176 L 101.5 176 L 98.5 178 L 98 176 Q 94.7 174.7 96 179.5 L 91 184.5 L 91 188 Q 87 186.6 89 193.5 L 88 197.5 L 90 207.5 L 88.5 213 L 88 204 Q 85 202.8 86 206.5 Q 82.5 208.2 84 214 L 89 214 L 89 221.5 L 92 223.5 Q 88.4 220.6 90 212.5 L 91.5 213 L 95 214 L 94 216.5 L 95 219.5 L 92 218.5 L 93.5 222 Q 95.8 221.3 95 223.5 L 97.5 225 L 100.5 220 L 105 220.5 L 104.5 222 L 110 221.5 L 109.5 220 L 215.5 220 L 216.5 221 L 219.5 220 L 221.5 221 Q 223 217.5 224.5 220 L 286.5 220 L 292 223.5 Q 291.1 226.5 295.5 225 L 297 223.5 L 296.5 220 L 304 216.5 L 305.5 214 L 307 214.5 L 305 215 Q 303.5 218.8 306.5 218 L 310 219 Q 308.3 223.1 312.5 222 L 317 219.5 L 318 209.5 L 316 206 L 312 204.5 L 316 201.5 L 316.5 203 L 317 200.5 L 316 198.5 L 318 189.5 L 317.5 188 Q 318.8 190.3 320 187.5 L 318 182 Q 315.3 183.1 316 180.5 L 312 178 Q 313.3 181 309.5 180 L 305.5 176 Q 300.9 176.6 299.5 174 L 294 174 Q 295.3 170.7 290.5 172 L 290.5 173 L 293 173.5 L 256.5 174 L 256.5 173 L 288 172.5 L 255 172 L 254.5 174 L 246.5 174 L 246.5 172 Q 241 173.5 239.5 171 L 237.5 171 L 232.5 169 L 231 169.5 L 229.5 167 Q 226.9 167.7 228 165 L 231 164.5 L 228.5 163 L 224 164 L 223.5 166 L 222.5 164 Q 225.1 164.7 224 162 L 219 161.5 L 219.5 160 L 215 159 L 214.5 155 L 212 156 Q 213.7 151.9 209.5 153 Q 206.5 152.5 207 148.5 L 208 145.5 L 204 147.5 Q 205 141 200.5 140 Q 197.9 140.8 199 137.5 L 199.5 136 Q 196.2 137.1 197 134.5 L 195.5 128 L 194.5 130 L 194 128.5 L 194 126.5 Q 193.7 119.3 190 115.5 L 192 115 L 191 112.5 L 193 112 Q 194 108.2 191.5 107 L 189.5 108 L 189 104.5 L 190 98 Q 193 99.3 192 95.5 L 191 95.5 L 190.5 97 L 189 93.5 L 192 89.5 L 192 84.5 L 190 81.5 Q 192.3 76.7 194.5 81 Q 199 82 200 79.5 L 199 76.5 L 200.5 74 L 203 75 L 204 70 Q 207 71.3 206 67.5 L 204.5 68 Q 200.8 69.3 202 65.5 L 201 65.5 L 201 69 Q 198.3 67.9 199 70.5 L 198.5 73 L 196.5 72 L 197 73.5 Q 197.7 76.1 195 75 L 196.5 71 L 198 70.5 L 197 69.5 L 200 66.5 L 201.5 64 L 210 62 Q 208.9 59.3 211.5 60 L 213.5 59 L 218 60 L 215 54.5 L 216.5 55 L 222 57.5 Q 220.9 61.7 225 60 Q 226 54.8 223 52.5 L 224 50.5 L 221.5 52 L 220 50.5 L 222 50 L 221 47.5 L 223.5 46 L 225.5 47 L 225.5 45 L 228 46.5 L 226 47.5 L 229.5 48 L 231.5 46 Q 237.8 47.8 239.5 45 L 240.5 46 L 252 46 L 250.5 42 L 241.5 44 L 239 42.5 L 241.5 40 Q 247.8 41.7 249.5 39 L 318.5 39 L 318.5 40 L 257.5 40 L 257 42 L 319.5 42 L 320 44 L 321.5 44 L 323 41.5 L 322 38 Z M 256 44 L 257 46 L 320 46 L 320 44 L 256 44 Z M 232 47 L 232 48 L 234 48 L 232 47 Z M 221 60 L 216 64 L 220 65 L 222 62 Q 223 59 221 60 Z M 212 62 Q 209 64 212 65 L 215 64 Q 216 60 212 62 Z M 208 63 L 206 66 L 209 66 L 208 63 Z M 208 71 L 204 76 L 204 79 L 202 80 L 205 81 Q 207 80 206 76 L 209 75 L 208 71 Z M 241 79 Q 238 81 241 82 L 246 82 L 241 79 Z M 249 80 L 249 81 L 252 81 L 249 80 Z M 233 88 Q 232 91 235 90 Q 236 87 233 88 Z M 227 97 L 226 106 L 225 107 L 227 109 L 229 108 L 228 99 L 227 97 Z M 224 110 L 225 117 L 227 118 Q 229 117 228 113 L 224 110 Z M 230 114 L 229 124 L 225 126 L 227 129 L 231 128 L 230 125 L 232 124 L 235 120 L 234 117 L 230 114 Z M 197 120 L 196 123 L 197 123 L 197 120 Z M 298 133 L 296 135 L 298 136 L 298 133 Z M 300 133 L 300 135 L 300 138 Q 304 137 303 140 Q 308 141 309 139 L 304 137 L 309 135 L 300 133 Z M 106 134 L 106 137 L 110 139 L 112 138 Q 114 139 113 136 Q 111 132 106 134 Z M 96 138 L 96 141 L 91 144 Q 92 146 96 145 L 98 142 Q 103 141 104 145 L 112 145 L 113 144 L 112 142 L 103 141 L 100 138 L 96 138 Z M 85 140 L 83 143 Q 84 145 88 144 Q 90 138 85 140 Z M 161 141 L 159 143 Q 158 147 162 145 L 162 141 L 161 141 Z M 288 142 Q 287 146 292 144 Q 293 140 288 142 Z M 214 152 L 214 154 L 216 153 L 214 152 Z M 340 153 Q 337 154 338 159 L 341 160 L 343 160 L 341 155 Q 342 152 340 153 Z M 78 154 L 78 159 Q 80 162 81 159 Q 83 152 78 154 Z M 230 160 L 230 162 L 236 162 L 236 160 L 230 160 Z M 64 164 L 55 176 L 61 177 L 62 173 Q 60 167 64 168 L 64 164 Z M 238 168 L 239 170 Q 242 171 241 169 L 240 169 L 238 168 Z M 292 168 L 292 169 L 294 169 L 292 168 Z M 108 169 L 108 170 L 112 170 L 108 169 Z M 118 170 L 119 172 L 109 173 L 175 173 L 175 172 L 121 172 L 120 170 L 118 170 Z M 290 170 L 290 171 L 296 171 L 290 170 Z M 296 171 L 296 173 L 298 172 L 296 171 Z M 302 172 L 303 173 L 304 174 Q 305 171 302 172 Z M 311 176 Q 309 179 312 178 L 311 176 Z M 318 176 L 320 179 Q 321 175 318 176 Z M 318 196 L 318 204 L 320 204 L 320 197 L 318 196 Z M 304 218 L 303 219 Q 300 218 301 222 Q 302 225 306 224 Q 307 221 304 222 L 304 218 Z M 113 221 L 113 222 L 216 222 L 113 221 Z M 218 221 L 218 224 Q 221 223 218 221 Z M 319 221 L 317 224 L 320 225 L 321 223 L 319 221 Z M 346 224 L 345 230 L 346 230 L 346 224 Z M 96 256 L 97 258 L 176 258 L 176 256 L 96 256 Z M 288 256 Q 287 260 292 258 Q 293 254 288 256 Z "
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 41 L 233.5 43 L 232 42.5 L 234.5 41 Z "
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236 41 Q 239 40 238 43 Q 235 44 236 41 Z "
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 713.5 42 L 715 42.5 L 710.5 50 L 711 48.5 L 713.5 42 Z "
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 801.5 42 L 802.5 44 L 801.5 42 Z "
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 804.5 45 L 806.5 48 L 804.5 45 Z "
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 52 L 213 53.5 L 212 57 Q 207.8 56 206.5 59 L 209.5 55 Q 212.8 56.1 212 53.5 L 213.5 52 Z "
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 709.5 52 Q 712.3 53.2 710 54.5 L 708.5 59 L 708 57.5 L 709.5 52 Z "
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1334.5 55 L 1337 56.5 Q 1338.5 60.9 1335.5 60 L 1334 60.5 L 1335 58.5 Q 1331.3 56.7 1334.5 55 Z "
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1255 57 L 1258.5 58 L 1260 57.5 L 1257 59.5 L 1258 61.5 L 1257 61.5 L 1255 57 Z "
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 985.5 59 L 986 60.5 L 984.5 64 L 984 61.5 L 985.5 59 Z "
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1255.5 61 L 1256 64 Q 1253.3 62.9 1254 65.5 L 1253 65.5 Q 1252.5 61.5 1255.5 61 Z "
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 809.5 65 L 811.5 66 L 813 65.5 L 812 67.5 L 814 70.5 L 813.5 73 Q 810.5 73.9 812 69.5 L 809.5 65 Z "
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1030.5 69 L 1030 70.5 L 1029.5 72 L 1029 70.5 L 1030.5 69 Z "
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 989.5 73 L 990.5 75 L 989.5 73 Z "
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1318.5 74 L 1320 77.5 L 1318 78.5 L 1319 76.5 L 1316 77.5 L 1318.5 74 Z "
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 75 L 193 76.5 L 192.5 78 L 192 76.5 L 193.5 75 Z "
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 695.5 75 L 698 76.5 Q 697.3 80.3 699.5 81 L 701 80.5 L 700 84 L 697.5 85 L 694 79.5 L 694 76.5 L 695.5 75 Z "
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 757.5 76 L 759 78.5 L 755.5 80 L 755.5 79 L 757 78.5 Q 754.8 77.3 757.5 76 Z "
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1025 76 L 1027 76.5 L 1026.5 79 Q 1023.5 79.7 1025 76 Z "
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1241 80 L 1243 80.5 L 1241 81.5 L 1241 80 Z "
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 755.5 82 Q 758.8 80.9 758 83.5 L 756.5 86 L 754 85 L 755.5 82 Z "
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189 85 Q 192 84 191 87 Q 188 85.8 189 89.5 L 187 90.5 L 189 85 Z "
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1021.5 85 L 1022 87.5 L 1020 86.5 L 1021.5 85 Z "
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 759.5 87 L 763 89.5 L 761.5 93 L 760 92.5 L 760 96 Q 763 94.8 762 98.5 Q 760.8 101.2 759.5 99 L 757 100.5 L 756 113 Q 760 114.4 758 107.5 L 760 104 L 762 103.5 L 761.5 102 L 766.5 106 L 768 105.5 L 771 114.5 L 770 116.5 L 770.5 120 L 769 119.5 L 767 123.5 L 767 128.5 L 767 130.5 Q 765.8 135.8 768.5 137 Q 771.3 135.8 770 130.5 L 770 128.5 Q 769 124 771.5 123 L 772.5 125 L 774 124.5 L 775 126.5 L 774.5 128 Q 777.9 127.1 776 132.5 L 779 136.5 Q 775.5 138 778 139.5 L 776.5 143 L 776 141 Q 773.3 139.9 774 142.5 L 774.5 144 L 772 144 L 772 140 L 770.5 140 L 769 143 L 748.5 143 L 744.5 142 L 743.5 143 L 736 143 Q 734.8 140 738.5 141 Q 742 140 741 134.5 L 738 133 L 737.5 135 L 737 133.5 L 740.5 132 Q 741.8 134.2 746.5 133 Q 750.7 131.7 750 125.5 L 747 123.5 L 744.5 128 L 740.5 125 L 739 125.5 L 743 123.5 L 741.5 119 L 743.5 118 L 744.5 121 Q 746.8 120.3 746 122.5 L 747 122.5 L 748 118.5 Q 745 116.3 746 111 Q 748.7 109.9 748 112.5 L 751.5 120 Q 754.3 118.8 753 113.5 L 749.5 109 L 747.5 109 L 745.5 110 L 746 108.5 Q 745.3 105.9 748 107 L 748 103.5 L 747.5 102 Q 750.1 101.3 749 104 L 751 104 L 751 106.5 L 750 109 L 754 107.5 Q 755 103 752.5 102 Q 750.3 102.8 751 100.5 L 749 97.5 Q 752.1 95.7 750.5 94 L 758 92 Q 757 88.2 759.5 87 Z M 757 94 L 750 98 L 755 99 L 757 96 L 757 94 Z M 763 109 L 761 112 L 764 113 L 765 111 L 763 109 Z M 744 124 L 742 126 L 744 126 L 744 124 Z M 775 130 Q 771 131 772 136 L 775 137 L 776 135 L 775 130 Z M 750 136 Q 748 141 752 140 Q 754 135 750 136 Z "
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1017.5 89 L 1020 93 L 1017.5 94 Q 1014.7 92.8 1017 91.5 L 1017.5 89 Z "
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 626 92 L 628 92.5 L 627.5 95 L 626 92 Z "
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 93 L 187.5 95 Q 184.7 95.7 186.5 93 Z "
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 690.5 98 L 691.5 101 Q 693.8 100.3 693 102.5 L 691.5 105 L 691 103.5 L 692 102.5 L 690 100.5 L 690.5 98 Z "
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1006.5 99 L 1010 101.5 Q 1011.1 104.8 1008.5 104 Q 1010.2 106 1006.5 108 L 1007 102.5 L 1006.5 99 Z "
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 953.5 101 Q 956.5 102.5 953.5 104 Q 950.5 102.5 953.5 101 Z "
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1301.5 101 Q 1305 103 1300.5 105 L 1296.5 106 L 1294 105.5 L 1296.5 102 L 1297 104 L 1301 103.5 Q 1298.8 102.3 1301.5 101 Z "
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1060.5 102 L 1063 108.5 L 1060 108.5 L 1060.5 107 Q 1057.9 107.8 1059 104.5 L 1060.5 102 Z "
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1223 103 L 1225 103.5 L 1222.5 107 L 1223 105.5 L 1223 103 Z "
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 951.5 104 L 954 105 Q 954.8 108.1 952 107.5 L 952 113 L 956.5 112 L 959 112.5 L 958 113.5 L 958 227.5 L 954.5 234 L 951.5 235 L 948 232.5 L 949 230 L 946 229.5 L 950.5 228 L 951.5 231 L 954 230 L 954 223.5 L 952.5 223 L 951 223.5 L 951.5 104 Z "
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1010 106 L 1012 106.5 L 1010.5 110 L 1010 106 Z "
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 744.5 112 L 744 113.5 L 743.5 117 L 743 113.5 L 744.5 112 Z "
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1008.5 112 L 1011 113.5 L 1008.5 117 L 1009 115.5 Q 1009.8 113.3 1007.5 114 L 1008.5 112 Z "
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 684.5 115 Q 686.8 114.3 686 116.5 L 686 118.5 L 685.5 120 L 685 118 Q 682.3 119.1 683 116.5 L 684.5 115 Z "
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1212.5 118 L 1211.5 120 L 1212.5 118 Z "
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 960.5 121 L 963 127 L 966 128.5 L 963 128.5 L 962.5 127 L 961 133.5 L 965 138.5 L 965 142 L 962 142 L 962 147 L 960 147 L 960 136.5 L 961 134.5 L 960 132.5 L 961 130.5 L 959 130.5 L 959.5 128 L 961 128.5 L 962 126.5 Q 959 124.7 960.5 121 Z "
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 740.5 127 L 739.5 129 L 740.5 127 Z "
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1276.5 127 L 1276 128.5 L 1276.5 130 L 1278 129.5 L 1276.5 133 L 1275 128.5 L 1276.5 127 Z "
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 299.5 129 Q 303.3 128.3 304 130.5 L 302.5 131 L 299.5 130 L 299.5 129 Z "
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 130 L 170 132.5 L 168 131.5 L 168.5 130 Z "
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 131 L 97 132.5 L 94.5 133 L 93 132.5 L 94.5 131 Z "
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1273.5 131 L 1274 133 L 1271.5 134 L 1273.5 131 Z "
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166 133 Q 168.7 131.9 168 134.5 L 169.5 134 Q 173.7 132.7 172 137.5 L 172.5 139 L 168 138.5 L 169 136 L 166 134.5 L 166 133 Z "
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 966.5 133 L 967.5 135 L 969 134.5 L 966 136.5 L 966.5 133 Z "
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1269 135 L 1271 135.5 L 1268.5 140 L 1265 141 L 1264.5 143 L 1264 141.5 L 1267 140 L 1269 135 Z "
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 676.5 138 L 679 139.5 L 678.5 141 L 676 140.5 L 676.5 138 Z "
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 968.5 139 Q 972.3 138 971 141 Q 968.3 139.9 969 142.5 Q 971.3 143.8 970 148.5 L 974.5 154 L 976.5 153 L 977 154.5 L 976.5 156 Q 978.8 155.3 978 157.5 L 978 159.5 Q 977.3 162.1 980 161 L 980 163.5 L 979.5 166 Q 977.3 166.8 978 164.5 L 975.5 158 Q 970.8 158.8 970 155.5 L 968.5 152 Q 966.3 152.8 967 150.5 L 966 144 Q 969 145.3 968 141.5 L 968.5 139 Z "
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 140 L 173.5 142 Q 170.7 142.7 172.5 140 Z "
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 140 L 331 142 L 328 141.5 L 330.5 140 Z "
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 961.5 150 Q 964.9 149.1 963 154.5 L 960.5 158 L 959 153.5 L 961.5 150 Z "
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 155 L 183 157.5 L 181 158.5 L 181 156.5 L 181.5 155 Z "
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1174.5 163 L 1177 163.5 L 1174.5 164 L 1174.5 163 Z "
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 847.5 167 L 848.5 169 Q 845.7 169.7 847.5 167 Z "
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 980.5 167 L 983 167.5 L 982 169.5 Q 985 170.8 984 175 L 980 175 L 980.5 167 Z "
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 168 L 191 170 L 193 170.5 L 191 171.5 L 192 174 L 188 173.5 L 190 172.5 L 189 170.5 L 190.5 168 Z "
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1032.5 168 L 1034 172 Q 1031.3 173.1 1032 170.5 L 1032.5 168 Z "
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 849.5 170 L 852.5 174 L 853 172 L 855 172.5 L 852.5 176 L 849 175 L 850 172.5 L 849.5 170 Z "
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1030.5 172 L 1032 174.5 L 1029.5 178 L 1029 174.5 L 1030.5 172 Z "
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1034 173 Q 1037.3 171.9 1036 176 Q 1032.7 177.1 1034 173 Z "
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 855 174 Q 858 173 857 176 Q 854 177 855 174 Z "
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1241.5 175 L 1242 181.5 L 1239 183.5 L 1238.5 182 L 1236.5 185 Q 1230.7 187.1 1232 182.5 L 1235 183.5 Q 1234.3 181.3 1236.5 182 L 1239.5 176 L 1241.5 175 Z "
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 851 177 Q 853.7 175.9 853 178.5 L 856 179.5 L 856 181.5 L 858 187.5 L 856 190.5 L 856.5 192 L 855 189.5 L 856 187.5 L 856 185.5 L 855.5 184 Q 854.3 186.3 853 183.5 L 854 182.5 Q 850.9 180.8 852.5 179 Q 849.9 179.7 851 177 Z "
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 183 Q 315.1 182.2 314 185.5 L 313 185.5 L 312.5 183 Z "
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 660.5 187 L 659.5 189 L 660.5 187 Z "
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 796.5 195 L 798 198.5 L 797 198.5 L 796.5 195 Z "
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 861.5 205 L 862.5 207 L 861.5 205 Z "
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312 208 Q 314.7 206.9 314 209.5 L 315 213.5 L 312.5 217 Q 309.9 217.8 311 214.5 L 309 211.5 L 312 210 L 312 208 Z "
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 208 L 357 212.5 L 356 212.5 L 356.5 208 Z "
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 710.5 212 Q 713.3 213.2 711 214.5 L 710.5 216 L 710 214.5 L 710.5 212 Z "
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 803.5 213 L 805 213.5 L 802.5 215 L 803.5 213 Z "
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 805.5 215 L 807 221.5 L 804 221.5 L 805.5 215 Z "
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 867.5 221 L 869 223.5 L 867 222.5 L 867.5 221 Z "
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 802 224 L 806 224 L 806 230 Q 809.8 228.5 809 231.5 L 811.5 232 Q 816.5 233 817.5 230 L 863 230 L 862.5 232 L 817.5 232 L 817 234.5 L 813.5 236 L 809.5 234 L 807.5 235 L 802 230.5 L 804 230 L 802 224 Z "
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 810.5 228 L 811.5 230 L 810.5 228 Z "
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 904.5 229 L 908 229.5 L 904.5 230 L 904.5 229 Z "
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 909.5 229 L 913.5 230 L 942.5 230 L 947 232.5 L 943.5 233 L 942.5 232 L 912.5 232 L 909.5 229 Z "
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1066.5 229 L 1071 229.5 L 1066.5 230 L 1066.5 229 Z "
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1072.5 230 L 1102.5 230 L 1104 231.5 L 1073 232 L 1071.5 235 L 1069 233.5 L 1070.5 231 L 1072.5 230 Z "
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 566.5 252 L 567 254 L 565 253.5 L 566.5 252 Z "
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 990.5 252 L 991 254 L 989 253.5 L 990.5 252 Z "
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 634.5 281 L 635 283 L 638.5 281 L 656.5 281 L 659 281.5 L 659.5 283 Q 661.3 280.3 663 284.5 L 665 287.5 L 665 289.5 L 664 293.5 L 665 294.5 L 665 343.5 L 664.5 346 L 662 346.5 L 664 347.5 L 661 348.5 L 661.5 350 L 660 349.5 L 658.5 352 L 656.5 351 L 655.5 352 L 631 352 Q 632.3 349 628.5 350 L 626.5 347 L 628 347.5 Q 628.8 345.3 626.5 346 L 627 344.5 L 627 295.5 L 628.5 295 L 628.5 294 Q 625.9 294.8 627 291.5 L 626 291.5 L 625.5 344 L 625 289 L 628.5 290 L 629 287.5 L 627.5 288 L 626 287.5 L 628 286.5 L 627.5 285 L 630.5 283 L 634.5 281 Z M 633 283 L 633 284 L 635 284 L 633 283 Z M 658 283 L 657 285 L 640 286 L 656 286 L 657 287 Q 661 285 658 283 Z M 661 283 Q 659 286 662 287 L 663 287 L 661 283 Z M 635 285 L 635 286 L 639 286 L 635 285 Z M 632 286 L 632 287 L 634 287 L 632 286 Z M 660 286 Q 658 289 661 288 L 660 286 Z M 631 291 L 629 293 Q 628 295 631 294 L 631 291 Z M 629 296 L 628 345 L 629 345 L 629 296 Z M 659 344 L 657 347 L 659 346 L 659 344 Z M 630 345 L 630 348 Q 633 347 630 345 Z M 658 348 Q 655 350 658 351 L 658 349 L 660 349 L 658 348 Z "
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1074.5 281 L 1077.5 282 L 1078.5 281 L 1095.5 281 L 1098.5 282 L 1100.5 283 L 1102.5 283 Q 1104.8 282.3 1104 284.5 L 1106.5 288 L 1105 287.5 L 1105.5 290 L 1107 289.5 L 1106 294.5 L 1107 295.5 L 1107 344.5 L 1103.5 350 L 1100.5 352 L 1098.5 351 L 1097.5 352 L 1074 352 Q 1075.5 348.2 1072.5 349 L 1071.5 350 L 1067 345.5 L 1069.5 347 L 1071 345.5 L 1067 344 L 1067 294.5 L 1070 294 L 1070 291.5 L 1069 291.5 L 1068.5 293 L 1067 289.5 L 1069 289.5 L 1068 285.5 Q 1070 281.8 1072 283.5 Q 1071.3 281.3 1073.5 282 L 1074.5 281 Z M 1080 282 L 1078 284 L 1080 284 L 1080 282 Z M 1074 283 L 1074 284 L 1076 284 L 1074 283 Z M 1100 283 L 1098 285 L 1100 285 L 1100 283 Z M 1077 284 L 1074 286 L 1077 286 L 1077 284 Z M 1097 284 L 1096 285 L 1079 286 L 1097 286 L 1097 284 Z M 1103 284 L 1101 286 L 1103 286 L 1103 284 Z M 1070 286 L 1070 287 L 1072 287 L 1070 286 Z M 1097 286 L 1097 288 L 1099 287 L 1101 288 L 1102 288 Q 1101 285 1097 286 Z M 1070 296 L 1069 344 L 1070 344 L 1070 296 Z M 1103 345 L 1100 346 L 1101 348 L 1104 347 L 1103 345 Z M 1100 348 Q 1098 351 1101 350 L 1100 348 Z "
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 515.5 286 Q 517.8 285.3 517 287.5 L 515.5 286 Z "
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 738.5 348 L 741 349 L 740.5 351 L 738.5 348 Z "
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 36 L 327 36.5 L 251.5 37 L 251.5 36 Z "
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 44 L 328 82.5 L 327 82.5 L 327.5 44 Z "
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 48 L 214.5 50 L 215.5 48 Z "
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 56 L 202.5 60 L 205.5 56 Z "
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 84 L 328 86.5 Q 326.8 89.3 325.5 87 L 254 86.5 L 327 86 L 327.5 84 Z "
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 87 L 252 87.5 Q 244 89 240 94.5 L 238 97.5 L 237.5 112 L 236 100.5 Q 237.8 93.3 243.5 90 L 249.5 87 Z "
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 104 L 184 115.5 L 183 115.5 L 183.5 104 Z "
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 119 L 185 121.5 L 184 121.5 L 184.5 119 Z "
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 120 L 243.5 123 L 241.5 120 Z "
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 123 Q 193.1 143.9 207.5 158 Q 217.3 167.2 231 172.5 L 229.5 173 Q 213.7 166.3 203 154.5 L 188 133.5 L 185 125.5 L 185.5 123 Z "
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 127 L 300 127.5 L 297.5 128 L 297.5 127 Z "
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 138 L 73.5 140 L 74.5 138 Z "
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 146 L 61.5 150 L 64.5 146 Z "
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 174 L 238 174.5 L 235.5 175 L 235.5 174 Z "
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 175 L 242 175.5 L 239.5 176 L 239.5 175 Z "
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 176 L 190 176.5 L 114.5 177 L 114.5 176 Z "
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 176 L 251 176.5 L 244.5 177 L 244.5 176 Z "
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 177 L 296 177.5 L 291.5 178 L 291.5 177 Z "
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 178 Q 305.7 179.8 309 185.5 L 312 193.5 L 310.5 196 Q 311 184.5 303.5 181 L 298.5 179 L 298.5 178 Z "
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 179 L 103.5 181 L 98 185.5 L 96 192.5 L 97 194.5 L 95.5 198 L 95 189.5 L 102.5 180 L 104.5 179 Z "
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 179 L 202.5 181 L 200 180.5 L 201.5 179 Z "
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 363.5 186 L 364 188.5 L 363 188.5 L 363.5 186 Z "
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 363.5 206 L 364 210.5 L 363 210.5 L 363.5 206 Z "
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 213 L 363 214.5 Q 354.6 237.6 337.5 252 L 328.5 258 L 329.5 256 L 345 243.5 L 353 232.5 L 362.5 213 Z "
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 520 249 L 560.5 249 L 561.5 250 L 565 249 L 565 280 L 522.5 280 L 515 283.5 Q 516.1 286.8 513.5 286 Q 515.1 287.8 512 289.5 L 513 290.5 L 512 293.5 L 514 293.5 L 513 294.5 L 518.5 300 L 520.5 301 L 545.5 301 L 547.5 302 L 549.5 301 L 554.5 302 L 556.5 304 L 558.5 304 L 563 305 L 563.5 307 L 565 306.5 L 565.5 308 L 566.5 307 L 569.5 310 L 577 316.5 L 579 319.5 L 578.5 321 L 581 322.5 L 582 325.5 L 581 326.5 L 583.5 330 L 582 329.5 L 584 332.5 L 586 342.5 L 585 344.5 L 585 346.5 L 584 356 Q 581.3 354.9 582 357.5 L 582.5 359 L 580.5 358 L 580 360 L 582 360.5 Q 577.8 369.3 570.5 375 L 568 375 Q 569.1 377.7 566.5 377 Q 564.8 380.1 563 378.5 Q 563.8 380.8 561.5 380 L 559.5 381 L 557.5 380 L 557.5 382 Q 556 379.5 554.5 383 Q 549.1 384.9 550 381.5 L 549 381.5 L 548.5 384 L 482 384 L 482 356.5 L 483 355.5 Q 480.8 354.3 483.5 353 L 486 354 Q 484.9 356.7 487.5 356 L 487 354.5 L 487.5 353 L 543.5 353 L 545.5 353 L 548.5 352 Q 549.8 354.3 551 351.5 L 553.5 348 L 555 348.5 L 554 345.5 L 555 340.5 L 554 338.5 L 555.5 336 L 553.5 337 L 549.5 332 L 548 332.5 Q 548.8 330.3 546.5 331 L 545.5 332 L 520.5 332 L 518.5 332 L 515.5 330 L 512.5 331 Q 510.8 327.9 509 329.5 L 508.5 328 L 507 328.5 L 506.5 327 L 504.5 327 Q 502.3 327.8 503 325.5 L 501 325.5 L 501.5 324 Q 499.3 324.8 500 322.5 L 498 321.5 L 497.5 323 L 489 313.5 L 489.5 312 L 488 312 Q 489.5 308.3 486.5 309 L 488 306.5 L 487.5 305 L 485.5 306 L 485.5 304 Q 482.9 304.8 484 301.5 L 485 299.5 L 483 299.5 L 484 296.5 L 483 294 L 485 293.5 L 482 293 L 482 287.5 L 483.5 287 L 483 285.5 L 484 283.5 L 483 281.5 L 485.5 277 L 487 277.5 Q 487.8 275.3 485.5 276 L 485.5 275 L 487 274.5 Q 484.5 273 488 271.5 L 490.5 266 L 493 264.5 Q 492.5 260.5 495.5 260 Q 497.3 262.8 499 258.5 L 500.5 256 L 504.5 254 L 509.5 255 L 510.5 253 L 506.5 254 L 506.5 253 L 514.5 250 L 518.5 250 L 520 250.5 L 520 249 Z M 521 251 L 521 252 L 560 252 L 521 251 Z M 562 251 L 560 253 L 562 253 L 562 251 Z M 512 252 L 512 253 L 516 253 L 512 252 Z M 518 253 L 515 255 L 518 255 L 518 253 Z M 500 257 L 500 259 L 502 258 L 500 257 Z M 514 281 Q 514 285 516 282 L 514 281 Z M 513 283 Q 511 286 514 285 L 513 283 Z M 513 297 L 513 298 L 515 298 L 513 297 Z M 513 301 L 514 303 Q 515 300 513 301 Z M 516 301 L 517 303 Q 518 300 516 301 Z M 523 302 L 523 303 L 525 303 L 523 302 Z M 566 309 Q 564 312 567 311 L 566 309 Z M 571 314 L 570 320 L 571 320 L 571 314 Z M 575 315 L 574 317 L 576 318 L 575 315 Z M 505 325 L 506 327 Q 507 324 505 325 Z M 579 327 L 580 329 Q 581 326 579 327 Z M 545 328 L 546 330 L 547 330 L 545 328 Z M 578 329 L 577 332 L 578 332 L 578 329 Z M 550 330 L 550 332 L 552 331 L 550 330 Z M 546 355 L 546 356 L 548 356 L 546 355 Z M 579 358 L 578 361 L 579 361 L 579 358 Z M 578 363 L 576 366 L 578 366 L 578 363 Z M 546 376 L 545 379 L 546 379 L 546 376 Z M 555 379 L 555 380 L 557 380 L 555 379 Z M 545 380 L 545 381 L 547 381 L 545 380 Z M 552 381 L 552 382 L 554 382 L 552 381 Z "
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 631.5 249 L 655.5 249 L 656.5 250 L 658 249.5 L 657.5 251 L 665 250 L 665.5 252 L 669 251 L 669.5 253 L 671 252.5 Q 670.3 254.8 672.5 254 Q 673.8 251.8 675 254.5 L 675.5 256 L 677 255.5 L 677.5 257 Q 678.8 254.8 680 257.5 L 678 257.5 Q 677.3 259.8 679.5 259 L 681.5 259 L 684 260.5 Q 683.3 262.8 685.5 262 L 692 270.5 L 691 273 L 693 273.5 L 692.5 275 L 694 275.5 L 693.5 277 Q 696.1 276.2 695 279.5 L 696 282 L 693.5 281 L 693 283 Q 697.1 281.3 696 285.5 L 697 286.5 L 697 346.5 L 695.5 353 Q 694.3 350.8 693 353.5 L 693.5 355 L 695 354.5 L 693 357.5 L 693 359.5 L 692 363 Q 689 361.8 690 365.5 L 681.5 375 L 680 374.5 L 678.5 377 L 676.5 376 L 675.5 379 L 674 378.5 Q 674.8 380.8 672.5 380 L 668.5 382 L 667.5 380 L 665 381.5 L 665.5 383 L 662.5 382 L 660 382.5 Q 660.8 385.1 657.5 384 L 655.5 384 L 630.5 384 L 628 383 Q 629.3 380 625.5 381 L 625.5 382 L 627 382.5 L 624.5 383 L 621 382 L 620.5 379 L 619 379.5 L 619.5 378 Q 616.9 377.3 618 380 L 616 380 L 615.5 378 L 614 378.5 L 613.5 375 Q 611 379.5 608.5 374 L 603 369.5 L 600 365.5 L 600.5 364 L 599 363.5 L 599.5 362 Q 597.3 362.8 598 360.5 L 596 356.5 L 597.5 352 L 595.5 353 L 594 350.5 L 594 348.5 L 595 345 L 593 344.5 L 593 288.5 L 595 283.5 L 594 281.5 Q 597.1 279.8 595.5 278 L 597 277.5 L 596 275.5 L 598 271 L 600 270.5 Q 597.5 269 601 267.5 L 603 264.5 L 606.5 260 L 608 260.5 L 606 261.5 Q 607.5 264.5 609 261.5 L 611 256 L 613.5 255 L 615.5 255 L 618.5 253 L 625.5 250 L 627.5 251 L 631.5 249 Z M 633 251 L 633 252 L 656 252 L 633 251 Z M 662 251 L 662 252 L 664 252 L 662 251 Z M 625 252 L 626 254 L 628 253 L 625 252 Z M 665 252 L 662 254 L 666 254 L 665 252 Z M 675 257 L 676 259 Q 677 256 675 257 Z M 677 260 L 675 262 L 677 262 L 677 260 Z M 683 261 L 681 263 L 684 263 L 683 261 Z M 687 265 Q 685 268 688 267 L 687 265 Z M 604 266 L 602 269 L 605 267 L 604 266 Z M 684 266 L 683 268 L 686 269 L 684 266 Z M 606 269 Q 604 272 607 271 L 606 269 Z M 683 270 L 684 272 Q 685 269 683 270 Z M 631 280 Q 631 283 627 282 L 627 284 L 624 289 L 624 345 L 624 347 L 626 347 Q 624 349 628 351 Q 630 350 629 353 Q 631 351 633 354 L 634 353 Q 637 352 636 355 L 639 353 Q 651 351 660 354 L 660 352 L 662 353 L 666 345 L 666 297 L 667 296 L 666 294 L 667 289 L 665 288 L 666 286 L 666 283 L 665 285 L 663 283 L 665 282 Q 663 278 662 282 L 658 280 L 634 280 L 633 281 L 631 280 Z M 670 280 L 672 283 L 672 282 L 670 280 Z M 669 288 L 668 291 L 669 291 L 669 288 Z M 668 296 L 667 344 L 668 344 L 668 296 Z M 669 344 L 666 346 Q 668 349 670 345 L 669 344 Z M 596 345 L 595 348 L 597 348 L 598 346 L 596 345 Z M 599 347 L 598 350 L 599 350 L 599 347 Z M 670 347 L 668 349 L 670 349 L 670 347 Z M 627 351 Q 625 354 628 353 L 627 351 Z M 692 352 L 691 355 L 692 355 L 692 352 Z M 631 353 Q 629 356 632 355 L 631 353 Z M 628 354 L 627 356 L 630 357 L 628 354 Z M 662 354 L 662 355 L 664 355 L 662 354 Z M 691 356 L 690 359 L 692 359 L 691 356 Z M 599 357 L 598 360 L 599 360 L 599 357 Z M 627 358 L 628 360 Q 629 357 627 358 Z M 607 360 L 605 362 L 607 362 L 607 360 Z M 609 368 L 607 370 L 609 370 L 609 368 Z M 613 371 L 614 373 Q 615 370 613 371 Z M 627 378 L 625 380 L 628 380 L 627 378 Z M 657 381 L 657 382 L 659 382 L 657 381 Z "
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 707.5 249 L 732.5 249 L 736 250 L 735 252.5 L 736 253.5 L 736 346.5 L 739.5 351 L 743.5 353 L 777 353.5 L 776 358.5 L 777 360.5 L 777 384 L 741.5 384 L 741 382.5 L 741.5 381 Q 739.3 380.3 740 382.5 L 738.5 382 L 735 383 Q 736.5 379.2 733.5 380 L 733.5 382 Q 730.9 382.7 732 380 L 729.5 380 L 727 379.5 L 726.5 377 L 724.5 378 L 714 369.5 L 710 363.5 L 712 363 L 711.5 361 Q 709.8 363.7 708 359.5 L 706 353.5 L 706.5 352 Q 703.9 352.8 705 349.5 L 705 347.5 L 706 344.5 L 704 341.5 L 704 253.5 L 704 251.5 Q 703.2 248.9 706.5 250 L 707.5 249 Z M 708 250 L 706 252 L 708 252 L 708 250 Z M 733 250 Q 731 253 734 252 L 733 250 Z M 713 251 L 713 252 L 728 252 L 713 251 Z M 710 253 L 710 254 L 712 254 L 710 253 Z M 729 253 L 729 254 L 731 254 L 729 253 Z M 708 345 L 706 348 L 708 347 L 708 345 Z M 740 355 L 741 357 L 744 357 L 740 355 Z M 738 357 L 739 359 L 741 359 L 738 357 Z M 716 362 L 717 363 L 718 364 Q 719 361 716 362 Z M 719 364 L 718 368 L 719 368 L 719 364 Z M 717 367 L 715 369 L 717 369 L 717 367 Z M 717 369 Q 716 372 719 371 Q 720 368 717 369 Z M 725 370 L 726 372 Q 727 369 725 370 Z "
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 786.5 249 L 812.5 249 L 816 250 L 815 252.5 L 816 253.5 L 816 346.5 L 820.5 352 L 823.5 353 L 849.5 353 L 852 352.5 L 857 345.5 L 857 252.5 L 858 251.5 Q 855.8 250.3 858.5 249 L 861.5 250 L 862.5 249 L 888 249 L 887.5 251 L 864.5 251 L 864.5 252 L 887.5 252 L 888 252.5 L 888 343.5 L 887 345.5 L 888 349 Q 885.3 347.9 886 350.5 L 887 353.5 L 886 353.5 L 885.5 352 L 885 354.5 L 886 357 L 883.5 356 L 883 358 L 885 358.5 Q 880.7 360.8 882.5 363 L 881 363.5 Q 883.5 365 880 366.5 L 876.5 371 Q 874.3 370.3 875 372.5 L 868.5 378 L 866.5 377 L 866.5 379 L 865 378.5 Q 865.8 380.8 863.5 380 L 859.5 382 L 854.5 383 L 852 382.5 Q 852.9 379.5 848.5 381 L 848.5 382 Q 852.3 381 851 384 L 821.5 384 L 821 381.5 L 820 381.5 Q 820.8 383.8 818.5 383 L 816 382.5 Q 816.8 380.3 814.5 381 L 812 382 L 813 379.5 L 811 379 L 810.5 381 Q 802.5 378.5 798 372.5 Q 798.8 370.3 796.5 371 Q 789.8 365.7 787 356.5 L 787.5 355 L 786 354.5 L 786 352.5 L 785 349.5 L 786 347.5 L 785 346.5 L 785 250.5 L 786.5 249 Z M 786 250 L 786 253 L 787 253 Q 786 250 789 251 L 788 253 L 789 256 L 790 253 Q 791 248 786 250 Z M 813 250 Q 811 253 814 252 L 813 250 Z M 793 251 L 793 252 L 808 252 L 793 251 Z M 862 252 L 861 255 L 862 255 L 862 252 Z M 809 253 L 809 254 L 811 254 L 809 253 Z M 860 256 L 859 336 L 860 336 L 860 256 Z M 788 261 L 787 264 L 788 264 L 788 261 Z M 788 269 L 787 272 L 788 272 L 788 269 Z M 788 277 L 787 280 L 788 280 L 788 277 Z M 788 285 L 787 288 L 788 288 L 788 285 Z M 788 293 L 787 296 L 788 296 L 788 293 Z M 788 301 L 787 304 L 788 304 L 788 301 Z M 788 309 L 787 312 L 788 312 L 788 309 Z M 788 317 L 787 320 L 788 320 L 788 317 Z M 788 325 L 787 328 L 788 328 L 788 325 Z M 788 333 L 787 336 L 788 336 L 788 333 Z M 859 336 L 858 341 L 859 341 L 859 336 Z M 788 341 L 787 344 L 788 344 L 788 341 Z M 859 344 L 860 346 Q 861 343 859 344 Z M 787 345 Q 785 348 788 347 L 787 345 Z M 788 353 Q 787 356 790 355 Q 791 352 788 353 Z M 791 355 L 790 357 L 788 358 Q 790 361 791 358 L 791 355 Z M 820 355 L 821 357 L 824 357 L 820 355 Z M 818 357 L 819 359 L 821 359 L 818 357 Z M 851 359 L 851 360 L 853 360 L 851 359 Z M 793 360 L 791 362 L 793 362 L 793 360 Z M 797 361 L 796 364 L 797 364 L 797 361 Z M 794 362 L 793 364 L 795 363 L 794 362 Z M 795 364 L 794 366 L 797 366 L 795 364 Z M 877 365 L 878 369 L 878 366 L 880 366 L 877 365 Z M 805 370 L 805 372 Q 804 374 807 373 L 806 372 Q 807 369 805 370 Z M 804 373 L 805 375 Q 806 372 804 373 Z M 869 373 L 870 375 L 872 374 L 869 373 Z M 813 377 L 814 379 Q 815 376 813 377 Z M 819 378 L 818 380 L 816 381 L 819 381 Q 822 380 819 378 Z "
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 896 249 L 984.5 249 L 985.5 250 L 989 249 L 989 280 L 958.5 280 L 958 282.5 L 957 285.5 L 958 286.5 L 958 384 L 927.5 384 L 927 383.5 L 927 283.5 L 927.5 280 L 896 280 L 896 252 L 984 251.5 L 896 251 L 896 249 Z M 986 251 L 984 253 L 986 253 L 986 251 Z M 956 283 L 954 285 L 956 285 L 956 283 Z "
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 998.5 249 L 1024.5 249 L 1025.5 250 Q 1026.7 247.7 1028 250.5 L 1027 253.5 L 1028 254.5 L 1028 384 L 997.5 384 L 997 383.5 L 997 253 L 1000 252.5 L 998.5 250 L 997.5 252 L 997 250.5 L 998.5 249 Z M 1001 251 L 1001 252 L 1024 252 L 1001 251 Z M 1025 252 L 1025 255 L 1027 256 L 1026 254 Q 1027 251 1025 252 Z "
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1076.5 249 L 1100 249.5 L 1099.5 251 L 1103.5 250 L 1105.5 250 L 1108.5 252 L 1110.5 252 L 1120.5 256 L 1124 259.5 L 1124.5 261 Q 1126.2 258.3 1128 262.5 Q 1126.9 265.8 1129.5 265 L 1131 267.5 L 1130.5 269 L 1133 269.5 L 1132.5 273 L 1135 273.5 L 1134.5 275 L 1136 275.5 L 1135 276.5 L 1138 281.5 L 1137 283.5 L 1138 286.5 L 1137.5 288 L 1139 288.5 L 1139 344.5 Q 1135.5 346 1138 347.5 L 1137 349.5 L 1138 351.5 L 1136 353.5 L 1137 354.5 Q 1133.9 356.3 1135.5 358 L 1134 357.5 L 1135 359.5 L 1133 360.5 L 1133 362.5 L 1124.5 374 L 1122.5 373 L 1121 377 L 1118.5 378 L 1118 376 L 1116 376.5 L 1117 378.5 L 1110.5 382 L 1110.5 380 L 1108 381.5 Q 1108.8 383.8 1106.5 383 L 1104.5 383 L 1103 382.5 L 1105 381.5 L 1101.5 381 L 1102 382.5 Q 1102.8 385.1 1099.5 384 L 1099.5 382 Q 1097.3 381.3 1098 383.5 L 1095.5 384 L 1077.5 384 L 1075.5 383 L 1071.5 384 L 1069 383 Q 1067.9 380.3 1070.5 381 L 1070.5 380 L 1068 380 Q 1069.5 383.8 1066.5 383 L 1066.5 381 L 1063.5 382 L 1060 381 L 1059.5 379 L 1057.5 379 L 1055 377.5 Q 1056.1 374.2 1053.5 375 L 1053.5 377 L 1044 368.5 Q 1046.3 367.3 1043.5 366 Q 1041.3 366.8 1042 364.5 Q 1038.9 362.8 1040.5 361 L 1039 360.5 L 1039.5 359 L 1038 358.5 L 1039 356 Q 1036 357.3 1037 353.5 L 1036 351.5 L 1036 349.5 L 1035 346.5 L 1035 294.5 L 1035 292.5 Q 1033.8 285.8 1037 283.5 L 1036 280.5 L 1038 279.5 L 1038.5 283 L 1039 278 L 1037 277.5 L 1040 274.5 L 1039 273.5 Q 1038.2 270.9 1041.5 272 L 1042 269.5 L 1043.5 266 L 1043 267.5 L 1043.5 269 L 1046 264.5 L 1045 263.5 L 1049.5 259 L 1055.5 255 L 1057 255.5 L 1057.5 254 L 1059.5 254 L 1062.5 252 L 1065.5 251 L 1068.5 250 L 1070.5 251 L 1073.5 250 Q 1074.7 252.3 1079.5 251 L 1079.5 250 Q 1075.5 250.7 1076.5 249 Z M 1081 251 L 1081 252 L 1097 252 L 1081 251 Z M 1069 252 L 1069 253 L 1071 253 L 1069 252 Z M 1077 252 L 1077 253 L 1080 253 L 1077 252 Z M 1097 255 L 1097 256 L 1099 256 L 1097 255 Z M 1055 259 L 1053 261 L 1055 261 L 1055 259 Z M 1050 262 L 1051 264 L 1052 264 L 1050 262 Z M 1130 271 L 1131 274 L 1132 272 L 1130 271 Z M 1071 280 L 1072 282 L 1067 284 L 1068 286 L 1066 286 L 1067 288 L 1065 288 L 1066 290 Q 1067 294 1065 296 L 1066 297 L 1066 346 L 1066 348 L 1068 348 L 1070 352 L 1077 354 L 1081 353 L 1096 353 L 1097 354 L 1105 351 L 1107 347 Q 1106 344 1109 345 L 1108 344 L 1108 297 L 1109 295 L 1109 293 L 1108 289 L 1110 289 Q 1109 286 1108 288 L 1106 283 L 1105 283 L 1103 282 L 1099 280 L 1076 280 L 1075 281 L 1071 280 Z M 1065 283 Q 1063 286 1066 285 L 1065 283 Z M 1036 289 L 1037 295 L 1038 295 Q 1040 288 1036 289 Z M 1111 291 L 1110 295 L 1112 295 L 1111 291 Z M 1111 296 L 1110 345 L 1111 345 L 1111 296 Z M 1076 354 L 1077 357 L 1080 356 L 1076 354 Z M 1098 354 L 1099 358 L 1100 355 L 1098 354 Z M 1131 354 L 1133 357 L 1134 356 L 1131 354 Z M 1101 355 L 1100 360 L 1101 360 L 1101 355 Z M 1074 358 L 1074 359 L 1076 359 L 1074 358 Z M 1129 363 L 1129 365 L 1131 364 L 1129 363 Z M 1049 369 L 1050 371 Q 1051 368 1049 369 Z M 1125 369 L 1123 371 L 1125 371 L 1125 369 Z M 1053 372 L 1052 374 L 1055 374 L 1053 372 Z M 1075 377 L 1075 379 L 1077 378 L 1075 377 Z M 1100 377 L 1100 378 L 1102 378 L 1100 377 Z M 1068 378 L 1068 379 L 1071 379 L 1068 378 Z M 1105 379 Q 1104 382 1107 381 Q 1108 378 1105 379 Z M 1073 381 L 1073 382 L 1075 382 L 1073 381 Z "
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1184 249 L 1207.5 249 L 1208.5 250 L 1210.5 249 L 1210.5 251 L 1217.5 250 L 1221.5 252 L 1223.5 252 L 1228.5 256 L 1230.5 256 L 1239 262.5 L 1237 263.5 L 1243 267.5 L 1242.5 269 Q 1244.8 268.3 1244 270.5 Q 1241.8 271.8 1244.5 273 L 1246 273.5 L 1245.5 275 Q 1248.1 274.2 1247 277.5 L 1249 282.5 L 1248 284.5 L 1250 287.5 L 1250 384 L 1219.5 384 L 1219 383.5 L 1219 290.5 L 1220 288 Q 1217.3 289.1 1218 286.5 L 1218 284.5 L 1217.5 283 L 1216 283.5 L 1216.5 282 L 1214.5 281 L 1212.5 281 L 1210.5 280 L 1185.5 280 L 1177 284.5 L 1179 285.5 L 1177 286.5 L 1177.5 288 L 1176 287.5 L 1177 292.5 L 1177 294.5 L 1177 384 L 1146 384 L 1146 287.5 L 1148 283.5 L 1147 281 L 1150 279.5 L 1148 279 Q 1146.9 276.3 1149.5 277 L 1151 277.5 Q 1151.8 275.3 1149.5 276 L 1149.5 275 L 1151.5 276 L 1152 274 Q 1149.3 275.1 1150 272.5 L 1154.5 266 Q 1157.1 266.8 1156 263.5 L 1160.5 259 L 1163 259 L 1164.5 256 L 1166 256.5 Q 1165.2 253.9 1168.5 255 Q 1172.3 250.8 1179.5 250 L 1181.5 250 L 1183.5 251 L 1184 249 Z M 1185 251 L 1185 252 L 1208 252 L 1185 251 Z M 1176 254 L 1176 255 L 1178 255 L 1176 254 Z M 1211 254 L 1211 255 L 1214 255 L 1211 254 Z M 1218 254 L 1218 255 L 1220 255 L 1218 254 Z M 1223 254 L 1223 255 L 1225 255 L 1223 254 Z M 1230 257 L 1229 259 L 1233 259 L 1230 257 Z M 1165 259 L 1166 261 Q 1167 258 1165 259 Z M 1159 265 L 1160 267 Q 1161 264 1159 265 Z M 1244 276 L 1242 279 L 1244 278 L 1244 276 Z M 1222 285 L 1222 288 Q 1225 287 1222 285 Z M 1224 287 L 1222 290 L 1224 289 L 1224 287 Z M 1221 293 L 1220 296 L 1221 296 L 1221 293 Z "
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1295.5 249 L 1339 249.5 L 1337 250.5 L 1340 251 L 1340 280 L 1297.5 280 L 1295.5 281 L 1294 280.5 Q 1294.8 282.8 1292.5 282 L 1288 288.5 L 1288 292.5 L 1293.5 300 L 1295.5 301 L 1321.5 301 L 1322.5 302 L 1324.5 301 L 1328 302 L 1328.5 304 L 1329.5 302 Q 1331 305.5 1332.5 303 L 1340 306 L 1340.5 308 L 1341.5 307 L 1344.5 310 L 1352 316.5 L 1354 319.5 L 1353.5 321 L 1356 322.5 L 1357 325.5 L 1356.5 327 L 1358 327.5 L 1357.5 329 Q 1360.5 328.1 1359 332.5 L 1361 339.5 L 1361 345.5 Q 1358.5 347 1360 352.5 L 1358 354.5 L 1358.5 356 Q 1356.3 355.3 1357 357.5 L 1356 359.5 L 1356 361.5 L 1354.5 364 L 1353 364.5 L 1353.5 366 L 1352 365.5 L 1352 368.5 L 1345.5 375 L 1342.5 377 L 1341 376.5 L 1339.5 379 L 1334.5 381 L 1333 380.5 L 1332.5 382 Q 1331 379.5 1329.5 383 L 1326.5 382 L 1324 382.5 Q 1324.8 385.1 1321.5 384 L 1319.5 384 L 1257 384 L 1257 357.5 L 1257 355.5 L 1258.5 353 L 1260.5 353 L 1321.5 353 L 1323.5 352 L 1325 352.5 L 1332 341.5 L 1329 339.5 Q 1330.5 335.1 1327.5 336 Q 1324.8 334.7 1327 333.5 L 1326.5 332 L 1324.5 333 L 1323.5 332 L 1292 332 L 1291.5 330 L 1287.5 331 Q 1285.8 327.9 1284 329.5 L 1283.5 328 L 1281.5 328 L 1278 327 L 1277.5 325 L 1276 325.5 L 1274.5 323 L 1273.5 324 L 1266 316.5 Q 1268.3 315.3 1265.5 314 Q 1263.3 314.8 1264 312.5 L 1261 307.5 L 1263 306.5 L 1260 305.5 L 1260.5 304 Q 1258.3 304.8 1259 302.5 L 1260 299.5 L 1258 299.5 L 1257 289 Q 1260.7 290.5 1260 287.5 L 1258.5 288 L 1257 287.5 L 1259 286.5 L 1258.5 285 L 1260 284.5 L 1258 283.5 L 1258.5 281 L 1260 280.5 L 1259 278.5 L 1261 273 L 1263 272.5 L 1262.5 271 L 1264 270.5 L 1264 268.5 L 1266.5 265 Q 1269.1 265.8 1268 262.5 Q 1269.2 259.3 1273 260 L 1275.5 256 L 1277.5 255 L 1279.5 255 L 1282.5 253 L 1289.5 250 L 1291.5 251 L 1293.5 250 L 1295.5 251 L 1295.5 249 Z M 1297 251 L 1297 252 L 1336 252 L 1297 251 Z M 1289 252 L 1289 254 L 1291 253 L 1289 252 Z M 1279 258 L 1280 260 Q 1281 257 1279 258 Z M 1275 259 L 1273 261 L 1275 261 L 1275 259 Z M 1272 262 Q 1270 265 1273 264 L 1272 262 Z M 1269 265 L 1267 268 L 1269 267 L 1269 265 Z M 1269 269 L 1269 271 L 1271 270 L 1269 269 Z M 1264 273 L 1262 276 L 1264 275 L 1264 273 Z M 1263 277 L 1262 281 L 1263 281 L 1263 277 Z M 1263 288 L 1262 297 L 1263 297 L 1263 288 Z M 1292 300 L 1291 302 L 1293 301 L 1292 300 Z M 1300 302 L 1299 304 L 1303 303 L 1300 302 Z M 1270 312 Q 1268 315 1271 314 L 1270 312 Z M 1348 315 L 1349 317 Q 1350 314 1348 315 Z M 1277 321 L 1278 323 Q 1279 320 1277 321 Z M 1325 328 L 1323 330 L 1325 330 L 1325 328 Z M 1331 336 L 1330 339 L 1331 339 L 1331 336 Z M 1333 339 L 1334 341 Q 1335 338 1333 339 Z M 1336 342 L 1335 345 L 1336 345 L 1336 342 Z M 1331 345 L 1332 349 L 1333 347 Q 1334 344 1331 345 Z M 1262 354 L 1260 356 L 1262 356 L 1262 354 Z M 1325 354 L 1325 355 L 1327 355 L 1325 354 Z M 1355 354 L 1356 355 L 1357 356 Q 1358 353 1355 354 Z M 1354 355 L 1353 358 L 1354 358 L 1354 355 Z M 1261 357 Q 1260 360 1263 359 Q 1264 356 1261 357 Z M 1326 358 L 1326 359 L 1328 359 L 1326 358 Z M 1345 371 L 1346 373 Q 1347 370 1345 371 Z M 1321 381 L 1321 382 L 1323 382 L 1321 381 Z "
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 326.5 258 L 325.5 260 L 320.5 262 L 320.5 261 L 326.5 258 Z "
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 265 L 311 265.5 L 308.5 266 L 308.5 265 Z "
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 266 L 307 266.5 L 302.5 267 L 302.5 266 Z "
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 267 L 103 267.5 L 96 269 L 95 274.5 L 96 277.5 L 95 277.5 L 94 270.5 L 98.5 267 Z "
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 267 L 176 267.5 L 104.5 268 L 104.5 267 Z "
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 267 L 299 267.5 L 179.5 268 L 179.5 267 Z "
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(168,170,170)",
    stroke: "rgb(168,170,170)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 357 L 95.5 357 L 96 359 L 93.5 358 L 44.5 358 L 42.5 359 L 43.5 357 Z "
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 11 15 L 380 15 L 380 384 L 16 383.5 L 379 383 L 379 17.5 L 377.5 17 L 376.5 16 L 14.5 16 L 12 17 L 12 380.5 L 13 383 L 15 383.5 L 11 384 L 11 15 Z "
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 431 15 L 434 15.5 L 431.5 17 L 431 15 Z "
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 483.5 15 L 634 15.5 L 483 16 L 482.5 226 L 482 16.5 L 483.5 15 Z "
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 727.5 15 L 788 15.5 L 727.5 16 L 727.5 15 Z "
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 898.5 15 L 960.5 15 L 962 16.5 L 960.5 16 L 898.5 16 L 898.5 15 Z "
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1056.5 15 L 1118.5 15 L 1120 16.5 L 1119.5 227 L 1119 16 L 1056.5 16 L 1056.5 15 Z "
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1166.5 15 L 1330 15.5 L 1166.5 16 L 1166.5 15 Z "
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1331.5 16 L 1332 55.5 L 1331 55.5 L 1331.5 16 Z "
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 36 L 251 36.5 L 248.5 37 L 248.5 36 Z "
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 37 L 329 88.5 L 326.5 92 L 251.5 92 L 242 97.5 L 238.5 106 L 238 100.5 Q 239.5 94 244.5 91 L 247.5 89 L 256.5 87 L 322.5 87 L 328 88 L 328.5 37 Z "
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 49 L 212.5 51 L 213.5 49 Z "
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 53 L 206.5 56 L 208.5 53 Z "
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 536.5 56 L 537 95.5 L 536 95.5 L 536.5 56 Z "
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 60 L 199.5 63 L 201.5 60 Z "
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1259.5 63 L 1258.5 65 L 1259.5 63 Z "
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 65 L 196.5 67 L 197.5 65 Z "
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1255.5 68 L 1254.5 70 L 1255.5 68 Z "
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1320.5 69 L 1319.5 71 L 1320.5 69 Z "
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 71 L 192.5 73 L 193.5 71 Z "
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1251.5 73 L 1250.5 75 L 1251.5 73 Z "
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1315.5 75 L 1314.5 77 L 1315.5 75 Z "
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1246.5 79 L 1245.5 81 L 1246.5 79 Z "
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1311.5 80 L 1310.5 82 L 1311.5 80 Z "
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1242.5 84 L 1241.5 86 L 1242.5 84 Z "
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1307.5 85 L 1306.5 87 L 1307.5 85 Z "
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1065.5 86 L 1066 226.5 L 1065 226.5 L 1065.5 86 Z "
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1303.5 90 L 1302.5 92 L 1303.5 90 Z "
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 91 L 185 93.5 L 184 93.5 L 184.5 91 Z "
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1234.5 94 L 1233.5 96 L 1234.5 94 Z "
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 96 L 184 99.5 L 183 99.5 L 183.5 96 Z "
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1221.5 110 L 1220.5 112 L 1221.5 110 Z "
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 111 L 239 113.5 L 238 113.5 L 238.5 111 Z "
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1286.5 111 L 1285.5 113 L 1286.5 111 Z "
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1218.5 114 L 1217.5 116 L 1218.5 114 Z "
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1282.5 116 L 1281.5 118 L 1282.5 116 Z "
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 117 L 184 120.5 L 183 120.5 L 183.5 117 Z "
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 122 L 186 128.5 L 185 128.5 L 184.5 122 Z "
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 123 L 246.5 125 L 245.5 123 Z "
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1209.5 125 L 1208.5 127 L 1209.5 125 Z "
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 126 L 170 126.5 L 109.5 127 L 109.5 126 Z "
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 301.5 127 L 304 127.5 L 301.5 128 L 301.5 127 Z "
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1273.5 127 L 1272.5 129 L 1273.5 127 Z "
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 128 L 98 128.5 L 95.5 129 L 95.5 128 Z "
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 130 L 190 138.5 L 204.5 157 Q 217.3 170.2 237.5 176 L 248.5 178 L 295.5 178 Q 303.9 180.2 308 186.5 L 310 194.5 L 310 203.5 L 309 203.5 Q 310.5 190.5 303.5 186 L 295.5 182 L 245.5 182 L 235.5 180 Q 213 173 200 156.5 L 192 145.5 L 186 132.5 L 186.5 130 Z "
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1205.5 130 L 1204.5 132 L 1205.5 130 Z "
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 135 L 77.5 137 L 78.5 135 Z "
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1201.5 135 L 1200.5 137 L 1201.5 135 Z "
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 136 L 329.5 138 L 328.5 136 Z "
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 537.5 136 L 627 136.5 L 537 137 L 536.5 141 L 536 137.5 L 537.5 136 Z "
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1265.5 137 L 1264.5 139 L 1265.5 137 Z "
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 139 L 71.5 141 L 72.5 139 Z "
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1197.5 140 L 1196.5 142 L 1197.5 140 Z "
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 142 L 66.5 145 L 68.5 142 Z "
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 536.5 142 L 537 226.5 L 536 226.5 L 536.5 142 Z "
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 143 L 347.5 153 L 338.5 143 Z "
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 731.5 145 L 783 145.5 L 731.5 146 L 731.5 145 Z "
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 151 L 58.5 153 L 59.5 151 Z "
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1252.5 153 L 1251.5 155 L 1252.5 153 Z "
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1185.5 155 L 1184.5 157 L 1185.5 155 Z "
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 156 L 54.5 158 L 55.5 156 Z "
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 156 L 351.5 158 L 350.5 156 Z "
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1248.5 158 L 1247.5 160 L 1248.5 158 Z "
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 159 L 52.5 161 L 53.5 159 Z "
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1181.5 160 L 1180.5 162 L 1181.5 160 Z "
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1244.5 163 L 1243.5 165 L 1244.5 163 Z "
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1176.5 166 L 1175.5 168 L 1176.5 166 Z "
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1239.5 169 L 1238.5 171 L 1239.5 169 Z "
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1172.5 171 L 1171.5 173 L 1172.5 171 Z "
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 174 L 198.5 176 L 197.5 174 Z "
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 177 L 183.5 177 L 184.5 178 L 186.5 178 L 193.5 178 Q 197.1 181.4 204 181.5 L 110.5 182 L 101 187 L 98 191.5 L 97.5 195 L 97 190.5 Q 98.8 183.3 104.5 180 L 109.5 178 L 119.5 178 L 120.5 177 Z "
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1231.5 179 L 1229.5 182 L 1231.5 179 Z "
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1227.5 184 L 1226.5 186 L 1227.5 184 Z "
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 190 L 365 192.5 L 364 192.5 L 364.5 190 Z "
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 196 L 97 216.5 L 96 216.5 L 96.5 196 Z "
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 204 L 365 208.5 L 364 208.5 L 364.5 204 Z "
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 208 L 306.5 210 L 307.5 208 Z "
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 363.5 212 L 364 214.5 L 363 214.5 L 363.5 212 Z "
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 301.5 214 L 300.5 216 L 301.5 214 Z "
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 216 L 363 218.5 L 362 218.5 L 362.5 216 Z "
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 217 L 295 217.5 L 223.5 218 L 223.5 217 Z "
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 223 L 361 224.5 Q 353.4 243.9 338.5 256 L 319.5 268 L 297.5 273 L 184.5 273 L 183.5 272 L 97 272 Q 98 275 95 274 L 97.5 269 L 99.5 268 L 187.5 268 L 188.5 269 L 218.5 269 L 219.5 268 L 302.5 268 Q 303.8 265.8 308.5 267 Q 332.8 260.3 347 243.5 Q 355.7 235.2 360.5 223 Z "
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 277 L 97 357.5 L 96 357.5 L 96.5 277 Z "
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 359 L 93.5 359 L 94.5 360 L 96 359.5 L 95.5 363 L 42 363 Q 40.5 359.2 43.5 360 L 44.5 359 Z "
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(125,139,165)",
    stroke: "rgb(125,139,165)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 431.5 383 L 434 384.5 L 431 385 L 431.5 383 Z "
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 87 L 256 87.5 L 252.5 88 L 252.5 87 Z "
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 323.5 87 L 326 87.5 L 323.5 88 L 323.5 87 Z "
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 91 L 240.5 95 L 243.5 91 Z "
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 96 L 239 97.5 L 238.5 100 L 238 97.5 L 239.5 96 Z "
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 134 Q 194.3 145.3 203 153.5 L 196 147.5 L 188.5 134 Z "
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 155 L 204.5 157 L 203.5 155 Z "
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 160 L 211.5 163 L 209.5 160 Z "
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 164 L 215.5 166 L 214.5 164 Z "
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 166 L 218.5 168 L 217.5 166 Z "
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 176 L 244 176.5 L 241.5 177 L 241.5 176 Z "
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 177 L 120 177.5 L 111.5 178 L 111.5 177 Z "
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 177 L 192 177.5 L 186.5 178 L 186.5 177 Z "
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 177 L 291 177.5 L 248.5 178 L 248.5 177 Z "
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 181 L 99 185.5 L 96.5 193 L 96 189.5 L 102.5 181 Z "
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 181 L 307.5 186 L 303.5 181 Z "
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 189 L 310 193.5 L 309 193.5 L 309.5 189 Z "
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 196 L 365 203.5 L 364 203.5 L 364.5 196 Z "
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 224 L 359 225.5 Q 352.1 240.1 340.5 250 L 346 243.5 L 359.5 224 Z "
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 519.5 250 L 520.5 251 L 559.5 251 L 560.5 252 L 563.5 250 L 563.5 251 Q 561.3 250.3 562 252.5 L 563 254.5 L 562 254.5 Q 562.8 252.3 560.5 253 L 559.5 252 L 520.5 252 L 519 252.5 L 519.5 250 Z "
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 626.5 250 L 630 251.5 L 627 253.5 L 628.5 254 L 630.5 253 L 631.5 255 L 629.5 254 L 627.5 255 L 625.5 254 Q 623.5 258 621.5 254 L 620 253.5 L 621.5 253 Q 623 255.5 624.5 252 L 628 251.5 L 626.5 250 Z "
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 707.5 250 L 708 252 L 706 251.5 L 707.5 250 Z "
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 732.5 250 L 733.5 252 Q 730.7 252.7 732.5 250 Z "
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 786 250 Q 791.2 247.9 790 252.5 L 788.5 256 L 788 252.5 L 788.5 251 Q 786.3 250.3 787 252.5 L 786 252.5 L 786 250 Z "
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 791.5 250 L 792.5 251 L 808 251.5 L 792.5 252 L 791.5 250 Z "
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 812.5 250 L 813.5 252 Q 810.7 252.7 812.5 250 Z "
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 858.5 250 L 857.5 252 L 858.5 250 Z "
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 862.5 250 L 864.5 251 L 888 251.5 L 864.5 252 L 863.5 253 L 863.5 251 L 862.5 250 Z "
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 986.5 250 L 988 250.5 L 986 251 L 987 254.5 L 986 254.5 Q 986.8 252.3 984.5 253 L 983.5 252 L 896 251.5 L 983.5 251 Q 985 253.5 986.5 250 Z "
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 998.5 250 L 999.5 252 L 1000.5 251 L 1023.5 251 L 1024.5 250 L 1024.5 252 Q 1026.8 251.3 1026 253.5 L 1027 255.5 L 1025 254.5 L 1023.5 252 L 1000.5 252 L 997.5 253 L 998 251.5 L 998.5 250 Z "
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1074.5 250 L 1097 251.5 L 1076.5 253 L 1076.5 252 L 1080 251.5 L 1074.5 251 L 1074.5 250 Z "
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1099.5 250 L 1102 250.5 L 1099.5 251 L 1099.5 250 Z "
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1183.5 250 L 1184.5 251 L 1208 251.5 L 1184.5 252 L 1183.5 250 Z "
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1210.5 250 L 1213 250.5 L 1210.5 251 L 1210.5 250 Z "
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1290.5 250 L 1293.5 251 L 1295.5 250 L 1296.5 251 L 1336 251.5 L 1296.5 252 L 1294.5 251 L 1292.5 252 L 1290.5 250 Z "
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1337.5 250 L 1340 250.5 L 1337.5 251 L 1337.5 250 Z "
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 516.5 251 L 518 251.5 Q 516.3 253.8 511.5 253 L 509.5 255 L 505.5 255 L 505.5 254 L 516.5 251 Z "
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 632.5 251 L 656 251.5 L 632.5 252 L 632.5 251 Z "
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 661.5 251 L 664.5 252 L 666.5 252 L 668 252.5 L 662.5 254 L 662.5 253 L 664 252.5 Q 660.7 252.6 661.5 251 Z "
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 712.5 251 L 728 251.5 L 712.5 252 L 712.5 251 Z "
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1106.5 251 L 1105.5 253 L 1102.5 254 L 1102.5 253 L 1106.5 251 Z "
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1108.5 251 Q 1111.5 252.5 1108.5 254 L 1105.5 255 L 1105.5 254 L 1109 252.5 L 1108.5 251 Z "
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1215.5 251 L 1216.5 253 L 1215.5 251 Z "
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 252 L 335.5 254 L 336.5 252 Z "
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 861.5 252 L 862 254.5 L 860 256.5 L 860 335.5 L 858.5 341 L 858 336.5 L 859 335.5 L 859 256.5 L 861.5 252 Z "
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1068.5 252 L 1071 252.5 L 1068.5 253 L 1068.5 252 Z "
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1289 252 L 1291 252.5 L 1288 254.5 L 1289 252 Z "
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 517.5 253 L 518 255 L 514.5 256 L 512 254.5 L 513.5 254 L 515.5 254 L 517.5 253 Z "
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 709.5 253 L 712 253.5 L 709.5 254 L 709.5 253 Z "
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 728.5 253 L 731 253.5 L 728.5 254 L 728.5 253 Z "
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 808.5 253 L 811 253.5 L 808.5 254 L 808.5 253 Z "
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1059.5 253 L 1061.5 254 L 1063 253.5 L 1062.5 256 L 1059.5 254 L 1058 254.5 L 1059.5 253 Z "
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1114.5 253 L 1114 254.5 L 1113.5 256 L 1113 254.5 L 1114.5 253 Z "
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1173.5 253 L 1178 254.5 L 1175.5 255 L 1173.5 254 L 1173.5 256 L 1171 254.5 L 1173.5 253 Z "
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1179.5 253 L 1182 254.5 L 1180.5 255 L 1179.5 253 Z "
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1220.5 253 L 1224.5 254 L 1226 253.5 L 1221.5 256 L 1221.5 254 L 1217.5 255 L 1217.5 254 L 1220.5 253 Z "
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1293.5 253 L 1295 253.5 L 1291.5 255 L 1291.5 254 L 1293.5 253 Z "
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 615.5 254 L 617 254.5 L 614.5 256 L 615.5 254 Z "
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 618.5 254 L 621 255.5 L 619.5 256 L 618.5 254 Z "
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1210.5 254 L 1214 254.5 L 1210.5 255 L 1210.5 254 Z "
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1227.5 254 L 1228.5 256 L 1226 255.5 L 1227.5 254 Z "
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1279.5 254 L 1281 254.5 L 1278.5 256 L 1279.5 254 Z "
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1337.5 254 L 1338.5 256 L 1337.5 254 Z "
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 332.5 255 L 331.5 257 L 332.5 255 Z "
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 673.5 255 L 672.5 257 L 673.5 255 Z "
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1096.5 255 L 1099 255.5 L 1096.5 256 L 1096.5 255 Z "
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 677.5 256 L 681 258 L 683.5 262 L 685 261.5 L 680.5 264 L 678 262.5 L 680 261.5 L 679.5 259 Q 677.3 259.8 678 257.5 L 677.5 256 Z "
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1165.5 256 L 1168 256.5 L 1167.5 259 L 1165.5 256 Z "
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 500 257 L 502 257.5 L 502 259.5 L 499.5 262 Q 497.8 258.9 496 260.5 L 499 258.5 Q 496.8 259.8 499.5 261 Q 502.3 259.8 500 258.5 L 500 257 Z "
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 610.5 257 L 609 259.5 L 607.5 263 L 606.5 261 Q 608.8 261.8 608 259.5 L 610.5 257 Z "
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 613.5 257 L 616 258.5 L 614.5 258 L 612 259.5 L 615.5 264 L 613.5 264 L 611.5 263 L 610 263.5 L 611 261.5 L 610 260.5 L 613.5 257 Z M 613 261 Q 611 264 614 263 L 613 261 Z "
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 674.5 257 Q 676.8 256.3 676 258.5 L 674.5 257 Z "
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1055.5 257 L 1056 258.5 L 1055 261 L 1052.5 260 L 1051 260.5 L 1052.5 258 L 1053.5 260 L 1055.5 257 Z "
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1229.5 257 L 1233 258.5 L 1229 259 L 1229.5 257 Z "
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 258 L 326.5 260 L 327.5 258 Z "
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 672.5 258 L 673.5 260 L 672.5 258 Z "
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1121.5 258 L 1123.5 261 L 1125 260.5 Q 1121.9 262.3 1123.5 264 L 1120 262.5 L 1122 259.5 L 1121.5 258 Z "
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1276.5 258 L 1278.5 258 Q 1280.8 257.3 1280 259.5 Q 1278 257.8 1276 261.5 L 1276.5 263 Q 1278.3 259.3 1280 262.5 L 1278.5 264 L 1275 262.5 Q 1275.8 260.3 1273.5 261 L 1272.5 264 Q 1270.3 263.3 1271 265.5 Q 1273.3 266.8 1270.5 268 L 1269 268.5 L 1272 270.5 Q 1270.3 268.9 1268.5 272 L 1265 269.5 L 1268 265.5 L 1267.5 264 L 1269 267 L 1271 266.5 L 1269 262.5 L 1273 260.5 L 1272.5 259 L 1275 259.5 L 1275.5 261 L 1276.5 258 Z M 1269 269 L 1267 271 L 1269 271 L 1269 269 Z "
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1164.5 259 Q 1166.8 258.3 1166 260.5 L 1168 260.5 L 1166.5 263 L 1164.5 259 Z "
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 503.5 260 L 503.5 263 Q 502 260.5 500.5 264 L 499 263.5 L 503.5 260 Z "
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 676.5 260 L 677 262 L 672.5 264 L 673.5 262 L 676.5 260 Z "
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1233.5 260 L 1234.5 262 L 1233.5 260 Z "
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 261 L 788 263.5 L 787 263.5 L 787.5 261 Z "
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1048.5 261 L 1051.5 263 Q 1052.8 260.8 1054 263.5 L 1051.5 264 L 1049.5 263 L 1047 264.5 L 1048.5 261 Z "
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1162.5 262 L 1165 263.5 L 1163.5 263 L 1162.5 262 Z "
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1236.5 262 L 1239 263.5 L 1237.5 264 L 1235 263.5 L 1236.5 262 Z "
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 492.5 264 L 493 266.5 L 492.5 268 L 491 265.5 L 492.5 264 Z "
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 685.5 264 L 688.5 268 L 686 267 L 685.5 264 Z "
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1045.5 264 L 1045 265.5 L 1044 268.5 L 1047 269.5 L 1046.5 272 L 1043 267.5 L 1045.5 264 Z "
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1157.5 264 L 1160 265 L 1159.5 267 L 1157.5 264 Z "
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 494.5 265 Q 497.5 266.5 494.5 268 L 494.5 265 Z "
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 602.5 265 L 604.5 266 L 606.5 265 L 606.5 266 L 604 267.5 L 607 269.5 L 606 267.5 L 608 268.5 L 607 270.5 L 607.5 272 L 605.5 271 L 602.5 272 L 601 271.5 L 603 271 L 602 267.5 L 602.5 265 Z "
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1155.5 265 L 1157.5 268 Q 1156.3 265.8 1155 268.5 L 1155.5 270 L 1154 269.5 L 1153.5 271 L 1153 269.5 Q 1157.2 267.2 1155.5 265 Z "
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 683.5 266 L 685.5 269 L 683 267.5 L 683.5 266 Z "
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1240.5 266 L 1242.5 269 L 1241 268.5 L 1240.5 270 L 1240 268.5 L 1240.5 266 Z "
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 267 L 179 267.5 L 176.5 268 L 176.5 267 Z "
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 299.5 267 L 303 267.5 L 299.5 268 L 299.5 267 Z "
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 268 L 219 268.5 L 188.5 269 L 188.5 268 Z "
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 490.5 268 L 493 271.5 L 492 271.5 L 490.5 268 Z "
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 681.5 268 L 682 270 Q 684.7 268.9 684 271.5 L 681 269.5 L 681.5 268 Z "
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1130.5 268 L 1132 268.5 L 1129 270.5 L 1131.5 271 Q 1132.8 268.8 1134 271.5 Q 1134.8 273.8 1132.5 273 L 1131 272.5 L 1130.5 274 L 1128 270.5 L 1130.5 268 Z "
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 600.5 269 L 599.5 271 L 600.5 269 Z "
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 269 L 788 271.5 L 787 271.5 L 787.5 269 Z "
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1041.5 269 L 1043.5 272 L 1041.5 272 L 1040 271.5 L 1042 270.5 L 1041.5 269 Z "
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1157.5 269 L 1159 271.5 L 1157 270.5 L 1157.5 269 Z "
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 690.5 270 L 692 272.5 L 690 273.5 L 691 271.5 L 690.5 270 Z "
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1242.5 270 L 1245 271 L 1243 275.5 L 1246 274.5 L 1243 278.5 L 1243.5 280 L 1240 274.5 L 1241 274.5 L 1241.5 276 L 1244 272.5 L 1242.5 270 Z "
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1262.5 272 L 1264 274.5 Q 1260.5 276 1263 277.5 L 1264 281.5 L 1262 280.5 L 1261 276.5 L 1263 273.5 L 1262.5 272 Z "
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 486.5 274 Q 489.2 275.3 487 276.5 L 488 278.5 L 486 278.5 L 488 282.5 L 487 282.5 L 486.5 281 L 485 281.5 L 485 279.5 L 486 277.5 L 485.5 276 L 487 275.5 L 486.5 274 Z "
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 598.5 274 Q 601.3 275.3 599 276.5 L 600 278.5 L 599 280.5 L 600 282.5 L 599 282.5 L 596 277.5 L 598 277.5 L 599 275.5 L 598.5 274 Z "
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1039.5 274 L 1039.5 277 Q 1036.5 275.5 1039.5 274 Z "
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1150.5 274 Q 1152.8 273.3 1152 275.5 L 1150.5 278 L 1149.5 276 L 1151 275.5 L 1150.5 274 Z "
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1129.5 275 L 1131 277.5 L 1130 277.5 L 1129.5 275 Z "
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1132.5 275 Q 1135.3 276.3 1133 277.5 Q 1132.3 279.8 1134.5 279 L 1134.5 280 L 1132.5 279 L 1131 279.5 L 1133 276.5 L 1132.5 275 Z "
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 693.5 276 L 690.5 280 L 688 279.5 Q 689.3 276.8 690.5 279 L 693.5 276 Z "
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 277 L 788 279.5 L 787 279.5 L 787.5 277 Z "
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1245.5 277 L 1247 279.5 L 1246 279.5 L 1245.5 277 Z "
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1037.5 278 Q 1040.9 277.1 1039 282.5 L 1038 282.5 L 1037.5 278 Z "
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 595.5 279 Q 598.5 280.5 595.5 282 L 595.5 279 Z "
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1148 279 L 1151 280.5 L 1148 280.5 L 1148 279 Z "
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 516.5 280 L 517 282.5 L 515.5 284 L 513.5 281 L 516.5 280 Z "
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 661.5 280 L 665.5 280 L 668 281.5 Q 667.3 283.8 669.5 283 L 669.5 284 L 667.5 285 L 667 282.5 Q 667.8 280.3 665.5 281 L 663 282.5 L 663.5 284 L 661.5 280 Z "
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 669.5 280 L 672 281.5 L 671.5 283 L 669.5 280 Z "
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 954.5 280 L 955.5 282 L 954.5 280 Z "
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1068.5 280 L 1068.5 282 L 1070 282.5 L 1067.5 284 L 1067 281.5 L 1068.5 280 Z "
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1070.5 280 L 1073 280.5 L 1070.5 281 L 1070.5 280 Z "
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1106.5 280 L 1109 281.5 L 1109.5 280 L 1110 281.5 L 1110 283.5 L 1111 285.5 Q 1108.5 287 1112 288.5 L 1111.5 290 L 1110.5 288 L 1108 289 L 1109 286.5 L 1107.5 284 L 1109 284.5 L 1106.5 280 Z "
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1177.5 280 L 1179.5 280 L 1181 280.5 L 1178.5 282 L 1176 281.5 L 1177.5 280 Z "
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1259.5 280 L 1262 282.5 L 1260 284.5 L 1261.5 287 L 1258 284.5 L 1261 282.5 L 1259.5 280 Z "
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 693.5 281 L 696 282.5 L 693 283 L 693.5 281 Z "
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1214.5 281 L 1218 283.5 L 1217.5 285 L 1217 283 L 1214.5 281 Z "
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1221.5 281 L 1224 284.5 L 1222 283.5 L 1221.5 281 Z "
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1291.5 281 L 1289.5 284 L 1288.5 282 Q 1290 284.5 1291.5 281 Z "
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 624.5 282 L 626.5 282 L 628 282.5 L 625.5 284 L 624.5 282 Z "
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1065.5 282 Q 1063.9 283.8 1067 285.5 L 1065.5 289 L 1064 286.5 L 1066 286.5 L 1064 283.5 L 1065.5 282 Z "
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1149.5 282 L 1151 284.5 L 1150 286.5 L 1150.5 288 L 1147 283.5 L 1150 284.5 L 1149.5 282 Z "
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1180.5 282 L 1178.5 285 L 1177 285.5 L 1177 287.5 L 1176.5 289 L 1176 287.5 L 1176.5 283 L 1178.5 283 L 1180.5 282 Z "
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1219.5 282 L 1224 288.5 L 1222 289.5 L 1219.5 282 Z "
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 483.5 283 L 485 285.5 L 483 286.5 L 484 284.5 L 483.5 283 Z "
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 512.5 283 L 513.5 285 Q 510.7 285.7 512.5 283 Z "
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 665.5 283 L 666 285.5 L 665 285.5 L 665.5 283 Z "
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 955.5 283 L 956 285 L 954 284.5 L 955.5 283 Z "
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 957.5 283 L 958 285.5 L 957 285.5 L 957.5 283 Z "
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1036.5 283 L 1039 287.5 L 1037 286.5 L 1036.5 283 Z "
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 487.5 285 L 488 286.5 L 486 287.5 L 487.5 285 Z "
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 285 L 788 287.5 L 787 287.5 L 787.5 285 Z "
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1136.5 285 L 1138 287.5 L 1136 286.5 L 1136.5 285 Z "
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 668.5 286 L 671 287.5 L 669.5 287 L 668 287.5 L 669 290.5 L 667.5 293 L 667 291.5 L 668 288.5 L 666 288.5 L 668.5 286 Z "
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1258.5 286 L 1260 289 L 1258 288.5 L 1258.5 286 Z "
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1263.5 287 L 1263 288.5 L 1262.5 297 L 1262 288.5 L 1263.5 287 Z "
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1036 289 Q 1040 287.6 1038 294.5 L 1037 294.5 L 1036 289 Z "
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1110.5 291 L 1112 294.5 L 1110 295 L 1110.5 291 Z "
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 512.5 292 L 514 294.5 L 512 293.5 L 512.5 292 Z "
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 293 L 788 295.5 L 787 295.5 L 787.5 293 Z "
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1220.5 293 L 1221 295.5 L 1220 295.5 L 1220.5 293 Z "
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 486.5 294 L 488 296.5 L 486 295.5 L 486.5 294 Z "
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 666.5 294 L 668 296.5 L 668 344 L 670.5 345 L 672 344.5 L 671 346.5 L 672 348.5 L 669.5 352 L 670 350.5 Q 670.8 348.3 668.5 349 L 670 346.5 L 669.5 345 Q 667.8 348.8 666 345.5 L 668 344.5 L 667 343.5 L 667 296.5 L 666.5 294 Z "
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1110.5 296 L 1111 344.5 Q 1109.5 347.5 1108 344.5 L 1110 344.5 L 1110.5 296 Z "
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 485.5 297 L 486 298.5 L 484.5 301 L 484 299.5 L 485.5 297 Z "
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 512.5 297 L 515 297.5 L 512.5 298 L 512.5 297 Z "
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 512.5 299 L 514.5 300 L 516 299.5 L 515.5 301 Q 517.8 300.3 517 302.5 L 515 303.5 Q 517.3 302.3 514.5 301 L 513.5 303 L 512.5 301 L 514 300.5 L 512.5 299 Z "
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1259.5 299 L 1261 302.5 L 1259 301.5 L 1259.5 299 Z "
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1290.5 299 L 1293 300.5 L 1292.5 302 L 1294.5 301 L 1295.5 303 L 1293.5 303 L 1291.5 304 L 1291.5 302 L 1288 300.5 L 1290.5 299 Z "
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 486.5 301 L 485.5 303 L 486.5 301 Z "
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 301 L 788 303.5 L 787 303.5 L 787.5 301 Z "
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 522.5 302 L 525 302.5 L 522.5 303 L 522.5 302 Z "
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1299.5 302 L 1303 302.5 L 1298.5 304 L 1299.5 302 Z "
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1333.5 304 L 1335.5 307 L 1337 306.5 L 1336.5 309 L 1333 305.5 L 1333.5 304 Z "
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 487.5 305 L 488 306.5 L 486 307.5 L 487.5 305 Z "
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1263.5 305 L 1262.5 307 L 1261 306.5 L 1263.5 305 Z "
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 560.5 306 L 562.5 307 L 564 306.5 L 561.5 308 L 560.5 306 Z "
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1338.5 307 L 1341 307.5 L 1340.5 310 L 1338 309.5 L 1338.5 307 Z "
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 560.5 309 L 564 310.5 L 560.5 312 L 560.5 311 L 562 310.5 L 560.5 309 Z "
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 565.5 309 L 566.5 311 Q 563.7 311.7 565.5 309 Z "
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 309 L 788 311.5 L 787 311.5 L 787.5 309 Z "
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 568.5 310 L 569.5 312 L 568.5 310 Z "
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 493.5 312 L 496 315.5 L 493 315.5 L 493 313.5 L 493.5 312 Z "
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1267.5 312 L 1268.5 314 L 1269.5 312 L 1272 312.5 L 1272 316.5 L 1270.5 318 L 1269 316.5 L 1270.5 314 L 1268.5 315 L 1267.5 312 Z "
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 569.5 313 Q 572.3 314.3 571 319.5 L 570 319.5 L 569.5 314 L 568 314.5 L 569.5 313 Z "
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1265.5 314 L 1266.5 316 L 1265.5 314 Z "
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1345.5 314 L 1349 315 L 1348.5 317 L 1345.5 314 Z "
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 574.5 315 L 576 317.5 L 574.5 320 L 572 316.5 L 574 316.5 L 574.5 315 Z "
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 317 L 788 319.5 L 787 319.5 L 787.5 317 Z "
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1346.5 317 L 1345.5 319 L 1346.5 317 Z "
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1348.5 318 L 1347.5 320 L 1348.5 318 Z "
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1351.5 318 Q 1355.7 319.8 1353 321.5 L 1352.5 323 L 1352 321.5 Q 1354.3 320.3 1351.5 319 L 1350 319.5 L 1351.5 318 Z "
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 497.5 320 L 499.5 322 L 502 320.5 L 501.5 323 L 500 322.5 Q 499.3 324.8 501.5 324 L 504.5 325 Q 506.8 324.3 506 326.5 L 506.5 328 L 503.5 325 L 501.5 325 L 498 322.5 L 497.5 320 Z "
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 578.5 320 L 577.5 322 L 578.5 320 Z "
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1278.5 320 L 1278 321.5 L 1275.5 325 L 1274.5 323 Q 1275.7 325.3 1277 322.5 L 1276.5 321 L 1278.5 320 Z "
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 503.5 321 L 504.5 323 L 503.5 321 Z "
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 508.5 321 L 511 322.5 L 510.5 324 L 510 322 L 508.5 321 Z "
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 576.5 324 L 577.5 326 L 580 324.5 L 578.5 327 Q 580.8 326.3 580 328.5 L 576 327.5 L 576 325.5 L 576.5 324 Z "
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1355.5 324 L 1357 326.5 L 1354 327.5 L 1354 329.5 L 1355 332.5 L 1354 334.5 L 1354.5 336 L 1352 335.5 L 1354 331.5 L 1352 331.5 L 1354 328.5 Q 1351.5 327 1355 325.5 L 1355.5 324 Z "
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 325 L 788 327.5 L 787 327.5 L 787.5 325 Z "
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 581.5 326 L 583.5 331 Q 581.3 331.8 582 329.5 L 581.5 326 Z "
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 509.5 327 L 508.5 329 L 509.5 327 Z "
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 511.5 328 L 510.5 330 L 511.5 328 Z "
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 544.5 328 L 547 329.5 L 544.5 331 L 544.5 328 Z "
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 549.5 328 L 550 330 L 552 330.5 L 552 332.5 L 551.5 334 L 550.5 332 L 549 332.5 L 550 330.5 L 549.5 328 Z "
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1324.5 328 L 1325 330 L 1322.5 331 L 1324.5 328 Z "
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1357.5 328 L 1357 329.5 L 1356.5 331 L 1356 329.5 L 1357.5 328 Z "
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 577.5 329 L 578 331.5 L 577 331.5 L 577.5 329 Z "
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1325.5 331 L 1328 331.5 L 1327 334 L 1325 333.5 L 1325.5 331 Z "
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 333 L 788 335.5 L 787 335.5 L 787.5 333 Z "
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 554 336 L 556 336.5 L 554 337.5 L 554 336 Z "
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1330.5 336 L 1331 338.5 L 1330 338.5 L 1330.5 336 Z "
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1332.5 339 Q 1334.8 338.3 1334 340.5 L 1332.5 339 Z "
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 341 L 789 344.5 L 787 343.5 L 787.5 341 Z "
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1330 341 L 1332 341.5 L 1330 342.5 L 1330 341 Z "
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1335.5 342 L 1336 344.5 L 1335 344.5 L 1335.5 342 Z "
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 557.5 343 L 559 345.5 L 558 345.5 L 557.5 343 Z "
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 595.5 344 L 598 345.5 L 597 348 L 594 346.5 L 595.5 344 Z "
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 813.5 344 L 816 347.5 L 813 345.5 L 813.5 344 Z "
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 858.5 344 Q 860.8 343.3 860 345.5 L 858.5 344 Z "
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 707.5 345 L 708 346.5 L 705 348.5 L 707.5 345 Z "
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 786.5 345 L 787.5 347 Q 785.3 346.3 786 348.5 L 788 353 L 790 352.5 L 789 350.5 L 790 350.5 L 790.5 352 L 791.5 350 L 792 351.5 L 790 354.5 L 793 362 L 795 362.5 Q 792.8 363.8 795.5 365 L 798 366.5 L 796.5 366 L 793.5 367 L 794 365.5 Q 794.8 363.3 792.5 364 L 792.5 362 L 790 360.5 L 791 358.5 L 788 357.5 L 790 357 Q 791.1 354.3 788.5 355 L 787 355.5 L 788 353.5 L 786 353.5 L 787 351.5 L 785 347.5 L 786.5 345 Z "
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1064.5 345 L 1066.5 348 L 1064.5 345 Z "
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1330.5 345 Q 1333.8 343.9 1333 346.5 L 1334 348.5 Q 1332.5 351.5 1331 348.5 L 1330.5 345 Z "
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 789.5 346 L 791 348.5 L 789 347.5 L 789.5 346 Z "
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1137.5 346 L 1136.5 348 L 1137.5 346 Z "
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 598.5 347 L 599 349.5 L 598 349.5 L 598.5 347 Z "
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1107.5 347 L 1110 348.5 L 1108.5 348 L 1107.5 347 Z "
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 625.5 348 L 628 350.5 L 627.5 353 Q 625.3 353.8 626 351.5 Q 622.3 349.8 625.5 348 Z "
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 665.5 348 L 667 348.5 L 664.5 350 L 665.5 348 Z "
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1064.5 348 L 1067 349.5 L 1065.5 350 L 1064.5 348 Z "
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1111.5 348 L 1112 349.5 L 1111.5 352 L 1108 350.5 L 1111 349.5 L 1111.5 348 Z "
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 736.5 349 L 738 350.5 L 737.5 353 L 736 351.5 L 736.5 349 Z "
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1105.5 349 L 1105.5 352 Q 1102.5 350.5 1105.5 349 Z "
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1328.5 349 L 1330 349.5 L 1328 350.5 L 1328.5 352 Q 1325.5 350.5 1328.5 349 Z "
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 554.5 350 L 557 351.5 L 555.5 352 L 553 351.5 L 554.5 350 Z "
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 558.5 350 L 559.5 352 L 558.5 350 Z "
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 662.5 350 L 665 351.5 L 663.5 352 L 662 351.5 L 661.5 353 L 661 351.5 L 662.5 350 Z "
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 550.5 351 L 548.5 354 L 547 353.5 L 550.5 351 Z "
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 709.5 351 L 712 352.5 L 709.5 357 L 709 355.5 L 711 352.5 L 709.5 352 L 707.5 355 L 706 352.5 Q 707.8 354.1 709.5 351 Z "
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 818.5 351 L 817.5 353 L 818.5 351 Z "
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 577.5 352 L 578.5 354 L 577.5 352 Z "
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 581.5 352 L 582.5 354 L 581.5 352 Z "
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 596.5 352 L 599 353.5 L 598.5 355 L 597.5 353 Q 594 355 598.5 357 L 600 356.5 L 598.5 360 L 595 353.5 L 596.5 352 Z "
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 629.5 352 Q 631.2 355.1 633 353.5 L 632.5 356 L 630 355 L 629.5 352 Z "
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 691.5 352 L 692.5 355 L 694.5 352 L 695 353.5 Q 691.5 355 694 356.5 L 693.5 358 L 691 354.5 L 691.5 352 Z "
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 851.5 352 L 849.5 355 L 848 354.5 L 851.5 352 Z "
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 885.5 352 L 886 354.5 L 885 354.5 L 885.5 352 Z "
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1037.5 352 L 1038.5 354 L 1037.5 352 Z "
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1134.5 352 L 1135.5 354 L 1137 353.5 Q 1135.5 356.5 1134 353.5 L 1134.5 352 Z "
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 484.5 353 Q 487.8 351.9 487 354.5 L 487.5 356 L 484.5 354 L 483 354.5 L 484.5 353 Z "
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 636 353 L 638 353.5 L 636 354.5 L 636 353 Z "
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 656.5 353 L 660 353.5 L 656.5 354 L 656.5 353 Z "
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1076.5 353 L 1080 353.5 L 1076 354.5 L 1080 355.5 L 1076.5 357 L 1075 354.5 L 1076.5 353 Z "
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1096.5 353 L 1101 355.5 L 1100.5 360 L 1099.5 355 L 1098.5 358 L 1098 354 L 1096.5 353 Z "
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1101.5 353 L 1104 354.5 L 1102.5 355 L 1101.5 353 Z "
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1259.5 353 L 1258.5 355 L 1259.5 353 Z "
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 627.5 354 L 629.5 357 L 627 355.5 L 627.5 354 Z "
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 661.5 354 L 664 354.5 L 659.5 356 L 659.5 355 L 661.5 354 Z "
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1130.5 354 L 1134 355.5 L 1132.5 357 L 1130.5 354 Z "
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1261.5 354 L 1262 356 L 1260 355.5 L 1261.5 354 Z "
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1324.5 354 L 1327 354.5 L 1324.5 355 L 1324.5 354 Z "
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1352.5 354 L 1354.5 354 Q 1357.8 352.9 1357 355.5 L 1358 357.5 L 1356.5 360 L 1356 358.5 L 1357 356.5 L 1354 355 L 1353.5 358 L 1352.5 354 Z "
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 355 L 548 355.5 L 545.5 356 L 545.5 355 Z "
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 581.5 355 L 583 357.5 L 582 357.5 L 581.5 355 Z "
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 739.5 355 L 744 356.5 L 740.5 357 L 739.5 355 Z "
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 819.5 355 L 824 356.5 L 820.5 357 L 819.5 355 Z "
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 882.5 355 L 884.5 358 L 882 359.5 L 882.5 361 L 884 360.5 L 882.5 362 L 880 361.5 L 883 356.5 L 882.5 355 Z "
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1039.5 355 L 1039 356.5 L 1038.5 358 L 1038 356.5 L 1039.5 355 Z "
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 577.5 356 L 578.5 358 Q 580.2 355.3 582 359.5 L 580 360 L 579.5 358 L 578 361.5 L 578 363.5 Q 579.1 366.8 576.5 366 L 577 364.5 L 576 362.5 L 578 358.5 L 577.5 356 Z "
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 625.5 356 L 626 358 Q 628.7 356.9 628 359.5 L 625 357.5 L 625.5 356 Z "
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 690.5 356 L 692 358.5 L 689.5 360 L 688 357.5 L 689 357.5 L 689.5 359 L 690.5 356 Z "
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1135.5 356 L 1135 357.5 L 1134.5 359 L 1134 357.5 L 1135.5 356 Z "
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 737.5 357 L 741 358.5 L 738.5 359 L 737.5 357 Z "
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 817.5 357 L 821 358.5 L 818.5 359 L 817.5 357 Z "
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1129.5 357 L 1131 359.5 L 1129.5 362 L 1128 359.5 L 1130 359.5 L 1129.5 357 Z "
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1261 357 Q 1263.7 355.9 1263 358.5 L 1263.5 360 L 1261 359 L 1261 357 Z "
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 358 L 93.5 358 L 95 359.5 L 93.5 359 L 44.5 359 L 42.5 360 L 42.5 359 L 44.5 358 Z "
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 710.5 358 L 709.5 360 L 710.5 358 Z "
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 848.5 358 L 853 359.5 L 850.5 360 L 848.5 358 Z "
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1073.5 358 L 1076 358.5 L 1073.5 359 L 1073.5 358 Z "
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1325.5 358 L 1328 358.5 L 1325.5 359 L 1325.5 358 Z "
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1132.5 359 L 1134 360.5 Q 1128.6 363.3 1130.5 366 L 1128 365.5 L 1129 363 L 1133 360.5 L 1132.5 359 Z "
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1354.5 359 L 1355 361.5 L 1353.5 363 L 1352 362.5 L 1354 361.5 Q 1351.7 360.3 1354.5 359 Z "
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 601.5 360 L 599.5 363 L 601.5 360 Z "
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 604.5 360 L 607 360.5 L 608 362.5 L 604 365.5 L 606.5 362 L 604.5 360 Z "
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 718.5 360 L 719.5 362 L 718.5 360 Z "
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 794.5 360 L 797 361.5 L 796.5 364 L 796 361 L 794.5 360 Z "
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1042.5 360 L 1044.5 360 L 1047 361.5 L 1045.5 361 Q 1042.9 360.3 1044 363 L 1047 364.5 L 1045.5 364 L 1044 364.5 L 1046.5 369 L 1047.5 367 L 1048 369 L 1051.5 368 L 1053.5 370 L 1056 368.5 L 1053.5 371 L 1052.5 370 L 1050.5 372 L 1048 371.5 Q 1050.3 370.2 1047.5 369 L 1046.5 370 L 1043 366.5 L 1044 365.5 L 1040.5 361 L 1043 362.5 L 1042.5 360 Z M 1050 369 L 1050 371 L 1052 370 L 1050 369 Z "
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 709.5 361 L 712 361.5 L 713 363.5 L 711.5 363 L 709.5 361 Z "
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 603.5 362 L 603 363.5 L 601.5 366 L 600.5 364 L 602 364.5 L 603.5 362 Z "
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 715.5 362 Q 718.8 360.9 718 363.5 L 719 367.5 L 718 367.5 Q 718.8 363.8 716.5 363 L 715.5 362 Z "
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1353.5 364 L 1353 365.5 L 1352.5 367 L 1352 365.5 L 1353.5 364 Z "
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 607.5 365 L 606 367.5 L 607.5 369 L 609 368.5 L 611 371.5 L 608.5 370 L 606.5 369 Q 604.7 371.8 603 367.5 Q 605.2 369.2 607.5 365 Z "
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 712.5 365 Q 714.8 369.3 717 367.5 Q 716.3 370.1 719 369 L 719 371 L 717 371 Q 718.1 368.3 715.5 369 L 712.5 365 Z "
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 877 365 L 880 365.5 L 878 366 L 876.5 370 L 874 368.5 L 875.5 368 L 877 368.5 L 877 365 Z "
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 795.5 367 L 796.5 369 L 800 368.5 L 799 369.5 L 802.5 376 L 797.5 369 Q 796.3 371.3 795 368.5 L 795.5 367 Z "
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 610.5 368 L 611.5 370 L 610.5 368 Z "
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 615.5 368 L 614.5 370 L 615.5 368 Z "
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 680.5 368 L 681 370 L 685.5 368 L 684.5 370 L 683 370.5 L 683.5 372 L 681.5 371 L 682 372.5 L 680.5 375 L 681 373.5 L 680 371.5 L 680 369.5 L 680.5 368 Z "
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 725.5 368 L 728 369.5 L 726.5 369 L 725.5 368 Z "
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1125.5 368 L 1125 369.5 L 1126 371.5 L 1124.5 371 L 1123 370.5 L 1125.5 368 Z "
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1347.5 368 L 1350 368.5 Q 1347.9 371.8 1347.5 368 Z "
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 568.5 369 L 570.5 370 L 572 369.5 L 569.5 371 L 568.5 369 Z "
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 724.5 370 Q 726.8 369.3 726 371.5 L 726.5 373 L 724.5 370 Z "
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 804.5 370 Q 806.8 369.3 806 371.5 L 808 371.5 L 805 373 L 804.5 375 L 802.5 372 L 805 373 L 804.5 370 Z "
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 874.5 370 L 875.5 372 L 874.5 370 Z "
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1346.5 370 L 1346 371.5 L 1344.5 374 L 1344.5 371 L 1346.5 370 Z "
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 612.5 371 Q 614.8 370.3 614 372.5 L 615.5 375 L 612.5 371 Z "
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 720.5 371 L 722 371.5 L 720 372.5 L 722.5 376 L 719 372.5 L 720.5 371 Z "
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1120.5 371 Q 1122.3 374.1 1124 372.5 L 1121.5 376 L 1122 374.5 L 1121.5 373 L 1120 373.5 L 1120.5 371 Z "
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 568.5 372 L 569.5 374 L 568.5 372 Z "
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 607.5 372 L 610 373.5 L 608.5 373 L 607.5 372 Z "
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1052.5 372 L 1054.5 373 L 1056 372.5 L 1055 375.5 L 1054.5 377 L 1053.5 375 L 1055 374.5 L 1052 374 L 1052.5 372 Z "
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 869 373 L 872 373.5 L 869.5 375 L 869 373 Z "
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 612.5 374 L 614 377.5 L 611 375.5 L 612.5 374 Z "
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 807.5 374 L 806.5 376 L 807.5 374 Z "
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 724.5 375 L 727 378.5 L 726 378.5 L 724.5 375 Z "
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 376 L 546 378.5 L 545 378.5 L 545.5 376 Z "
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 555.5 376 L 559 378.5 L 557.5 378 L 555.5 376 Z "
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 564.5 376 L 565 377.5 Q 563.8 380.3 562.5 378 L 560.5 379 L 561.5 377 L 563.5 378 L 564.5 376 Z "
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 615.5 376 L 618 376.5 L 615 378.5 L 615.5 376 Z "
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 674.5 376 L 676.5 376 L 678 376.5 L 674.5 379 L 674.5 376 Z "
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 868.5 376 L 867.5 378 L 865.5 379 L 866.5 377 L 868.5 376 Z "
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1057.5 376 L 1063.5 379 L 1063.5 377 Q 1066.5 378.5 1063.5 380 L 1060.5 379 L 1059 379.5 L 1059.5 378 L 1057.5 377 L 1056 377.5 L 1057.5 376 Z "
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1072.5 376 L 1070.5 379 L 1067 378.5 Q 1071.3 378.8 1072.5 376 Z "
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1098.5 376 L 1101.5 377 L 1103 376.5 L 1099.5 378 L 1098.5 376 Z "
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1113.5 376 L 1115.5 377 L 1118 376 L 1117.5 378 L 1115.5 378 L 1112.5 380 L 1113.5 376 Z "
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1330.5 376 L 1336 379.5 L 1333.5 378 L 1332 378.5 L 1333.5 381 Q 1329.8 379 1331.5 377 L 1329.5 378 L 1330.5 376 Z "
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1338.5 376 L 1339.5 378 L 1338.5 376 Z "
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 623.5 377 L 625 377.5 L 623 378.5 L 624.5 380 Q 626.3 376.3 628 379.5 L 625 380.5 L 628 381 L 627.5 383 L 623.5 380 L 622 380.5 L 623.5 377 Z "
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 663.5 377 L 664 379 L 666 378.5 L 665.5 377 L 669.5 379 L 672.5 377 L 672.5 378 L 668 380 Q 669.3 383 665.5 382 L 665.5 381 L 668 379.5 L 666.5 379 L 662.5 381 L 662.5 380 L 664 379.5 L 663.5 377 Z "
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 812.5 377 Q 814.8 376.3 814 378.5 L 811 380.5 Q 811.8 378.3 809.5 379 L 809.5 378 L 812.5 379 L 812.5 377 Z "
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1075 377 L 1077 377.5 L 1075 378.5 L 1075 377 Z "
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1327.5 377 L 1328 379 L 1330 379.5 L 1328 380.5 L 1328.5 382 L 1326 380.5 L 1328 379.5 L 1327.5 377 Z "
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 618 378 L 621 379.5 Q 621.8 381.8 619.5 381 L 618 378 Z "
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 729.5 378 L 731 378.5 L 728.5 380 L 729.5 378 Z "
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 733.5 378 L 738 380.5 L 736.5 381 L 735 380.5 L 734.5 382 Q 733 378.5 731.5 381 L 730 380.5 L 733.5 378 Z "
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 818.5 378 Q 821.5 379.5 818.5 381 L 814.5 382 L 814.5 381 L 816 380.5 L 815.5 379 L 818 380 L 818.5 378 Z "
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 554.5 379 L 559 380.5 L 556.5 382 L 556.5 380 Q 553.5 380.5 554.5 379 Z "
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 852.5 379 L 853 380.5 L 851.5 383 L 848 381.5 L 852 381 L 852.5 379 Z "
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1105 379 Q 1108 378 1107 381 L 1105 381.5 L 1105.5 383 L 1103.5 382 Q 1102.3 384.3 1101 381.5 L 1105 381 L 1105 379 Z "
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 544.5 380 L 547 380.5 L 544.5 381 L 544.5 380 Z "
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 854.5 380 L 856.5 381 L 858.5 380 L 858.5 381 L 855.5 382 L 854.5 380 Z "
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1068 380 L 1071 380.5 L 1069 381 L 1068.5 383 L 1068 380 Z "
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1109.5 380 L 1111 380.5 L 1108.5 382 L 1109.5 380 Z "
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 551.5 381 L 554 381.5 L 551.5 382 L 551.5 381 Z "
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 656.5 381 L 659 381.5 L 656.5 382 L 656.5 381 Z "
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 740 381 L 742 381.5 L 740 382.5 L 740 381 Z "
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1072.5 381 L 1075 381.5 L 1071.5 383 L 1072.5 381 Z "
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1320.5 381 L 1323 381.5 L 1320.5 382 L 1320.5 381 Z "
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,168,167)",
    stroke: "rgb(166,168,167)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1098 382 L 1100 382.5 L 1098 383.5 L 1098 382 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofamz);
export default __webpack_public_path__ + "static/media/logofamz.b36ba34ed88c35f49a773dcff2c55fa2.svg";
export { ForwardRef as ReactComponent };